import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as htmlToImage from 'html-to-image';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import ReactDOM from 'react-dom/client';
import jsPDF from 'jspdf';
import Papa from 'papaparse';
import Modal from './Modal';
import SiparisGirisFormu from './SiparisGirisFormu';
import ProformaPreview from './ProformaPreview';
import EtiketSablonu from './EtiketSablonu';
import EditIcon from './assets/images/edit-icon.svg';
import DeleteIcon from './assets/images/delete-icon.svg';
import RecycleBinIcon from './assets/images/recycle-bin-icon.svg';
import PlusIcon from './assets/images/plus-icon.svg';
import TickIcon from './assets/images/tick_icon.svg';
import CrossIcon from './assets/images/cross_icon.svg';
import CrossIconRed from './assets/images/cross_icon_red.svg';
import EyeIcon from './assets/images/eye.svg';
import EyeOffIcon from './assets/images/eye-off.svg';
import WhatsappIcon from './assets/images/whatsapp_icon.svg';
import TransferIcon from './assets/images/transfericon.svg';
import DownloadIcon from './assets/images/download_icon.svg';
import IslemlerIcon from './assets/images/islemler_icon.svg';
import PTTLogo from './assets/images/ptt_logo.svg';
import EldenTeslimIcon from './assets/images/eldenteslim.svg';
import ParasutLogo from './assets/images/parasut_logo.svg';
import CalendarIcon from './assets/images/calendar_icon.svg';
import PrintIcon from './assets/images/yazdir.svg';
import CheckIcon from './assets/images/kontrol.svg';
import UndoIcon from './assets/images/guncelle.svg';
import EkEtiketIcon from './assets/images/ek_etiket.svg';
import OnizlemeIcon from './assets/images/onizleme.svg';
import ResmilestirIcon from './assets/images/resmilestir.svg';
import * as pdfjsLib from 'pdfjs-dist';
import FaturaOnizleme, {
    faturaPdfAl, islemButonStili, islemIkonu, etiketDugumGorseli, pdfSayfaGorselleri, a5Yazdir,
    parasutResmilestir, taslakOnizlemeAc
} from './FaturaOnizleme';

// Ödeme Takibi'nde izlenen ödeme yöntemleri (E = EFT/Havale, D = Kurum Ödemesi). "Ödenmedi" görünen
// siparişin faturası resmileştirilmez (backend de ayrıca engeller).
const ODEME_TAKIBI_YONTEMLERI = ['E', 'D'];
// Alıcı ödemeli takip numarası oluşturmak için sorulan parola
const ALICI_ODEMELI_PAROLA = '1234';
// Toplu etiket iptali için sorulan parola
const ETIKET_IPTAL_PAROLA = '1234';

const odemeYapilmadi = (siparis) => ODEME_TAKIBI_YONTEMLERI.includes(siparis.odeme_yontemi) && siparis.odeme_durumu === 'Ödenmedi';

// API URL'i tanımlama
const baseURL = process.env.REACT_APP_API_URL;

function SiparisListesi() {
    // --- STATE VE REF TANIMLAMALARI ---
    const [siparisler, setSiparisler] = useState([]);
    // localStorage'dan son seçilen tarihi yükle, yoksa bugünün tarihini kullan
    const [seciliTarih, setSeciliTarih] = useState(() => {
        const savedDate = localStorage.getItem('siparisListesiTarih');
        return savedDate || new Date().toISOString().split('T')[0];
    });
    const [acikSiparisId, setAcikSiparisId] = useState(null);
    
    // Kullanıcı rolünü local storage'dan al
    const [userRole, setUserRole] = useState(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        return user ? user.rol : null;
    });
    const [detayData, setDetayData] = useState(null);
    const [proformaTel, setProformaTel] = useState('');
    const [numaraCheckbox, setNumaraCheckbox] = useState(false);
    const [alternatifTel, setAlternatifTel] = useState('');
    const [musteriNotu, setMusteriNotu] = useState('');
    const [notModalAcik, setNotModalAcik] = useState(false);
    const [kargoHareketleri, setKargoHareketleri] = useState([]);
    const [kargoSorguLoading, setKargoSorguLoading] = useState(false);
    // Faturalama bilgileri düzenleme (telefon, isim, adres, kimlik/vergi no)
    const [faturaDuzenlenen, setFaturaDuzenlenen] = useState(null); // null | 'ana' | ek sipariş id
    const [faturaForm, setFaturaForm] = useState(null);
    const [faturaKaydediliyor, setFaturaKaydediliyor] = useState(false);
    // Paraşüt taslak fatura kontrolü: { anahtar: 'ana' | ek id, durum: 'yukleniyor' | 'hazir' | 'guncelleniyor', sonuc }
    const [taslakKontrol, setTaslakKontrol] = useState(null);
    // Paraşüt'te kesilmiş faturayı bağlama: { anahtar: 'ana' | ek id, numara, bagliyor }
    const [faturaBagla, setFaturaBagla] = useState(null);
    const [faturaIptalEdiliyor, setFaturaIptalEdiliyor] = useState({}); // Fatura ID'lerine göre
    const [faturaDuzenleModalAcik, setFaturaDuzenleModalAcik] = useState(false);
    const [resmilestirLoading, setResmilestirLoading] = useState({}); // Fatura ID'lerine göre loading state
    const [faturaStatuslari, setFaturaStatuslari] = useState({}); // Fatura durumları için cache
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCsvModalOpen, setIsCsvModalOpen] = useState(false); // CSV upload modal için ayrı state
    const [editingSiparisId, setEditingSiparisId] = useState(null);
    // Ek Sipariş state'leri
    const [ekSiparisModalAcik, setEkSiparisModalAcik] = useState(false);
    const [ekSiparisAnaSiparisId, setEkSiparisAnaSiparisId] = useState(null);
    const [ekSiparisInitialData, setEkSiparisInitialData] = useState(null);
    const [ekSiparisEditId, setEkSiparisEditId] = useState(null); // Düzenleme modunda ek sipariş ID
    // Aktif proforma indeksi: 0 = ana sipariş, 1+ = ek-1, ek-2...
    const [activeProformaIndex, setActiveProformaIndex] = useState(0);
    // Tekrar gönderim: modaldaki sipariş ID'si ve görüntülenen Tekrar-N proformasının indeksi (null = gösterilmiyor)
    const [tekrarModalSiparisId, setTekrarModalSiparisId] = useState(null);
    const [activeTekrarIndex, setActiveTekrarIndex] = useState(null);
    const [seciliSiparisler, setSeciliSiparisler] = useState([]);
    const [topluResmilestirIlerleme, setTopluResmilestirIlerleme] = useState(null); // "3/10" gibi, işlem yokken null
    const [topluFaturaIlerleme, setTopluFaturaIlerleme] = useState(null); // "3/10" gibi, işlem yokken null
    // Üst bardaki açık açılır menü ('ptt' | 'parasut' | 'islemler' | 'indirmeler'); menü dışına tıklanınca kapanır
    const [acikMenu, setAcikMenu] = useState(null);
    const menuAlaniRef = useRef(null);
    useEffect(() => {
        if (!acikMenu) return;
        const kapat = (e) => {
            if (menuAlaniRef.current && !menuAlaniRef.current.contains(e.target)) setAcikMenu(null);
        };
        document.addEventListener('mousedown', kapat);
        return () => document.removeEventListener('mousedown', kapat);
    }, [acikMenu]);

    // Admin: satıra uzun basıp sürükleyerek listedeki gösterim sırasını değiştirir (sipariş no vb. değişmez).
    // Sürükleme sürerken sıra suruklemeSirasi'nda (id listesi) tutulur; siparisler bırakınca bir kez güncellenir.
    const [suruklenenId, setSuruklenenId] = useState(null);
    const [suruklemeSirasi, setSuruklemeSirasi] = useState(null);
    const suruklemeSirasiRef = useRef(null);
    suruklemeSirasiRef.current = suruklemeSirasi;
    const uzunBasmaRef = useRef(null); // { timer, x, y }
    const tiklamaEngelleRef = useRef(false); // sürükleme bitince satırın onClick'i detayı açmasın
    const siralamaGuncellemesiRef = useRef(false); // sadece sıra değiştiyse faturalar yeniden sorgulanmaz
    const listeKutusuRef = useRef(null);
    const [aramaTerimi, setAramaTerimi] = useState('');
    const [acilSiparisler, setAcilSiparisler] = useState([]); // Acil gönderilecek siparişlerin ID'lerini tutacak
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');
    const [orderCount, setOrderCount] = useState(0);
    const fileInputRef = useRef(null);
    const [vergiNoUyarilari, setVergiNoUyarilari] = useState([]); // Vergi No tespit edilen siparişler
    const [isVergiUyariModalOpen, setIsVergiUyariModalOpen] = useState(false); // Vergi No uyarı modalı
    const [aktifBarkod, setAktifBarkod] = useState(''); // Çoklu paket için aktif barkod
    // Barkodsuz siparişte takip numarası tipi: 'G' Standart Gönderi | 'A' Alıcı Ödemeli (parola ister)
    const [gonderiTipi, setGonderiTipi] = useState('G');
    const [aliciOdemeliParola, setAliciOdemeliParola] = useState(null); // null: modal kapalı, string: girilen parola
    const [etiketIptalParola, setEtiketIptalParola] = useState(null); // Etiket İptal parola modalı (null: kapalı)
    const [, setEtiketUyariTick] = useState(0); // "Barkod Güncellendi" uyarısı localStorage'da; değişince yeniden çiz
    const duzenlemeOncesiRef = useRef(null); // Düzenleme modalı açılmadan önceki etiket bilgileri
    
    // Tarih değiştirme modalı için state'ler
    const [tarihModalAcik, setTarihModalAcik] = useState(false);
    const [secilenTarih, setSecilenTarih] = useState(new Date().toISOString().split('T')[0]);
    const [tarihDegistirilecekSiparisId, setTarihDegistirilecekSiparisId] = useState(null);
    
    // Toplu tarih değiştirme modalı için state'ler
    const [topluTarihModalAcik, setTopluTarihModalAcik] = useState(false);
    const [topluSecilenTarih, setTopluSecilenTarih] = useState(new Date().toISOString().split('T')[0]);

    // Değişiklik Talebi (DT) state'leri
    // Teslimat talepleri (PTT'ye mail ile giden adres / ödeme / iade vb. talepler)
    const [talepForm, setTalepForm] = useState(null); // null: kapalı | { turler, detay, kaynak, notlar }
    const [talepKaydediliyor, setTalepKaydediliyor] = useState(false);
    const [talepIslemde, setTalepIslemde] = useState(null); // işlem süren talep id'si
    // İşyerinden elden teslim (kargo yerine müşteriye elden teslim)
    const [eldenTeslimForm, setEldenTeslimForm] = useState(null); // null: kapalı | { tarih, teslim_alan }
    const [eldenTeslimKaydediliyor, setEldenTeslimKaydediliyor] = useState(false);
    // Eski etiket (admin): hareketleri gösterilecek önceki barkod seçimi
    const [eskiEtiketForm, setEskiEtiketForm] = useState(null); // null: kapalı | { secili, elle }
    const [eskiEtiketKaydediliyor, setEskiEtiketKaydediliyor] = useState(false);

    // Teslim Evrakı modalı için state'ler
    const [teslimEvrakiModalAcik, setTeslimEvrakiModalAcik] = useState(false);
    const [teslimSecilenSiparisId, setTeslimSecilenSiparisId] = useState('');
    const [teslimGerekce, setTeslimGerekce] = useState('Beklemede'); // 'Beklemede' | 'Önceden Teslim Edildi' | 'Diğer'
    const [teslimDigerAciklama, setTeslimDigerAciklama] = useState('');
    const [teslimEdilmeyenler, setTeslimEdilmeyenler] = useState([]); // { siparisId, son4, adSoyad, gerekce }
    const [teslimPdfLoading, setTeslimPdfLoading] = useState(false);
    const teslimEvrakiRef = useRef(null);

    // Fatura Kontrolü (proforma - Paraşüt fatura denkliği) modalı için state'ler
    const [faturaKontrolModalAcik, setFaturaKontrolModalAcik] = useState(false);
    // { durum: 'yukleniyor' | 'hazir', islenen, toplam, kontrolEdilen, uyumsuzlar, hatalar }
    const [faturaKontrol, setFaturaKontrol] = useState(null);
    const [faturaKontrolPdfLoading, setFaturaKontrolPdfLoading] = useState(false);
    const faturaKontrolRef = useRef(null);

    // A5 çift taraflı baskı (ön yüz etiket, arka yüz e-fatura) ilerleme metni
    const [yazdirIlerleme, setYazdirIlerleme] = useState(null);
    const [efaturaIndirIlerleme, setEfaturaIndirIlerleme] = useState(null); // toplu e-fatura indirme: "3/10" gibi

    // Siparişleri backend'den çeken ana fonksiyon
    const fetchSiparisler = () => {
        if (!seciliTarih) return; // Tarih seçili değilse boşuna istek atma
        const url = `api/siparisler?tarih=${seciliTarih}`;
        
        fetch(url, { cache: 'no-cache' })
            .then(res => res.json())
            .then(data => setSiparisler(data))
            .catch(error => console.error('Siparişleri çekerken hata:', error));
    };

    // Seçili tarih değiştiğinde hem veriyi çek hem de localStorage'a kaydet
    useEffect(() => {
        fetchSiparisler();
        if (seciliTarih) {
            localStorage.setItem('siparisListesiTarih', seciliTarih);
        }
    }, [seciliTarih]);

    // Siparişler yüklendikten sonra paraşüt faturalarının durumunu otomatik kontrol et
    useEffect(() => {
        if (siralamaGuncellemesiRef.current) {
            siralamaGuncellemesiRef.current = false;
            return;
        }
        console.log("🔄 Fatura kontrol useEffect tetiklendi!");
        console.log("📊 Siparisler length:", siparisler.length);
        console.log("📋 Siparisler array:", siparisler);
        
        if (siparisler.length > 0) {
            console.log("🔍 Sipariş listesi yüklendi, fatura durumları kontrol ediliyor...");
            
            // Paraşüt fatura ID'si olan siparişleri bul
            const faturaIdleri = siparisler
                .filter(siparis => siparis.parasut_fatura_id)
                .map(siparis => siparis.parasut_fatura_id);
            
            console.log("📋 Sipariş detayları:", siparisler.map(s => ({ 
                id: s.id, 
                siparis_no: s.siparis_no, 
                parasut_fatura_id: s.parasut_fatura_id 
            })));
            console.log("📄 Bulunan fatura ID'leri:", faturaIdleri);
            
            if (faturaIdleri.length > 0) {
                console.log(`📄 ${faturaIdleri.length} adet fatura durumu kontrol edilecek`);
                
                // Fatura kontrollerini hızlı bir şekilde yap (100ms gecikme)
                faturaIdleri.forEach((faturaId, index) => {
                    setTimeout(() => {
                        checkFaturaStatusOtomatik(faturaId)
                            .then(() => console.log(`✅ Fatura ${faturaId} durumu güncellendi`))
                            .catch(err => console.warn(`⚠️ Fatura ${faturaId} durumu güncellenemedi:`, err));
                    }, index * 100); // 500ms'den 100ms'ye düşürdük
                });
            }
        } else {
            console.log("📝 Henüz sipariş yüklenmedi veya fatura ID'si olan sipariş yok");
        }
    }, [siparisler, siparisler.length]); // Hem array hem length değişiminde tetikle

    // Butonları devre dışı bırakma kontrolü
    const isButtonDisabled = () => {
        return userRole === 'depo_operatoru';
    };

    const handleBrowseClick = () => {
        // Depo operatörü için engelle
        if (isButtonDisabled()) return;
        // Gizli dosya girişini tetikle
        fileInputRef.current.click();
    };

    // Kargo güncelleme butonu için özel disabled kontrolü
    const isShipmentUpdateDisabled = () => {
        // Hem depo operatörü hem de operatör kullanıcıları için pasif
        return userRole === 'depo_operatoru' || userRole === 'operator';
    };

    // Resmileştir butonu için özel disabled kontrolü
    const isResmilestirDisabled = (faturaId) => {
        return isButtonDisabled() || resmilestirLoading[faturaId] || false;
    };

    // Acil siparişleri localStorage'dan yükle
    useEffect(() => {
        const savedAcilSiparisler = localStorage.getItem('acilSiparisler');
        if (savedAcilSiparisler) {
            setAcilSiparisler(JSON.parse(savedAcilSiparisler));
        }
    }, []);
    
    // Acil siparişler değiştiğinde localStorage'a kaydet
    useEffect(() => {
        if (acilSiparisler.length > 0) {
            localStorage.setItem('acilSiparisler', JSON.stringify(acilSiparisler));
        }
    }, [acilSiparisler]);
    
    useEffect(() => {
        if (detayData) {
            setProformaTel(detayData.musteri?.telefon_numarasi || '');
            setMusteriNotu(detayData.siparis_notu || '');
            const altTel = detayData.alternatif_telefon || '';
            setAlternatifTel(altTel);
            setNumaraCheckbox(!!altTel);
        }
        // Detay bandı kapandığında veya değiştiğinde önceki hareketleri temizle
        if (!detayData) {
            setKargoHareketleri([]);
        }
    }, [detayData]);

    // Keyboard shortcut - Y tuşu ile yeni sipariş aç
    useEffect(() => {
        const handleKeyPress = (e) => {
            // Input elementlerine odaklanılmışsa kısayolu çalıştırma
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
                return;
            }
            
            // Y tuşuna basıldığında ve buton aktifse yeni sipariş aç
            if (e.key.toLowerCase() === 'y' && !isButtonDisabled()) {
                e.preventDefault();
                handleModalOpen();
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    // Otomatik fatura durumu kontrolü
    const checkFaturaStatusOtomatik = async (faturaId) => {
        if (!faturaId) return; // Fatura ID'si yoksa kontrol etme

        try {
            const token = localStorage.getItem('token');
            if (!token) return;

            console.log(`Fatura durumu sorgulanıyor: ${faturaId}`);
            const response = await fetch(`/api/faturalar/${faturaId}/durum`, {
                method: 'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status === 401) return;

            const data = await response.json();
            console.log(`Paraşüt API yanıtı alındı (${faturaId}):`, JSON.stringify(data, null, 2));
            
            if (response.ok) {
                // Orijinal veri yapısını koru ama tam API yanıtını da ekle
                const yeniFaturaDurumu = {
                    is_finalized: data.is_finalized,
                    iptal_edildi: !!data.iptal_edildi, // Paraşüt'te iptal edilmiş

                    fatura_bilgileri: data.fatura_bilgileri,
                    mesaj: data.mesaj,
                    // Tam API yanıtını raw_data olarak ekle
                    raw_data: data
                };
                
                // Eğer Paraşüt API'den gelen yanıt farklı formatta ise
                if (data.data && data.data.attributes) {
                    // API yanıtından fatura numarasını doğrudan çıkartmaya çalış
                    if (data.data.attributes.invoice_no) {
                        // data.data.attributes yapısı varsa ve invoice_no içeriyorsa
                        if (!yeniFaturaDurumu.fatura_bilgileri) {
                            yeniFaturaDurumu.fatura_bilgileri = {};
                        }
                        yeniFaturaDurumu.fatura_bilgileri.fatura_no = data.data.attributes.invoice_no;
                        console.log(`Fatura numarası alternatif yapıdan alındı: ${data.data.attributes.invoice_no}`);
                    }
                    
                    // Finalized durumu da attributes içinde olabilir
                    if (data.data.attributes.invoice_series_id) {
                        yeniFaturaDurumu.is_finalized = true;
                    }
                }

                // State'i güncelle
                setFaturaStatuslari(prev => ({
                    ...prev,
                    [faturaId]: yeniFaturaDurumu
                }));
                
                console.log(`Fatura durumu alındı: ${faturaId}`, yeniFaturaDurumu);
                
                // Ayrıca hemen yanıt olarak da döndürelim (toplu indirme için)
                return yeniFaturaDurumu;
            }
        } catch (error) {
            console.error("Otomatik fatura durumu kontrol hatası:", error);
        }
    };

    const getResmilesmisFaturaDurumu = async (faturaId) => {
        const maksimumDeneme = 20;
        const tekrarBeklemeMs = 1000;
        let sonDurum;

        for (let deneme = 1; deneme <= maksimumDeneme; deneme += 1) {
            sonDurum = await checkFaturaStatusOtomatik(faturaId);
            if (sonDurum?.is_finalized && getFaturaNumarasi(sonDurum)) {
                return sonDurum;
            }

            if (deneme < maksimumDeneme) {
                await new Promise(resolve => setTimeout(resolve, tekrarBeklemeMs));
            }
        }

        return sonDurum;
    };

    const handleSecim = (siparisId) => {
        setSeciliSiparisler(prev => 
            prev.includes(siparisId) 
                ? prev.filter(id => id !== siparisId)
                : [...prev, siparisId]
        );
    };

    const handleTumunuSec = (e) => {
        if (e.target.checked) {
            setSeciliSiparisler(filtrelenmisSiparisler.map(s => s.id));
        } else {
            setSeciliSiparisler([]);
        }
    };

    const handleBeklemeyeAl = async (siparisId) => {
        const isConfirmed = window.confirm("Bu sipariş bekleyenler listesine taşınacaktır. Emin misiniz?");
        if (!isConfirmed) return;

        try {
            const response = await fetch(`/api/siparisler/${siparisId}/durum-guncelle`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ kargo_durumu: 'Beklemede' })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            
            alert(data.mesaj);
            
            // --- DEĞİŞİKLİK BURADA ---
            // 1. Ana sipariş listesini yenileyerek satır renginin güncellenmesini sağla.
            fetchSiparisler(); 
            
            // 2. Açık olan detay bandının verisini de anında güncelle.
            // Bu, butonun "Beklemede" olarak değişmesini sağlar.
            setDetayData(prevDetayData => ({
                ...prevDetayData,
                kargo_durumu: 'Beklemede'
            }));
            // -------------------------

        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };
    
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        console.log('📁 Dosya seçildi:', file);
        
        if (!file) {
            console.log('❌ Dosya seçilmedi');
            return;
        }
        
        console.log('📄 Dosya detayları:', {
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified
        });

        setSelectedFile(file);
        setUploadStatus('Ön okuma yapılıyor...');

        // PapaParse ile CSV'yi tara ve sipariş sayısını bul
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                console.log('📊 PapaParse sonucu:', results);
                const data = results.data;
                console.log('📊 Veri sayısı:', data.length);
                if (data.length > 0) {
                    console.log('📋 İlk satır:', data[0]);
                    console.log('📋 Kolonlar:', Object.keys(data[0]));
                }
                
                // 'Sipariş numarası' sütununa göre benzersiz siparişleri say
                const uniqueOrderIds = new Set(data.map(item => item['Sipariş numarası']));
                console.log('📦 Benzersiz sipariş sayısı:', uniqueOrderIds.size);
                setOrderCount(uniqueOrderIds.size);

                // Vergi No / T.C Kimlik numarası olan siparişleri tespit et
                const vergiTespitlendi = [];
                const gorulenSiparisler = new Set();
                data.forEach(item => {
                    const siparisNo = item['Sipariş numarası'];
                    const vergiNo = (item['T.C Kimlik / Vergi No Giriniz'] || '').trim();
                    if (vergiNo && siparisNo && !gorulenSiparisler.has(siparisNo)) {
                        gorulenSiparisler.add(siparisNo);
                        vergiTespitlendi.push({
                            siparis_no: siparisNo,
                            ad_soyad: (item['Alıcı adı'] || '').trim()
                        });
                    }
                });
                setVergiNoUyarilari(vergiTespitlendi);

                setIsCsvModalOpen(true); // CSV onay ekranını aç
                setUploadStatus(''); // Durum mesajını temizle
            },
            error: (error) => {
                console.error('❌ CSV okuma hatası:', error);
                setUploadStatus(`CSV okuma hatası: ${error.message}`);
                setSelectedFile(null);
            }
        });
    };
    
    const handleAcilGonder = async (siparisId) => {
        const isConfirmed = window.confirm("Bu sipariş acil gönderilecek olarak işaretlenecek. Emin misiniz?");
        if (!isConfirmed) return;

        try {
            const response = await fetch(`/api/siparisler/${siparisId}/durum-guncelle`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ kargo_durumu: 'Acil' })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            
            alert(data.mesaj);
            
            // Acil siparişler listesine ekle
            setAcilSiparisler(prevList => [...prevList, siparisId]);
            
            // Ana sipariş listesini yenile
            fetchSiparisler(); 
            
            // Açık olan detay bandının verisini güncelle
            setDetayData(prevDetayData => ({
                ...prevDetayData,
                kargo_durumu: 'Acil'
            }));

        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };
    
    const handleNormalGonder = async (siparisId) => {
        const isConfirmed = window.confirm("Bu sipariş normal gönderilecek olarak işaretlenecek. Emin misiniz?");
        if (!isConfirmed) return;

        try {
            const response = await fetch(`/api/siparisler/${siparisId}/durum-guncelle`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ kargo_durumu: 'Normal' })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            
            alert(data.mesaj);
            
            // Acil siparişler listesinden çıkar
            setAcilSiparisler(prevList => prevList.filter(id => id !== siparisId));
            
            // Ana sipariş listesini yenile
            fetchSiparisler(); 
            
            // Açık olan detay bandının verisini güncelle
            setDetayData(prevDetayData => ({
                ...prevDetayData,
                kargo_durumu: 'Normal'
            }));

        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };

    // Alternatif telefon numarasını kaydetme fonksiyonu
    const handleSaveGonderimNumarasi = async () => {
        if (!detayData) return;

        try {
            const response = await fetch(`/api/siparisler/${detayData.id}/alternatif-telefon`, {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ 
                    alternatif_telefon: alternatifTel 
                })
            });

            const data = await response.json();
            
            if (!response.ok) {
                throw new Error(data.hata || 'Alternatif numara kaydedilemedi');
            }
            
            // Detay verilerini güncelle
            setDetayData(prevData => ({
                ...prevData,
                alternatif_telefon: data.alternatif_telefon
            }));
            
            alert('Alternatif numara başarıyla kaydedildi.');
            
        } catch (error) {
            console.error('Alternatif numara kaydetme hatası:', error);
            alert(`Hata: ${error.message}`);
        }
    };

    const getFaturaNumarasi = (faturaDurumu) => (
        faturaDurumu?.fatura_bilgileri?.fatura_no
        || faturaDurumu?.raw_data?.data?.attributes?.invoice_no
        || faturaDurumu?.data?.attributes?.invoice_no
        || ''
    );

    const handleTopluIndir = async (tip) => {
        if (seciliSiparisler.length === 0) {
            alert("Lütfen en az bir sipariş seçin.");
            return;
        }
        
        alert(`${seciliSiparisler.length} adet ${tip} indiriliyor. Lütfen bekleyin...`);
        const zip = new JSZip();
        const faturaNumarasiBekleyenSiparisler = [];
        const geciciRenderAlani = document.createElement('div');
        geciciRenderAlani.style.position = 'absolute';
        geciciRenderAlani.style.left = '-9999px';
        document.body.appendChild(geciciRenderAlani);

        try {
            for (const id of seciliSiparisler) {
                try {
                    const res = await fetch(`/api/siparisler/${id}`, { cache: 'no-cache' });
                    const detay = await res.json();
                    if (!res.ok) { continue; }
                    let faturaNo = detay.fatura_no || '';

                    // Eğer fatura numarası kullanılacak bir etiket ise, fatura durumunu kontrol et
                    if (tip === 'Etiket' && detay.parasut_fatura_id && !faturaNo) {
                        try {
                            console.log(`[ID: ${id}] Fatura durumu kontrol ediliyor... Fatura ID: ${detay.parasut_fatura_id}`);
                            
                            // Paraşüt resmileştirme bilgisini ilk sorguda gecikmeli döndürebilir.
                            const faturaDurumu = await getResmilesmisFaturaDurumu(detay.parasut_fatura_id);
                            
                            if (faturaDurumu) {
                                console.log(`[ID: ${id}] Fatura durumu alındı:`, JSON.stringify(faturaDurumu, null, 2));
                                
                                // Fatura bilgilerini her durumda güncelle
                                setFaturaStatuslari(prev => ({
                                    ...prev,
                                    [detay.parasut_fatura_id]: faturaDurumu
                                }));
                                
                                faturaNo = getFaturaNumarasi(faturaDurumu);
                                detay.fatura_no = faturaNo;
                                console.log(`[ID: ${id}] E-Fatura numarası: ${faturaNo || 'bulunamadı'}`);
                            } else {
                                console.log(`[ID: ${id}] Fatura durumu alınamadı`);
                            }
                            
                        } catch (error) {
                            console.error(`[ID: ${id}] Fatura durumu kontrol edilemedi, varsayılan ad kullanılacak:`, error);
                        }
                    }

                    if (tip === 'Etiket' && detay.parasut_fatura_id && !faturaNo) {
                        faturaNumarasiBekleyenSiparisler.push(detay.siparis_no || id);
                        console.warn(`[ID: ${id}] Fatura numarası doğrulanamadığı için etiket oluşturulmadı.`);
                        continue;
                    }

                    const componentWrapper = document.createElement('div');
                    geciciRenderAlani.appendChild(componentWrapper);
                    
                    const root = ReactDOM.createRoot(componentWrapper);
                    
                    // --- DEĞİŞİKLİK BURADA: Yeni prop'u gönderiyoruz ---
                    const ComponentToRender = tip === 'Proforma' 
                        ? <ProformaPreview detayData={detay} isForDownload={true} /> 
                        : <EtiketSablonu siparis={detay} />;

                    root.render(<React.StrictMode>{ComponentToRender}</React.StrictMode>);
                    
                    await new Promise(resolve => setTimeout(resolve, 100));
                    
                    const nodeToCapture = componentWrapper.firstChild;
                    if (!nodeToCapture) {
                        throw new Error("Render edilen component DOM'da bulunamadı.");
                    }

                    // Artık scrollHeight'e gerek kalmadan tam boyutu alabilmeliyiz
                    const dataUrl = await htmlToImage.toPng(nodeToCapture, {
                        pixelRatio: 3,
                        backgroundColor: 'white',
                        skipFonts: tip === 'Etiket' // etiket sadece Arial kullanır, bkz. etiketDugumGorseli
                    });
                    
                    const dosyaAdi = createFileName(tip, detay, faturaNo);
                    
                    if (tip === 'Etiket') {
                        // A5 boyutunda bir canvas oluştur
                        const canvas = document.createElement('canvas');
                        const a5Width = 1748; // yaklaşık 15cm (5.9 inç * 300dpi)
                        const a5Height = 2480; // yaklaşık 21cm (8.3 inç * 300dpi)
                        canvas.width = a5Width;
                        canvas.height = a5Height;
                        
                        // Canvas içerisinde 2D context oluştur
                        const ctx = canvas.getContext('2d');
                        
                        // Beyaz bir zemin ile başla
                        ctx.fillStyle = 'white';
                        ctx.fillRect(0, 0, a5Width, a5Height);
                        
                        // Etiket görselini yükle
                        const img = new Image();
                        await new Promise((resolve, reject) => {
                            img.onload = resolve;
                            img.onerror = reject;
                            img.src = dataUrl;
                        });
                        
                        // Etiketin boyutları (15cm x 12cm) - Boyutu genişletildi
                        const etiketWidth = 1748; // yaklaşık 15cm
                        const etiketHeight = 1300; // yaklaşık 12cm - genişletilmiş yükseklik
                        
                        // Etiketi A5 sayfasının üst kısmına hizala
                        ctx.drawImage(
                            img,
                            0, // X konumu
                            0, // Y konumu (üste dayalı)
                            etiketWidth, // Hedef genişlik
                            etiketHeight // Hedef yükseklik
                        );
                        
                        // A5 formatındaki görseli ekle
                        const finalDataUrl = canvas.toDataURL('image/png');
                        zip.file(dosyaAdi, finalDataUrl.split(',')[1], { base64: true });
                    } else {
                        // Proforma için normal davran
                        zip.file(dosyaAdi, dataUrl.split(',')[1], { base64: true });
                    }

                    root.unmount();
                    geciciRenderAlani.removeChild(componentWrapper);

                } catch (err) {
                    console.error(`[ID: ${id}] döngü içinde hata:`, err);
                }
            }
        } finally {
            document.body.removeChild(geciciRenderAlani);
        }

        // Zip dosyasını oluştur ve indir
        if (Object.keys(zip.files).length > 0) {
            zip.generateAsync({ type: "blob" }).then(content => {
                saveAs(content, `toplu_${tip.toLowerCase()}.zip`);
                const tamamlanmaMesaji = faturaNumarasiBekleyenSiparisler.length
                    ? `Toplu indirme tamamlandı.\n\nFatura numarası henüz doğrulanamadığı için ${faturaNumarasiBekleyenSiparisler.length} etiket oluşturulmadı: ${faturaNumarasiBekleyenSiparisler.join(', ')}`
                    : 'Toplu indirme tamamlandı!';
                alert(tamamlanmaMesaji);
            });
        } else {
            alert("Hiçbir dosya oluşturulamadı. Lütfen konsolu kontrol edin.");
        }
    };

    // --- A5 ÇİFT TARAFLI BASKI (ön yüz etiket, arka yüz e-fatura) ---
    // Çıktı tek PDF'tir; her sipariş yeni bir yaprağın ön yüzünden başlar (yaprak = ön + arka yüz):
    // - Ana fatura tek sayfaysa: [etiket | fatura]
    // - Ana fatura çok sayfaysa: fatura sayfaları ön/arka, etiket sonraki yaprakta tek başına
    // - Ek siparişlerin faturaları her biri yeni yapraktan başlar, ön/arka
    // Etiketi olmayan (barkodsuz) ya da faturası resmileşmemiş siparişte uyarılır; onaylanırsa sadece olan evrak basılır.
    const etiketGorseliOlustur = async (detay, renderAlani) => {
        const kap = document.createElement('div');
        renderAlani.appendChild(kap);
        const root = ReactDOM.createRoot(kap);
        try {
            root.render(<EtiketSablonu siparis={detay} />);
            await new Promise(resolve => setTimeout(resolve, 100)); // barkod SVG'si çizilsin
            if (!kap.firstChild) throw new Error('Etiket çizilemedi');
            return await etiketDugumGorseli(kap.firstChild);
        } finally {
            root.unmount();
            renderAlani.removeChild(kap);
        }
    };

    // Resmileşmiş faturanın PDF'ini Paraşüt'ten alıp her sayfasını A5 genişliğinde (300 DPI) görsele çevirir.
    // Fatura resmileşmemişse null döner.
    const faturaSayfaGorselleri = async (faturaId) => {
        const sonuc = await faturaPdfAl(faturaId, true);
        if (sonuc.resmilesmemis) return null;
        const doc = await pdfjsLib.getDocument({ data: new Uint8Array(sonuc.veri) }).promise;
        try {
            return await pdfSayfaGorselleri(doc);
        } finally {
            doc.destroy();
        }
    };

    // Detaydaki etiket önizlemesini (seçili barkod) tek başına A5 dikey, tek yönlü yazdırır
    const [etiketYazdiriliyor, setEtiketYazdiriliyor] = useState(false);
    const handleEtiketYazdir = async (siparisId) => {
        const dugum = document.getElementById(`etiket-wrapper-${siparisId}`)?.firstChild;
        if (!dugum) { alert('Etiket önizlemesi bulunamadı.'); return; }
        setEtiketYazdiriliyor(true);
        try {
            a5Yazdir([await etiketDugumGorseli(dugum)], false);
        } catch (error) {
            console.error('Etiket yazdırma hatası:', error);
            alert(`Etiket yazdırılamadı: ${error.message}`);
        } finally {
            setEtiketYazdiriliyor(false);
        }
    };

    const handleTopluYazdir = async () => {
        if (seciliSiparisler.length === 0 || yazdirIlerleme) return;
        const headers = { 'Authorization': `Bearer ${localStorage.getItem('token')}` };
        const renderAlani = document.createElement('div');
        renderAlani.style.position = 'absolute';
        renderAlani.style.left = '-9999px';
        document.body.appendChild(renderAlani);
        setYazdirIlerleme('hazırlanıyor');

        try {
            // 1) Her siparişin evrakını hazırla, eksikleri topla
            const siparisYuzleri = []; // her eleman bir siparişin yüz listesi (null = boş arka yüz)
            const uyarilar = [];
            for (let i = 0; i < seciliSiparisler.length; i++) {
                const id = seciliSiparisler[i];
                setYazdirIlerleme(`${i + 1}/${seciliSiparisler.length}`);
                let ad = `#${siparisler.find(s => s.id === id)?.siparis_no || id}`;
                try {
                    const res = await fetch(`/api/siparisler/${id}`, { headers, cache: 'no-cache' });
                    if (!res.ok) throw new Error(`Status ${res.status}`);
                    const detay = await res.json();
                    ad = `#${detay.siparis_no || id} ${(detay.musteri || detay).ad_soyad || ''}`.trim();

                    const eksikler = [];
                    let etiket = null;
                    if (!detay.kargo_takip_no) eksikler.push('etiket yok (barkod alınmamış)');
                    else {
                        try { etiket = await etiketGorseliOlustur(detay, renderAlani); }
                        catch (e) { eksikler.push(`etiket oluşturulamadı (${e.message})`); }
                    }

                    const faturalar = []; // her eleman bir faturanın sayfa görselleri
                    const kayitlar = [
                        { kayit: detay, adi: 'Fatura' },
                        ...(detay.ek_siparisler || []).map(ek => ({ kayit: ek, adi: `Ek-${ek.sira} faturası` }))
                    ];
                    for (const { kayit, adi } of kayitlar) {
                        if (!kayit.parasut_fatura_id) { eksikler.push(`${adi} kesilmemiş`); continue; }
                        try {
                            const sayfalar = await faturaSayfaGorselleri(kayit.parasut_fatura_id);
                            if (sayfalar) faturalar.push(sayfalar);
                            else eksikler.push(`${adi} resmileşmemiş`);
                        } catch (e) {
                            eksikler.push(`${adi} alınamadı (${e.message})`);
                        }
                    }

                    if (eksikler.length) uyarilar.push(`${ad}: ${eksikler.join(', ')}`);
                    if (!etiket && faturalar.length === 0) continue;

                    const yuzler = [];
                    const yapragiTamamla = () => { if (yuzler.length % 2) yuzler.push(null); };
                    const [ilkFatura, ...digerFaturalar] = faturalar;
                    if (etiket && ilkFatura?.length === 1) {
                        yuzler.push(etiket, ilkFatura[0]);
                    } else {
                        if (ilkFatura) { yuzler.push(...ilkFatura); yapragiTamamla(); }
                        if (etiket) yuzler.push(etiket);
                    }
                    digerFaturalar.forEach(sayfalar => { yapragiTamamla(); yuzler.push(...sayfalar); });
                    yapragiTamamla();
                    siparisYuzleri.push(yuzler);
                } catch (e) {
                    uyarilar.push(`${ad}: sipariş bilgisi okunamadı (${e.message})`);
                }
            }

            if (siparisYuzleri.length === 0) {
                alert(`Basılacak evrak bulunamadı.${uyarilar.length ? `\n\n${uyarilar.join('\n')}` : ''}`);
                return;
            }
            if (uyarilar.length && !window.confirm(
                `Bazı siparişlerin evrakı eksik:\n\n${uyarilar.join('\n')}\n\n` +
                `Yine de yazdırılsın mı? Bu siparişlerin sadece mevcut evrakı basılır.`
            )) return;

            // 2) Tek PDF'te birleştirip çift taraflı yazdır
            a5Yazdir(siparisYuzleri.flat(), true);
        } catch (error) {
            console.error('Yazdırma hazırlanırken hata:', error);
            alert(`Yazdırma hazırlanamadı: ${error.message}`);
        } finally {
            document.body.removeChild(renderAlani);
            setYazdirIlerleme(null);
        }
    };

    // Seçili siparişlerin (ek siparişler dahil) resmileşmiş e-fatura / e-arşiv PDF'lerini zip olarak indirir
    const handleTopluEFaturaIndir = async () => {
        if (seciliSiparisler.length === 0 || efaturaIndirIlerleme) return;
        const headers = { 'Authorization': `Bearer ${localStorage.getItem('token')}` };
        const zip = new JSZip();
        const atlananlar = [];
        setEfaturaIndirIlerleme('hazırlanıyor');
        try {
            for (let i = 0; i < seciliSiparisler.length; i++) {
                const id = seciliSiparisler[i];
                setEfaturaIndirIlerleme(`${i + 1}/${seciliSiparisler.length}`);
                let ad = `#${siparisler.find(s => s.id === id)?.siparis_no || id}`;
                try {
                    const res = await fetch(`/api/siparisler/${id}`, { headers, cache: 'no-cache' });
                    if (!res.ok) throw new Error(`Status ${res.status}`);
                    const detay = await res.json();
                    ad = `#${detay.siparis_no || id} ${(detay.musteri || detay).ad_soyad || ''}`.trim();
                    const kayitlar = [
                        { kayit: detay, adi: 'Fatura' },
                        ...(detay.ek_siparisler || []).map(ek => ({ kayit: ek, adi: `Ek-${ek.sira} faturası` }))
                    ];
                    for (const { kayit, adi } of kayitlar) {
                        const faturaId = kayit.parasut_fatura_id;
                        if (!faturaId) { atlananlar.push(`${ad}: ${adi} kesilmemiş`); continue; }
                        let sonuc;
                        try {
                            sonuc = await faturaPdfAl(faturaId);
                        } catch (e) {
                            atlananlar.push(`${ad}: ${adi} indirilemedi (${e.message})`);
                            continue;
                        }
                        if (sonuc.resmilesmemis) { atlananlar.push(`${ad}: ${adi} resmileşmemiş`); continue; }
                        const faturaNo = sonuc.faturaNo || kayit.fatura_no || `fatura_${faturaId}`;
                        let dosyaAdi = `${faturaNo}.pdf`;
                        for (let n = 2; zip.files[dosyaAdi]; n++) dosyaAdi = `${faturaNo} (${n}).pdf`;
                        zip.file(dosyaAdi, sonuc.veri);
                    }
                } catch (e) {
                    atlananlar.push(`${ad}: sipariş bilgisi okunamadı (${e.message})`);
                }
            }

            const dosyaSayisi = Object.keys(zip.files).length;
            if (dosyaSayisi === 0) {
                alert(`İndirilecek e-fatura bulunamadı.${atlananlar.length ? `\n\n${atlananlar.join('\n')}` : ''}`);
                return;
            }
            saveAs(await zip.generateAsync({ type: 'blob' }), 'toplu_efatura.zip');
            alert(atlananlar.length
                ? `${dosyaSayisi} e-fatura indirildi.\n\nİndirilemeyenler:\n${atlananlar.join('\n')}`
                : `${dosyaSayisi} e-fatura indirildi.`);
        } catch (error) {
            console.error('Toplu e-fatura indirilirken hata:', error);
            alert(`E-faturalar indirilemedi: ${error.message}`);
        } finally {
            setEfaturaIndirIlerleme(null);
        }
    };

    // Üst bardaki açılır menü: ana butona tıklanınca alt seçenekler altında listelenir.
    // durum: süren toplu işlemin ilerlemesi (menü kapalıyken de ana butonda görünsün diye)
    const renderUstMenu = (anahtar, ikon, ikonStili, baslik, durum, secenekler) => {
        const acik = acikMenu === anahtar;
        return (
            <div style={{ position: 'relative' }}>
                <button
                    onClick={() => setAcikMenu(acik ? null : anahtar)}
                    style={{
                        padding: '5px 12px',
                        fontFamily: 'poppins',
                        alignItems: 'center',
                        display: 'flex',
                        gap: '6px',
                        fontSize: '13px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        background: acik ? '#ececec' : '#f8f8f8',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap'
                    }}
                >
                    <img src={ikon} alt={baslik} style={{ height: '14px', ...ikonStili }} />
                    <span>{durum ? `${baslik} · ${durum}` : baslik}</span>
                    <span style={{ fontSize: '9px', color: '#666' }}>{acik ? '▲' : '▼'}</span>
                </button>
                {acik && (
                    <div style={{ position: 'absolute', top: 'calc(100% + 4px)', right: 0, minWidth: '100%', background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.12)', zIndex: 1050, padding: '4px 0' }}>
                        {secenekler.filter(s => !s.gizli).map((s, i) => (
                            <button
                                key={s.etiket}
                                className="ust-menu-secenek"
                                onClick={() => { setAcikMenu(null); s.onClick(); }}
                                disabled={s.disabled}
                                title={s.title}
                                style={{
                                    display: 'block',
                                    width: '100%',
                                    textAlign: 'left',
                                    padding: '6px 14px',
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                    borderBottom: 'none',
                                    borderTop: i > 0 ? '1px solid #eee' : 'none', // seçenekler arası ince ayırıcı
                                    background: 'transparent',
                                    fontFamily: 'poppins',
                                    fontSize: '13px',
                                    whiteSpace: 'nowrap',
                                    opacity: s.disabled ? 0.5 : 1,
                                    cursor: s.disabled ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {s.etiket}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    // Tarih input'u değiştiğinde state'i günceller
    const handleTarihChange = (e) => {
        setSeciliTarih(e.target.value);
    };

    // PTT kaydında/etikette yer alan ve değişince barkodun otomatik yenilenmesini gerektiren alanlar:
    // müşteri bilgileri, ödeme türü ve sadece kapıda ödemede (ödeme şartlı) tutar.
    // EFT/havale vb. siparişte etikette tutar yazmadığı için tutar değişse de barkod yenilenmez.
    const etiketBilgileri = (s) => {
        const m = s.musteri || s;
        const odemeSartli = s.odeme_yontemi === 'K';
        return JSON.stringify([m.ad_soyad, m.adres, m.il, m.ilce, m.telefon_numarasi || '', s.odeme_yontemi,
            odemeSartli ? Number(s.toplam_bedel || 0) : null]);
    };

    const handleModalOpen = (siparisId = null) => {
        setEditingSiparisId(siparisId); // Düzenleme için id'yi, yeni için null'ı ayarla
        setIsModalOpen(true);
        duzenlemeOncesiRef.current = null;
        if (siparisId) {
            // Sadece barkodu verilmiş siparişlerde, düzenleme öncesi etiket bilgilerini sakla
            fetch(`/api/siparisler/${siparisId}`, { cache: 'no-cache' })
                .then(res => res.json())
                .then(data => {
                    if (data.kargo_takip_no) {
                        duzenlemeOncesiRef.current = { id: siparisId, bilgi: etiketBilgileri(data) };
                    }
                })
                .catch(error => console.error("Düzenleme öncesi sipariş bilgisi alınamadı:", error));
        }
    };

    const handleModalClose = (refresh = false) => {
        // Preserve editing id before clearing so we can refresh detail if needed
        const prevEditingId = editingSiparisId;
        const oncesi = duzenlemeOncesiRef.current;
        duzenlemeOncesiRef.current = null;
        setIsModalOpen(false);
        setEditingSiparisId(null); // Modal kapanınca ID'yi temizle
        if (refresh) {
            fetchSiparisler(); // Eğer formda bir kayıt/güncelleme yapıldıysa listeyi yenile
        }
        // Barkodlu siparişte adres bilgisi sipariş kaydedilmeden de değişebilir; bu yüzden her kapanışta kontrol et
        const barkodKontrol = oncesi && oncesi.id === prevEditingId;
        if (!prevEditingId || (!refresh && !barkodKontrol)) return;
        fetch(`/api/siparisler/${prevEditingId}`, { cache: 'no-cache' })
            .then(res => res.json())
            .then(data => {
                const degisti = barkodKontrol && data.kargo_takip_no && etiketBilgileri(data) !== oncesi.bilgi;
                // Eğer kullanıcı aynı siparişi detayda açık tutuyorsa, detayı doğrudan yenile
                if (acikSiparisId && prevEditingId === acikSiparisId && (refresh || degisti)) {
                    setDetayData(data);
                    if (data.parasut_fatura_id) {
                        checkFaturaStatusOtomatik(data.parasut_fatura_id);
                    }
                }
                if (degisti) {
                    if (!refresh) fetchSiparisler();
                    // PTT kabulü yapılmış gönderide yeni barkod alınmaz; sadece uyarılır
                    if (data.ptt_durum === 'Yolda' || data.ptt_durum === 'Teslim Edildi') {
                        alert(`Etiket bilgileri değişti ancak gönderi PTT'de "${data.ptt_durum}" durumunda olduğu için barkod (${data.kargo_takip_no}) otomatik güncellenmedi.`);
                    } else {
                        handleEtiketYenile(prevEditingId);
                    }
                }
            })
            .catch(error => console.error("Sipariş detayı çekilirken hata:", error));
    };

    // Barkodu verilmiş siparişin barkodunu PTT'den yeniden alır (onay çağıran tarafta alınır)
    const handleEtiketYenile = async (siparisId) => {
        try {
            // Alıcı ödemeli oluşturulmuş barkod yenilenirken de alıcı ödemeli kalsın
            const odeme_sart = localStorage.getItem(`kargo_alici_odemeli_${siparisId}`) === 'true' ? 'A' : 'G';
            const response = await fetch(`api/siparisler/${siparisId}/kargo-olustur`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ odeme_sart })
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası oluştu.');
            }

            try { localStorage.setItem(`etiket_guncellendi_${siparisId}`, 'true'); } catch (e) { /* yoksay */ }
            setEtiketUyariTick(t => t + 1);
            alert(`Barkod güncellendi.\nYeni Takip No: ${data.kargoTakipNo}\n\nYeni etiketin çıktısını almayı unutmayın!`);

            fetchSiparisler();
            // Detay açıksa (toggle'a girmeden) yeni barkodu göstermek için yenile
            if (acikSiparisId === siparisId) {
                fetch(`/api/siparisler/${siparisId}`, { cache: 'no-cache' })
                    .then(res => res.json())
                    .then(detay => {
                        setDetayData(detay);
                        setAktifBarkod(detay.kargo_takip_no || '');
                    })
                    .catch(error => console.error("Sipariş detayı çekilirken hata:", error));
            }
        } catch (error) {
            console.error("Barkod güncellenirken hata:", error);
            alert(`Barkod güncellenemedi: ${error.message}`);
        }
    };

    const createFileName = (tip, siparis, faturaNo = '') => {
        const musteri = siparis.musteri || siparis;
        const telefonSon4 = (musteri.telefon_numarasi || '0000').slice(-4);
        const musteriAdSoyad = (musteri.ad_soyad || 'Isimsiz').replace(/ /g, '_'); // Boşlukları _ ile değiştir
        
        // E-fatura numarası varsa ve Etiket ise doğrudan e-fatura numarasını kullan
        if (tip === 'Etiket' && siparis.parasut_fatura_id) {
            if (faturaNo) {
                return `${faturaNo}.png`;
            }
            const faturaBilgisi = faturaStatuslari[siparis.parasut_fatura_id];
            
            // Fatura bilgisini debug etmek için ayrıntılı yazdır
            console.log(`DEBUG - Fatura bilgisi inceleniyor (${siparis.id}):`, 
                faturaBilgisi ? JSON.stringify(faturaBilgisi, null, 2) : 'Fatura bilgisi bulunamadı');
            
            // Fatura bilgisi kontrolü - Direkt fatura_no var mı?
            if (faturaBilgisi && faturaBilgisi.fatura_bilgileri && faturaBilgisi.fatura_bilgileri.fatura_no) {
                console.log(`${siparis.id || 'ID yok'} için e-fatura numarası kullanılıyor: ${faturaBilgisi.fatura_bilgileri.fatura_no}`);
                return `${faturaBilgisi.fatura_bilgileri.fatura_no}.png`;
            }
            
            // Alternatif fatura bilgisi kontrolü - Paraşüt API'den farklı yapıda gelebilir
            if (faturaBilgisi && faturaBilgisi.data && faturaBilgisi.data.attributes && 
                faturaBilgisi.data.attributes.invoice_no) {
                console.log(`${siparis.id || 'ID yok'} için alternatif e-fatura numarası kullanılıyor: ${faturaBilgisi.data.attributes.invoice_no}`);
                return `${faturaBilgisi.data.attributes.invoice_no}.png`;
            }
            
            // Siparis'in kendi içinde fatura_no varsa
            if (siparis.fatura_no) {
                console.log(`${siparis.id || 'ID yok'} için sipariş içindeki e-fatura numarası kullanılıyor: ${siparis.fatura_no}`);
                return `${siparis.fatura_no}.png`;
            }
        }
        
        // Yoksa eski formatta devam et, ama (Et) prefix'i olmadan
        if (tip === 'Etiket') {
            console.log(`${siparis.id || 'ID yok'} için eski format kullanılıyor (fatura no bulunamadı)`);
            return `${telefonSon4} - ${musteriAdSoyad}.png`;
        }
        
        // Proforma için prefix'i koru
        const prefix = tip === 'Proforma' ? '(Pr)' : '';
        return `${prefix} - ${telefonSon4} - ${musteriAdSoyad}.png`;
    };

    const handleDownloadLabel = async (siparisDetay, ozelBarkod = null, isEkPaket = false) => {
        // Hedefimiz artık etiketin kendisi değil, onu saran "kutu".
        const nodeId = `etiket-wrapper-${siparisDetay.id}`;
        const node = document.getElementById(nodeId);

        if (!node) {
            alert("Etiket önizlemesi bulunamadı, indirme işlemi yapılamıyor.");
            return;
        }
        
        let faturaNo = '';
        // Paraşüt resmileştirme bilgisi gecikmeli gelebileceği için numara gelene kadar tekrar sorgula.
        if (siparisDetay.parasut_fatura_id) {
            try {
                const faturaDurumu = await getResmilesmisFaturaDurumu(siparisDetay.parasut_fatura_id);
                faturaNo = getFaturaNumarasi(faturaDurumu);
                siparisDetay.fatura_no = faturaNo;
            } catch (error) {
                console.log("Fatura durumu kontrol edilemedi, dosya adında varsayılan format kullanılacak");
            }
        }

        // A5 boyutunda (15cm x 21cm) bir canvas oluştur
        const canvas = document.createElement('canvas');
        // A5 için piksel boyutları (300 DPI için)
        const a5Width = 1748; // yaklaşık 15cm (5.9 inç * 300dpi)
        const a5Height = 2480; // yaklaşık 21cm (8.3 inç * 300dpi)
        canvas.width = a5Width;
        canvas.height = a5Height;
        
        // Canvas içerisinde 2D context oluştur
        const ctx = canvas.getContext('2d');
        
        // Beyaz bir zemin ile başla
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, a5Width, a5Height);
        
        // Asıl etiket görüntüsünü oluştur
        htmlToImage.toPng(node, { 
            backgroundColor: 'transparent',
            pixelRatio: 3,
            height: node.scrollHeight + 20, // Etiketin tam yüksekliğine biraz ekstra ekle
        })
        .then((dataUrl) => {
            // Etiket görseli yükle
            const img = new Image();
            img.onload = () => {
                // Etiketin boyutları (15cm x 12cm) - Boyutu genişletildi
                const etiketWidth = 1748; // yaklaşık 15cm
                const etiketHeight = 1300; // yaklaşık 12cm - genişletilmiş yükseklik

                // Etiketi A5 sayfasının üst kısmına hizala
                // Orijinal görüntüyü yeni boyutlarla, ortalayarak çiz
                ctx.drawImage(
                    img, 
                    0, // X konumu
                    0, // Y konumu
                    etiketWidth, // Hedef genişlik
                    etiketHeight // Hedef yükseklik
                );
                
                // Yeni oluşturulan A5 formatındaki görseli indir
                const finalDataUrl = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                // Dosya adına ek paket bilgisini ekle
                const dosyaAdi = createFileName('Etiket', siparisDetay, faturaNo);
                const barkodSuffix = ozelBarkod && ozelBarkod !== siparisDetay.kargo_takip_no ? `_${ozelBarkod.slice(-6)}` : '';
                link.download = dosyaAdi.replace('.png', `${barkodSuffix}.png`);
                link.href = finalDataUrl;
                link.click();
                // Ana barkodun etiketi indirildiyse "Barkod Güncellendi" uyarısını kaldır
                if (!isEkPaket) {
                    try { localStorage.removeItem(`etiket_guncellendi_${siparisDetay.id}`); } catch (e) { /* yoksay */ }
                    setEtiketUyariTick(t => t + 1);
                }
            };
            img.src = dataUrl;
        })
        .catch((error) => {
            console.error('Etiket PNG oluşturulurken hata oluştu!', error);
            alert("Etiket indirilirken bir hata oluştu.");
        });
    };

    // --- TESLİM EVRAKI ---
    const telefonSon4Al = (telefon) => (telefon || '').replace(/[^0-9]/g, '').slice(-4) || '0000';
    const teslimTarihMetni = seciliTarih ? seciliTarih.split('-').reverse().join('.') : '';
    // Defterde gizlenen ve çöp kutusundaki siparişler teslim evrakına dahil edilmez
    const teslimSiparisleri = siparisler.filter(s => s.defterde_goster !== false && !s.silinme_tarihi);
    const teslimToplam = teslimSiparisleri.length;
    const teslimBekleyen = teslimEdilmeyenler.length;
    const teslimEdilen = Math.max(teslimToplam - teslimBekleyen, 0);

    const handleTeslimEvrakiAc = () => {
        setTeslimEdilmeyenler([]);
        setTeslimSecilenSiparisId('');
        setTeslimGerekce('Beklemede');
        setTeslimDigerAciklama('');
        setTeslimEvrakiModalAcik(true);
    };

    const handleTeslimEdilmeyenEkle = () => {
        const siparis = teslimSiparisleri.find(s => String(s.id) === String(teslimSecilenSiparisId));
        if (!siparis) {
            alert('Lütfen bir sipariş seçiniz.');
            return;
        }
        const gerekce = teslimGerekce === 'Diğer' && teslimDigerAciklama.trim()
            ? teslimDigerAciklama.trim()
            : teslimGerekce;
        setTeslimEdilmeyenler(prev => [...prev, {
            siparisId: siparis.id,
            son4: telefonSon4Al(siparis.telefon_numarasi),
            adSoyad: siparis.ad_soyad,
            gerekce
        }]);
        setTeslimSecilenSiparisId('');
        setTeslimGerekce('Beklemede');
        setTeslimDigerAciklama('');
    };

    const handleTeslimEdilmeyenSil = (siparisId) => {
        setTeslimEdilmeyenler(prev => prev.filter(item => item.siparisId !== siparisId));
    };

    const handleTeslimEvrakiOlustur = async () => {
        const node = teslimEvrakiRef.current;
        if (!node) return;
        setTeslimPdfLoading(true);
        try {
            const dataUrl = await htmlToImage.toPng(node, { pixelRatio: 2, backgroundColor: '#ffffff' });
            const pdf = new jsPDF('p', 'mm', 'a4');
            const margin = 10;
            const maxW = pdf.internal.pageSize.getWidth() - margin * 2;
            const maxH = pdf.internal.pageSize.getHeight() - margin * 2;
            let imgW = maxW;
            let imgH = node.offsetHeight * imgW / node.offsetWidth;
            // Liste çok uzunsa sayfaya sığacak şekilde küçült
            if (imgH > maxH) {
                imgW = imgW * maxH / imgH;
                imgH = maxH;
            }
            pdf.addImage(dataUrl, 'PNG', (pdf.internal.pageSize.getWidth() - imgW) / 2, margin, imgW, imgH);
            pdf.save(`Teslim Evrakı - ${teslimTarihMetni}.pdf`);
            setTeslimEvrakiModalAcik(false);
        } catch (error) {
            console.error('Teslim evrakı oluşturulurken hata:', error);
            alert('Teslim evrakı oluşturulurken bir hata oluştu.');
        } finally {
            setTeslimPdfLoading(false);
        }
    };

    // --- FATURA KONTROLÜ ---
    // Seçili siparişler (yoksa listedeki tüm siparişler) için proforma toplamı ile Paraşüt fatura toplamını
    // karşılaştırır. Paraşüt istek sınırı ve sunucu zaman aşımı için siparişler parça parça gönderilir.
    const handleFaturaKontrol = async () => {
        const hedefIdler = seciliSiparisler.length > 0 ? [...seciliSiparisler] : filtrelenmisSiparisler.map(s => s.id);
        if (hedefIdler.length === 0) {
            alert('Kontrol edilecek sipariş yok.');
            return;
        }
        const PARCA = 15;
        let sonuc = { durum: 'yukleniyor', islenen: 0, toplam: hedefIdler.length, kontrolEdilen: 0, uyumsuzlar: [], hatalar: [] };
        setFaturaKontrol(sonuc);
        setFaturaKontrolModalAcik(true);

        for (let i = 0; i < hedefIdler.length; i += PARCA) {
            const parca = hedefIdler.slice(i, i + PARCA);
            try {
                const response = await fetch('/api/siparisler/fatura-denklik-kontrol', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify({ siparisIds: parca })
                });
                if (response.status === 401) {
                    alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                    localStorage.removeItem('token');
                    window.location.href = '/login';
                    return;
                }
                const data = await response.json();
                if (!response.ok) throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası.');
                sonuc = {
                    ...sonuc,
                    kontrolEdilen: sonuc.kontrolEdilen + data.kontrol_edilen,
                    uyumsuzlar: [...sonuc.uyumsuzlar, ...data.uyumsuzlar],
                    hatalar: [...sonuc.hatalar, ...data.hatalar]
                };
            } catch (error) {
                const parcaHatalari = parca.map(id => {
                    const s = siparisler.find(x => x.id === id);
                    return { siparis_id: id, siparis_no: s?.siparis_no, ad_soyad: s?.ad_soyad || '', hata: error.message };
                });
                sonuc = { ...sonuc, hatalar: [...sonuc.hatalar, ...parcaHatalari] };
            }
            sonuc = { ...sonuc, islenen: Math.min(i + PARCA, hedefIdler.length) };
            setFaturaKontrol(sonuc);
        }
        setFaturaKontrol({ ...sonuc, durum: 'hazir' });
    };

    // Fatura kontrol sonucunu yatay A4 PDF olarak indirir; liste uzunsa satır sınırlarından sayfalara bölünür
    const handleFaturaKontrolPdfIndir = async () => {
        const node = faturaKontrolRef.current;
        if (!node) return;
        setFaturaKontrolPdfLoading(true);
        try {
            const canvas = await htmlToImage.toCanvas(node, { pixelRatio: 2, backgroundColor: '#ffffff' });
            const pdf = new jsPDF('l', 'mm', 'a4');
            const margin = 10;
            const sayfaW = pdf.internal.pageSize.getWidth() - margin * 2;
            const sayfaH = pdf.internal.pageSize.getHeight() - margin * 2;
            const sayfaPx = Math.floor(canvas.width * sayfaH / sayfaW); // bir sayfaya sığan piksel yüksekliği
            // Satır/blok alt kenarları: sayfa bu noktalardan kesilir, satır ikiye bölünmez
            const olcek = canvas.width / node.offsetWidth;
            const ustKenar = node.getBoundingClientRect().top;
            const kesimler = Array.from(node.querySelectorAll('tr, [data-pdf-blok]'))
                .map(el => Math.round((el.getBoundingClientRect().bottom - ustKenar) * olcek))
                .sort((a, b) => a - b);
            for (let y = 0, sayfa = 0; y < canvas.height; sayfa++) {
                const sinir = y + sayfaPx;
                const kesim = sinir >= canvas.height ? canvas.height
                    : (kesimler.filter(k => k > y && k <= sinir).pop() || sinir);
                const dilimH = kesim - y;
                const dilim = document.createElement('canvas');
                dilim.width = canvas.width;
                dilim.height = dilimH;
                dilim.getContext('2d').drawImage(canvas, 0, y, canvas.width, dilimH, 0, 0, canvas.width, dilimH);
                if (sayfa > 0) pdf.addPage();
                pdf.addImage(dilim.toDataURL('image/png'), 'PNG', margin, margin, sayfaW, dilimH * sayfaW / canvas.width);
                y = kesim;
            }
            pdf.save(`Fatura Kontrolü - ${teslimTarihMetni}.pdf`);
        } catch (error) {
            console.error('Fatura kontrol PDF oluşturulurken hata:', error);
            alert('PDF oluşturulurken bir hata oluştu.');
        } finally {
            setFaturaKontrolPdfLoading(false);
        }
    };

    const handleFaturaKontrolSiparisAc = (siparisId) => {
        setFaturaKontrolModalAcik(false);
        if (acikSiparisId !== siparisId) handleRowClick(siparisId);
    };

    const gosterilenSiparisler = suruklemeSirasi
        ? suruklemeSirasi.map(id => siparisler.find(s => s.id === id)).filter(Boolean)
        : siparisler;
    const filtrelenmisSiparisler = gosterilenSiparisler.filter(siparis => {
        const arama = aramaTerimi.toLowerCase();
        return siparis.ad_soyad.toLowerCase().includes(arama) ||
               siparis.telefon_numarasi.includes(arama);
    });

    // --- SIRALAMA (sadece admin; arama yapılırken kapalı, çünkü liste eksik görünür) ---
    const UZUN_BASMA_MS = 400;
    const siralamaAcik = userRole === 'admin' && !aramaTerimi;

    const uzunBasmaIptal = () => {
        if (uzunBasmaRef.current) {
            clearTimeout(uzunBasmaRef.current.timer);
            uzunBasmaRef.current = null;
        }
    };

    const handleSatirPointerDown = (e, siparisId) => {
        // Seçim kutusu ve butonlar normal çalışır
        if (!siralamaAcik || e.button !== 0 || e.target.closest('input, button, a, select, textarea, [data-surukleme-yok]')) return;
        uzunBasmaIptal();
        uzunBasmaRef.current = {
            x: e.clientX,
            y: e.clientY,
            timer: setTimeout(() => {
                uzunBasmaRef.current = null;
                tiklamaEngelleRef.current = true;
                setAcikSiparisId(null); // açık detay satırı sürüklemeyi bozmasın
                setSuruklemeSirasi(siparisler.map(s => s.id));
                setSuruklenenId(siparisId);
            }, UZUN_BASMA_MS)
        };
    };

    // Basılı tutarken fare kayarsa (metin seçimi vb.) uzun basma sayılmaz
    const handleSatirPointerMove = (e) => {
        const basma = uzunBasmaRef.current;
        if (basma && Math.hypot(e.clientX - basma.x, e.clientY - basma.y) > 10) uzunBasmaIptal();
    };

    useEffect(() => {
        if (suruklenenId === null) return;
        const ilkSira = suruklemeSirasiRef.current;
        let bitti = false;
        document.body.style.userSelect = 'none';
        document.body.style.cursor = 'grabbing';

        const hareket = (e) => {
            // Liste kutusunun üst/alt kenarına yaklaşınca kaydır
            const kutu = listeKutusuRef.current;
            if (kutu) {
                const r = kutu.getBoundingClientRect();
                if (e.clientY < r.top + 50) kutu.scrollTop -= 15;
                else if (e.clientY > r.bottom - 40) kutu.scrollTop += 15;
            }
            const hedef = document.elementFromPoint(e.clientX, e.clientY)?.closest('tr[data-siparis-id]');
            const hedefId = hedef ? Number(hedef.dataset.siparisId) : null;
            if (hedefId === null || hedefId === suruklenenId) return;
            setSuruklemeSirasi(onceki => {
                if (!onceki) return onceki;
                const yeni = onceki.filter(id => id !== suruklenenId);
                yeni.splice(onceki.indexOf(hedefId), 0, suruklenenId);
                return yeni;
            });
        };

        const birak = async () => {
            if (bitti) return;
            bitti = true;
            // Bırakınca gelen click satırın detayını açmasın; click'ten sonra engel kalkar
            setTimeout(() => { tiklamaEngelleRef.current = false; }, 0);
            const yeniSira = suruklemeSirasiRef.current;
            setSuruklenenId(null);
            setSuruklemeSirasi(null);
            if (!yeniSira || !ilkSira || yeniSira.join(',') === ilkSira.join(',')) return;

            siralamaGuncellemesiRef.current = true;
            setSiparisler(onceki => yeniSira.map(id => onceki.find(s => s.id === id)).filter(Boolean));
            try {
                const res = await fetch('/api/siparisler/siralama', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                    body: JSON.stringify({ siparisIds: yeniSira })
                });
                if (!res.ok) {
                    const data = await res.json().catch(() => ({}));
                    throw new Error(data.hata || `Status ${res.status}`);
                }
            } catch (error) {
                console.error('Sıralama kaydedilemedi:', error);
                alert(`Sıralama kaydedilemedi: ${error.message}`);
                fetchSiparisler();
            }
        };

        window.addEventListener('pointermove', hareket);
        window.addEventListener('pointerup', birak);
        window.addEventListener('pointercancel', birak);
        return () => {
            window.removeEventListener('pointermove', hareket);
            window.removeEventListener('pointerup', birak);
            window.removeEventListener('pointercancel', birak);
            document.body.style.userSelect = '';
            document.body.style.cursor = '';
        };
    }, [suruklenenId]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleRowClick = (siparisId) => {
        // Depo operatörü için detay ekranını kapat
        if (userRole === 'depo_operatoru') {
            return;
        }
        const yeniAcikId = acikSiparisId === siparisId ? null : siparisId;
        setAcikSiparisId(yeniAcikId);
        setActiveProformaIndex(0); // Her yeni satır açıldığında ana siparişe dön
        setActiveTekrarIndex(null);
        setGonderiTipi('G');
        if (yeniAcikId !== null) {
            setDetayData(null);
            // Yeni detay yüklenirken fatura bilgisi düzenleme modunu ve taslak kontrolünü kapat
            setFaturaDuzenlenen(null);
            setFaturaForm(null);
            setTaslakKontrol(null);
            setFaturaBagla(null);

            fetch(`/api/siparisler/${yeniAcikId}`, { cache: 'no-cache' })
                .then(res => res.json())
                .then(data => {
                    setDetayData(data);
                    // Aktif barkodu ana barkod olarak ayarla (ilk barkod)
                    setAktifBarkod(data.kargo_takip_no || '');
                    // Eğer fatura ID'si varsa otomatik durumu kontrol et (ek sipariş faturaları dahil)
                    if (data.parasut_fatura_id) {
                        checkFaturaStatusOtomatik(data.parasut_fatura_id);
                    }
                    (data.ek_siparisler || []).forEach(ek => {
                        if (ek.parasut_fatura_id) checkFaturaStatusOtomatik(ek.parasut_fatura_id);
                    });
                })
                .catch(error => console.error("Sipariş detayı çekilirken hata:", error));
        } else {
            setAktifBarkod(''); // Detay kapanınca aktif barkodu temizle
        }
    }; 

    // Detay bandı açılınca / barkod seçimi değişince aktif barkodun son 3 hareketini otomatik getirir.
    // Geç gelen yanıt başka barkoda geçildiyse yok sayılır.
    const kargoSorguBarkodRef = useRef(null);
    const handleQueryShipmentStatus = async (takipNo) => {
        kargoSorguBarkodRef.current = takipNo;
        setKargoSorguLoading(true);
        setKargoHareketleri([]); // Önceki sonuçları temizle
        try {
            const response = await fetch(`api/kargo-takip/${takipNo}?otomatik=1`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            const data = await response.json();
            if (!response.ok) { throw new Error(data.hata); }
            if (kargoSorguBarkodRef.current !== takipNo) return;
            setKargoHareketleri(Array.isArray(data) ? data : (data.durum_bilgisi || []));
        } catch (error) {
            if (kargoSorguBarkodRef.current === takipNo) {
                setKargoHareketleri([{ durum: `Kargo durumu sorgulanamadı: ${error.message}` }]);
            }
        } finally {
            if (kargoSorguBarkodRef.current === takipNo) setKargoSorguLoading(false);
        }
    };

    // Admin eski etiket seçtiyse hareketler (kaldırılana kadar) her zaman o barkoddan gösterilir
    const hareketBarkodu = detayData?.eski_etiket || aktifBarkod;
    useEffect(() => {
        if (hareketBarkodu) handleQueryShipmentStatus(hareketBarkodu);
        else {
            kargoSorguBarkodRef.current = null;
            setKargoHareketleri([]);
            setKargoSorguLoading(false);
        }
    }, [hareketBarkodu]);

    const handleEkBarkodOlustur = async () => {
        if (!detayData) return;

        const isConfirmed = window.confirm('Bu sipariş için ek bir barkod (kapıda ödemesiz) oluşturulacaktır. Emin misiniz?');
        if (!isConfirmed) return;

        try {
            const response = await fetch(`/api/siparisler/${detayData.id}/ek-barkod-olustur`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.hata || 'Ek barkod oluşturulamadı');
            }

            alert(data.mesaj);
            
            // Detay verilerini yenile
            const detayResponse = await fetch(`/api/siparisler/${detayData.id}`, { cache: 'no-cache' });
            const yeniDetay = await detayResponse.json();
            setDetayData(yeniDetay);
            
            // Yeni oluşturulan barkodu aktif yap
            setAktifBarkod(data.yeni_paket.kargo_takip_no);

        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };

    const handleDefterdGosterToggle = async (siparisId, e) => {
        if (e) e.stopPropagation(); // Satır tıklamasını engelle
        
        try {
            const response = await fetch(`/api/siparisler/${siparisId}/defterde-goster-toggle`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.hata || 'Defter durumu güncellenemedi');
            }

            // Listeyi yenile
            fetchSiparisler();
            alert(data.mesaj);

        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };

    const handleUpdatePttShipment = (siparisId) => {
        const message = "Sipariş bilgileri güncellenerek PTT için YENİ bir barkod oluşturulacaktır. Eski barkod geçersiz olacaktır. Emin misiniz?";
        const isConfirmed = window.confirm(message);
        if (isConfirmed) {
            handleEtiketYenile(siparisId);
        }
    };

    // --- FATURA BİLGİLERİ (Faturalama İşlemleri) ---
    // anahtar: 'ana' (ana sipariş) veya ek siparişin id'si
    const handleFaturaDuzenleBaslat = (anahtar, b) => {
        setFaturaForm({
            telefon: b.telefon || '',
            ad_soyad: b.ad_soyad || '',
            adres: b.adres || '',
            ilce: b.ilce || '',
            il: b.il || '',
            vergi_no: b.vergi_no || '',
            vergi_tipi: b.vergi_tipi || 'tc',
            vergi_dairesi: b.vergi_dairesi || ''
        });
        setFaturaDuzenlenen(anahtar);
    };

    const handleFaturaDuzenleIptal = () => {
        setFaturaDuzenlenen(null);
        setFaturaForm(null);
    };

    const handleFaturaBilgileriKaydet = async (anahtar) => {
        if (!faturaForm || !detayData) return;
        if (!faturaForm.ad_soyad.trim()) {
            alert('Fatura ismi boş bırakılamaz.');
            return;
        }
        const vergiNo = faturaForm.vergi_no.replace(/\D/g, '');
        if (faturaForm.vergi_tipi === 'vergi') {
            if (vergiNo.length !== 10) {
                alert('Vergi No 10 haneli olmalıdır.');
                return;
            }
            if (!faturaForm.vergi_dairesi.trim()) {
                alert('Vergi No seçildiğinde Vergi Dairesi zorunludur.');
                return;
            }
        } else if (vergiNo && vergiNo.length !== 11) {
            alert('T.C. Kimlik No 11 haneli olmalıdır.');
            return;
        }
        setFaturaKaydediliyor(true);
        try {
            const url = anahtar === 'ana'
                ? `/api/siparisler/${detayData.id}/fatura-bilgileri`
                : `/api/siparisler/${detayData.id}/ek-siparis/${anahtar}/fatura-bilgileri`;
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ ...faturaForm, vergi_no: vergiNo })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            setDetayData(prev => anahtar === 'ana'
                ? { ...prev, fatura_bilgileri: data.fatura_bilgileri }
                : {
                    ...prev,
                    ek_siparisler: (prev.ek_siparisler || []).map(ek =>
                        ek.id === anahtar ? { ...ek, fatura_bilgileri: data.fatura_bilgileri } : ek)
                });
            setFaturaDuzenlenen(null);
            setFaturaForm(null);
            setTaslakKontrol(null); // eski karşılaştırma sonucu geçersiz
        } catch (error) {
            alert(`Fatura bilgileri kaydedilemedi:\n${error.message}`);
        } finally {
            setFaturaKaydediliyor(false);
        }
    };

    // --- PARAŞÜT TASLAK FATURA KONTROL / GÜNCELLEME ---
    const taslakUrlKoku = (anahtar) => anahtar === 'ana'
        ? `/api/siparisler/${detayData.id}`
        : `/api/siparisler/${detayData.id}/ek-siparis/${anahtar}`;

    const taslakSonucunuIsle = (anahtar, sonuc) => {
        // Resmileşme tespit edildiyse backend sabitlenen bilgileri döndürür
        if (sonuc.fatura_bilgileri) {
            setDetayData(prev => anahtar === 'ana'
                ? { ...prev, fatura_bilgileri: sonuc.fatura_bilgileri }
                : { ...prev, ek_siparisler: (prev.ek_siparisler || []).map(ek =>
                    ek.id === anahtar ? { ...ek, fatura_bilgileri: sonuc.fatura_bilgileri } : ek) });
        }
        setTaslakKontrol({ anahtar, durum: 'hazir', sonuc });
    };

    const handleTaslakKontrol = async (anahtar) => {
        if (faturaDuzenlenen !== null) {
            alert('Fatura bilgilerinde kaydedilmemiş değişiklik var. Lütfen önce Kaydet veya İptal ile düzenlemeyi tamamlayın.');
            return;
        }
        setTaslakKontrol({ anahtar, durum: 'yukleniyor', sonuc: null });
        try {
            const response = await fetch(`${taslakUrlKoku(anahtar)}/fatura-taslak-kontrol`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            taslakSonucunuIsle(anahtar, data);
        } catch (error) {
            setTaslakKontrol({ anahtar, durum: 'hazir', sonuc: { hata: error.message } });
        }
    };

    const handleTaslakGuncelle = async (anahtar) => {
        if (!window.confirm('Listelenen değişiklikler Paraşüt\'teki taslak faturaya işlenecektir. Emin misiniz?')) return;
        setTaslakKontrol(prev => ({ ...prev, durum: 'guncelleniyor' }));
        try {
            const response = await fetch(`${taslakUrlKoku(anahtar)}/fatura-taslak-guncelle`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            taslakSonucunuIsle(anahtar, data);
        } catch (error) {
            setTaslakKontrol({ anahtar, durum: 'hazir', sonuc: { hata: `Taslak güncellenemedi: ${error.message}` } });
        }
    };

    // Taslak (resmileşmemiş) faturanın Paraşüt önizlemesini yeni sekmede açar
    const [taslakOnizleniyor, setTaslakOnizleniyor] = useState({}); // Fatura ID'lerine göre
    const handleTaslakOnizleme = async (faturaId) => {
        setTaslakOnizleniyor(prev => ({ ...prev, [faturaId]: true }));
        try {
            await taslakOnizlemeAc(faturaId);
        } catch (error) {
            alert(`Fatura önizlemesi açılamadı:\n${error.message}`);
        } finally {
            setTaslakOnizleniyor(prev => ({ ...prev, [faturaId]: false }));
        }
    };

    // Fatura kesilmiş ama resmileşmemiş siparişte buton grubu: Resmileştir | Önizleme | Kontrol | İptal Et
    // Kontrol sonucu (farklar ve Güncelle) grubun altında gösterilir.
    const renderTaslakIslemleri = (anahtar, faturaId) => {
        const aktif = taslakKontrol?.anahtar === anahtar ? taslakKontrol : null;
        const mesgul = aktif && aktif.durum !== 'hazir';
        const sonuc = aktif?.durum === 'hazir' ? aktif.sonuc : null;
        const resmilestiriliyor = !!resmilestirLoading[faturaId];
        const iptalEdiliyor = !!faturaIptalEdiliyor[faturaId];
        const onizleniyor = !!taslakOnizleniyor[faturaId];
        const resmilestirPasif = isButtonDisabled() || resmilestiriliyor || iptalEdiliyor || !faturaStatuslari[faturaId];
        const kontrolPasif = isButtonDisabled() || mesgul || iptalEdiliyor;
        const iptalPasif = isButtonDisabled() || iptalEdiliyor || resmilestiriliyor || mesgul;
        const onizlemePasif = onizleniyor || iptalEdiliyor;
        const butonStili = islemButonStili;
        return (
            <div style={{ fontFamily: 'Poppins, sans-serif' }} onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <button type="button" style={butonStili(resmilestirPasif, resmilestiriliyor)} disabled={resmilestirPasif}
                        onClick={() => handleResmilestir(faturaId)}
                        title={!faturaStatuslari[faturaId] ? 'Fatura durumu kontrol ediliyor...' : 'Faturayı resmileştir (e-fatura / e-arşiv)'}>
                        {islemIkonu(ResmilestirIcon, '')}
                        <span>{resmilestiriliyor ? 'Resmileştiriliyor...' : 'Resmileştir'}</span>
                    </button>
                    <button type="button" style={butonStili(onizlemePasif, onizleniyor)} disabled={onizlemePasif}
                        onClick={() => handleTaslakOnizleme(faturaId)}
                        title="Faturanın Paraşüt önizlemesini aç (resmileştirmeden)">
                        {islemIkonu(OnizlemeIcon, '')}
                        <span>{onizleniyor ? 'Açılıyor...' : 'Önizleme'}</span>
                    </button>
                    <button type="button" style={butonStili(kontrolPasif, mesgul)} disabled={kontrolPasif}
                        onClick={() => handleTaslakKontrol(anahtar)}
                        title="Taslağı siparişin güncel haliyle karşılaştır">
                        {islemIkonu(CheckIcon, '')}
                        <span>{aktif?.durum === 'yukleniyor' ? 'Kontrol...' : 'Kontrol'}</span>
                    </button>
                    <button type="button" style={butonStili(iptalPasif, iptalEdiliyor)} disabled={iptalPasif}
                        onClick={() => handleFaturaIptal(faturaId, false)}
                        title="Fatura taslağını iptal et">
                        <img src={CrossIconRed} alt="" style={{ height: '22px', margin: '0 -3px' }} />
                        <span>{iptalEdiliyor ? 'İptal ediliyor...' : 'İptal Et'}</span>
                    </button>
                </div>

                {aktif?.durum === 'guncelleniyor' && (
                    <p style={{ fontSize: '12px', color: '#666', margin: '8px 0 0 0' }}>Taslak fatura güncelleniyor...</p>
                )}
                {sonuc && (
                    <div style={{ marginTop: '8px', border: '1px solid #eee', borderRadius: '4px', background: '#fff', padding: '10px', fontSize: '12px' }}>
                        {sonuc.hata ? (
                            <p style={{ margin: 0, color: '#dc3545' }}>{sonuc.hata}</p>
                        ) : sonuc.resmilesti ? (
                            <p style={{ margin: 0, color: '#666' }}>{sonuc.mesaj || 'Fatura resmileştiği için güncellenemez.'}</p>
                        ) : (sonuc.farklar || []).length === 0 ? (
                            <p style={{ margin: 0, color: '#28a745', fontWeight: '600' }}>
                                {sonuc.mesaj === 'Taslak fatura güncellendi.' ? 'Taslak fatura güncellendi, ' : ''}Taslak, siparişin güncel haliyle aynı.
                            </p>
                        ) : (
                            <>
                                <p style={{ margin: '0 0 8px 0', fontWeight: '600', color: '#c0392b' }}>{sonuc.mesaj}</p>
                                {sonuc.farklar.map((f, i) => (
                                    <div key={i} style={{ padding: '5px 0', borderTop: i ? '1px solid #f2f2f2' : 'none' }}>
                                        <div style={{ fontWeight: '600', color: '#333' }}>{f.alan}</div>
                                        <div style={{ color: '#888', textDecoration: 'line-through' }}>{f.mevcut || '—'}</div>
                                        <div style={{ color: '#1565C0' }}>{f.yeni || '—'}</div>
                                    </div>
                                ))}
                                <button type="button" style={{ ...butonStili(kontrolPasif, mesgul), marginTop: '8px' }} disabled={kontrolPasif}
                                    onClick={() => handleTaslakGuncelle(anahtar)}
                                    title="Listelenen değişiklikleri Paraşüt'teki taslağa işle">
                                    {islemIkonu(UndoIcon, '')}
                                    <span>Güncelle</span>
                                </button>
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    };

    // Faturalama İşlemleri'ndeki bilgi paneli. anahtar: 'ana' veya ek sipariş id'si.
    // duzenlenebilir=false ise (fatura kesilmişse) sadece gösterilir.
    const renderFaturaBilgileri = (anahtar, b, duzenlenebilir, faturaVar = false) => {
        if (!b) return null;
        const aktif = duzenlenebilir && faturaDuzenlenen === anahtar && faturaForm;
        const degerler = aktif ? faturaForm : b;
        const degisenler = duzenlenebilir ? (b.degistirilen_alanlar || []) : [];
        const alanStili = {
            width: '100%',
            padding: '5px 8px',
            border: '1px solid #ccc',
            borderRadius: '3px',
            fontSize: '13px',
            fontFamily: 'Poppins, sans-serif',
            boxSizing: 'border-box',
            backgroundColor: aktif ? 'white' : '#f1f1f1',
            color: aktif ? '#000' : '#555'
        };
        const etiketStili = { fontSize: '12px', fontWeight: '600', display: 'block', margin: '0 0 3px 0', color: '#333' };
        const degisti = (alan) => !aktif && degisenler.includes(alan) && (
            <span title="Varsayılan sipariş bilgisinden farklı" style={{ color: '#1565C0', fontWeight: '500', marginLeft: '5px' }}>(değiştirildi)</span>
        );
        const guncelle = (alan) => (e) => setFaturaForm(prev => ({ ...prev, [alan]: e.target.value }));
        const butonStili = {
            padding: '5px 14px',
            fontSize: '13px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            background: '#f8f8f8',
            fontFamily: 'Poppins, sans-serif',
            cursor: faturaKaydediliyor ? 'wait' : 'pointer'
        };

        return (
            <div style={{ marginBottom: '15px', border: '1px solid #eee', padding: '12px', borderRadius: '4px', background: '#f9f9f9' }}
                onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                    <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#333' }}>Fatura Bilgileri</h4>
                    {duzenlenebilir && faturaDuzenlenen === null && !isButtonDisabled() && (
                        <img src={EditIcon} alt="Düzenle" title="Fatura bilgilerini düzenle"
                            onClick={() => handleFaturaDuzenleBaslat(anahtar, b)}
                            style={{ height: '16px', cursor: 'pointer' }} />
                    )}
                </div>

                <div style={{ marginBottom: '8px' }}>
                    <label style={etiketStili}>Telefon Numarası{degisti('telefon')}</label>
                    <input type="text" value={degerler.telefon} disabled={!aktif} onChange={guncelle('telefon')} style={alanStili} />
                </div>
                <div style={{ marginBottom: '8px' }}>
                    <label style={etiketStili}>İsim / Ünvan{degisti('ad_soyad')}</label>
                    <input type="text" value={degerler.ad_soyad} disabled={!aktif} onChange={guncelle('ad_soyad')} style={alanStili} />
                    {!aktif && b.eft_odeme_yapan && !degisenler.includes('ad_soyad') && (
                        <p style={{ margin: '3px 0 0 0', fontSize: '11px', color: '#666' }}>EFT ödeme kaydındaki ödeme yapan kişi</p>
                    )}
                </div>
                <div style={{ marginBottom: '8px' }}>
                    <label style={etiketStili}>Adres{(degisti('adres') || degisti('ilce') || degisti('il'))}</label>
                    <textarea value={degerler.adres} disabled={!aktif} onChange={guncelle('adres')} rows={2}
                        style={{ ...alanStili, resize: 'vertical', marginBottom: '5px' }} />
                    <div style={{ display: 'flex', gap: '5px' }}>
                        <input type="text" placeholder="İlçe" value={degerler.ilce} disabled={!aktif} onChange={guncelle('ilce')} style={alanStili} />
                        <input type="text" placeholder="İl" value={degerler.il} disabled={!aktif} onChange={guncelle('il')} style={alanStili} />
                    </div>
                </div>
                <div style={{ marginBottom: aktif ? '12px' : 0 }}>
                    {/* T.C. Kimlik No (11 hane) / Vergi No (10 hane + vergi dairesi) seçimi */}
                    <div style={{ display: 'flex', gap: '6px', marginBottom: '5px' }}>
                        {[['tc', 'T.C. Kimlik No'], ['vergi', 'Vergi No']].map(([tip, etiket]) => {
                            const secili = (degerler.vergi_tipi || 'tc') === tip;
                            return (
                                <button key={tip} type="button" disabled={!aktif}
                                    onClick={() => setFaturaForm(prev => ({
                                        ...prev,
                                        vergi_tipi: tip,
                                        // Tip değişince numara diğer tipe uymaz: T.C.'de varsayılan, Vergi'de boş başlar
                                        vergi_no: tip === prev.vergi_tipi ? prev.vergi_no : (tip === 'tc' ? '11111111111' : ''),
                                        vergi_dairesi: tip === 'tc' ? '' : prev.vergi_dairesi
                                    }))}
                                    style={{
                                        flex: 1,
                                        padding: '4px 8px',
                                        fontSize: '12px',
                                        fontFamily: 'Poppins, sans-serif',
                                        fontWeight: secili ? '600' : '400',
                                        border: '1px solid #ccc',
                                        borderRadius: '3px',
                                        background: secili ? '#1565C0' : (aktif ? 'white' : '#f1f1f1'),
                                        color: secili ? 'white' : '#555',
                                        cursor: aktif ? 'pointer' : 'default',
                                        opacity: !aktif && !secili ? 0.6 : 1
                                    }}>
                                    {etiket}
                                </button>
                            );
                        })}
                    </div>
                    <label style={etiketStili}>
                        {(degerler.vergi_tipi || 'tc') === 'vergi' ? 'Vergi No (10 hane)' : 'T.C. Kimlik No (11 hane)'}{degisti('vergi_no')}
                    </label>
                    <input type="text" inputMode="numeric"
                        maxLength={(degerler.vergi_tipi || 'tc') === 'vergi' ? 10 : 11}
                        value={degerler.vergi_no} disabled={!aktif} onChange={guncelle('vergi_no')} style={alanStili} />
                    {(degerler.vergi_tipi || 'tc') === 'vergi' && (
                        <div style={{ marginTop: '8px' }}>
                            <label style={etiketStili}>Vergi Dairesi{degisti('vergi_dairesi')}</label>
                            <input type="text" value={degerler.vergi_dairesi || ''} disabled={!aktif} onChange={guncelle('vergi_dairesi')} style={alanStili} />
                        </div>
                    )}
                </div>

                {aktif && (
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                        <button onClick={handleFaturaDuzenleIptal} disabled={faturaKaydediliyor} style={butonStili}>İptal</button>
                        <button onClick={() => handleFaturaBilgileriKaydet(anahtar)} disabled={faturaKaydediliyor} style={butonStili}>
                            {faturaKaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
                        </button>
                    </div>
                )}
                {!duzenlenebilir && (
                    <p style={{ fontSize: '11px', margin: '8px 0 0 0', color: '#666' }}>
                        Fatura resmileştiği için bilgiler değiştirilemez.
                    </p>
                )}
                {duzenlenebilir && faturaVar && !aktif && (
                    <p style={{ fontSize: '11px', margin: '8px 0 0 0', color: '#666' }}>
                        Fatura taslağı Paraşüt'te. Bilgileri değiştirdikten sonra "Kontrol" ve "Güncelle" ile taslağa işleyebilirsiniz.
                    </p>
                )}
            </div>
        );
    };

    // Açık sipariş detayını (fatura bağlantıları, iptal geçmişi) yeniler; detay kapanmaz, aktif sekme korunur
    const faturaDetayYenile = async () => {
        if (!acikSiparisId) return;
        try {
            const res = await fetch(`/api/siparisler/${acikSiparisId}`, { cache: 'no-cache' });
            const data = await res.json();
            setDetayData(data);
            [data.parasut_fatura_id, ...(data.ek_siparisler || []).map(ek => ek.parasut_fatura_id)]
                .filter(Boolean)
                .forEach(id => checkFaturaStatusOtomatik(id));
        } catch (err) {
            console.error('Detay yenileme hatası:', err);
        }
    };

    // Paraşüt'te doğrudan kesilmiş faturayı fatura numarasıyla siparişe (veya ek siparişe) bağlar
    const handleFaturaBagla = async (anahtar) => {
        const numara = (faturaBagla?.numara || '').trim();
        if (!numara) { alert('Fatura numarası giriniz.'); return; }
        setFaturaBagla(prev => ({ ...prev, bagliyor: true }));
        try {
            const response = await fetch(`${taslakUrlKoku(anahtar)}/fatura-bagla`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                body: JSON.stringify({ fatura_no: numara })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            alert(`✅ ${data.mesaj}`);
            setFaturaBagla(null);
            await faturaDetayYenile();
        } catch (error) {
            alert(`Fatura bağlanamadı:\n${error.message}`);
            setFaturaBagla(prev => prev ? { ...prev, bagliyor: false } : prev);
        }
    };

    // Taslak (resmi=false) veya resmileşmiş faturayı iptal eder; sipariş E-Fatura Oluştur / Bağla aşamasına döner
    const handleFaturaIptal = async (faturaId, resmi) => {
        if (isButtonDisabled() || faturaIptalEdiliyor[faturaId]) return;
        if (faturaDuzenlenen !== null) {
            alert('Fatura bilgilerinde kaydedilmemiş değişiklik var. Lütfen önce Kaydet veya İptal ile düzenlemeyi tamamlayın.');
            return;
        }
        const soru = faturaStatuslari[faturaId]?.iptal_edildi
            ? 'Bu fatura Paraşüt\'te zaten iptal edilmiş.\n\nSistemde de iptal edilecek ve sipariş "E-Fatura Oluştur / E-Fatura Bağla" aşamasına dönecek. Emin misiniz?'
            : resmi
            ? 'Resmileşmiş fatura iptal edilecek.\n\nSadece son kullanıcı (11111111111) faturaları, fatura tarihinden itibaren 7 gün içinde iptal edilebilir.\n\nBu işlem GERİ ALINAMAZ. Emin misiniz?'
            : 'Fatura taslağı Paraşüt\'ten silinerek iptal edilecek ve sipariş "E-Fatura Oluştur / E-Fatura Bağla" aşamasına dönecek.\n\nEmin misiniz?';
        if (!window.confirm(soru)) return;

        setFaturaIptalEdiliyor(prev => ({ ...prev, [faturaId]: true }));
        try {
            const response = await fetch(`/api/faturalar/${faturaId}/iptal`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Kod ${response.status})`);
            alert(`✅ ${data.mesaj}`);
            setTaslakKontrol(null);
            await faturaDetayYenile();
        } catch (error) {
            alert(`Fatura iptal edilemedi:\n${error.message}`);
        } finally {
            setFaturaIptalEdiliyor(prev => ({ ...prev, [faturaId]: false }));
        }
    };

    // Fatura kesilmemişken: E-Fatura Oluştur | E-Fatura Bağla (bağlamada fatura numarası sorulur)
    const renderFaturaOlusturBagla = (anahtar, onOlustur, etiket = '') => {
        const baglaAcik = faturaBagla?.anahtar === anahtar;
        const pasif = isButtonDisabled();
        const butonStili = {
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', flex: 1, minWidth: 0,
            padding: '10px', cursor: pasif ? 'not-allowed' : 'pointer', fontFamily: 'poppins', background: '#f8f8f8',
            border: '1px solid #ccc', borderRadius: '4px', opacity: pasif ? '0.5' : '1', whiteSpace: 'nowrap'
        };
        const kucukButon = { padding: '5px 14px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', background: '#f8f8f8', fontFamily: 'Poppins, sans-serif', cursor: faturaBagla?.bagliyor ? 'wait' : 'pointer' };
        const kaydedilmemisVar = () => {
            if (faturaDuzenlenen === null) return false;
            alert('Fatura bilgilerinde kaydedilmemiş değişiklik var. Lütfen önce Kaydet veya İptal ile düzenlemeyi tamamlayın.');
            return true;
        };
        return (
            <div style={{ marginBottom: '15px' }} onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button style={butonStili} disabled={pasif}
                        onClick={() => { if (!pasif && !kaydedilmemisVar()) onOlustur(); }}>
                        <img src={ParasutLogo} alt="E-Fatura Oluştur" style={{ height: '16px' }} />
                        <span>E-Fatura Oluştur{etiket}</span>
                    </button>
                    <button style={{ ...butonStili, ...(baglaAcik ? { background: '#e9ecef', borderColor: '#999' } : {}) }} disabled={pasif}
                        title="Paraşüt'te doğrudan kesilmiş faturayı fatura numarasıyla bu siparişe bağla"
                        onClick={() => {
                            if (pasif || kaydedilmemisVar()) return;
                            setFaturaBagla(baglaAcik ? null : { anahtar, numara: '', bagliyor: false });
                        }}>
                        <img src={ParasutLogo} alt="E-Fatura Bağla" style={{ height: '16px' }} />
                        <span>E-Fatura Bağla</span>
                    </button>
                </div>
                {baglaAcik && (
                    <div style={{ marginTop: '8px', border: '1px solid #eee', borderRadius: '4px', background: '#f9f9f9', padding: '10px', fontFamily: 'Poppins, sans-serif' }}>
                        <label style={{ fontSize: '12px', fontWeight: '600', display: 'block', margin: '0 0 4px 0', color: '#333' }}>Fatura numarası giriniz</label>
                        <input type="text" autoFocus value={faturaBagla.numara} disabled={faturaBagla.bagliyor}
                            placeholder="Ör. SYP2026000000123"
                            onChange={(e) => setFaturaBagla(prev => ({ ...prev, numara: e.target.value }))}
                            onKeyDown={(e) => { if (e.key === 'Enter') handleFaturaBagla(anahtar); if (e.key === 'Escape') setFaturaBagla(null); }}
                            style={{ width: '100%', padding: '5px 8px', border: '1px solid #ccc', borderRadius: '3px', fontSize: '13px', fontFamily: 'Poppins, sans-serif', boxSizing: 'border-box' }} />
                        <p style={{ fontSize: '11px', margin: '4px 0 8px 0', color: '#666' }}>
                            Paraşüt'teki fatura numarası (veya fatura sayfasının bağlantısı) girilebilir.
                        </p>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <button style={kucukButon} disabled={faturaBagla.bagliyor} onClick={() => setFaturaBagla(null)}>Vazgeç</button>
                            <button style={kucukButon} disabled={faturaBagla.bagliyor} onClick={() => handleFaturaBagla(anahtar)}>
                                {faturaBagla.bagliyor ? 'Bağlanıyor...' : 'Bağla'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // İptal edilen faturaların geçmişi (fatura bölümünün altında her zaman gösterilir)
    const renderIptalGecmisi = (liste) => (liste || []).length === 0 ? null : (
        <div style={{ marginTop: '10px', fontSize: '12px', fontFamily: 'Poppins, sans-serif' }}>
            {liste.map((f, i) => (
                <div key={`${f.fatura_id}-${i}`} style={{ padding: '6px 10px', marginTop: i ? '4px' : 0, border: '1px solid #f5c2c7', background: '#fdecee', color: '#842029', borderRadius: '4px' }}>
                    {f.tur === 'resmi'
                        ? `${f.fatura_no || f.fatura_id} nolu fatura iptal edildi.`
                        : `${f.fatura_id} nolu fatura taslağı iptal edildi.`}
                    <span style={{ color: '#888', marginLeft: '6px' }}>{f.tarih}{f.kullanici ? ` · ${f.kullanici}` : ''}</span>
                </div>
            ))}
        </div>
    );

    const handleCreateParasutInvoice = async (siparisId, ozelFaturaKisiAdi = null) => {
        const isConfirmed = window.confirm('Bu sipariş için Paraşüt\'te fatura taslağı oluşturulacaktır. Emin misiniz?');
        if (!isConfirmed) return;

        const token = localStorage.getItem('token');
        if (!token) {
            alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
            window.location.href = '/login';
            return;
        }

        try {
            // faturaKisiAdi boşsa backend, Faturalama İşlemleri'nde kaydedilen fatura bilgilerini kullanır
            const response = await fetch(`/api/siparisler/${siparisId}/fatura-olustur`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    faturaKisiAdi: ozelFaturaKisiAdi
                })
            });

            if (response.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }

            const data = await response.json();
            if (!response.ok) {
                const hataMesaji = data?.hata || `Sunucu hatası (Kod ${response.status})`;
                throw new Error(hataMesaji);
            }

            alert(`${data.mesaj}\nFatura ID: ${data.faturaId}\nDurum: ${data.faturaDurumu}`);
            handleRowClick(siparisId);
            
            // Yeni fatura oluşturulduktan sonra otomatik durumu kontrol et
            if (data.faturaId) {
                setTimeout(() => {
                    checkFaturaStatusOtomatik(data.faturaId);
                }, 1000); // 1 saniye bekle
            }

        } catch (error) {
            console.error("Paraşüt Faturası oluşturulurken hata:", error);
            alert(`Fatura oluşturulamadı:\n${error.message}`);
        }
    };

    const handleUpdateParasutInvoice = async (siparisId) => {
        const isConfirmed = window.confirm('Bu siparişin Paraşüt\'teki faturası güncellenecektir. Emin misiniz?');
        if (!isConfirmed) return;

        const token = localStorage.getItem('token');
        if (!token) {
            alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
            return;
        }

        try {
            const response = await fetch(`api/siparisler/${siparisId}/fatura-guncelle`, {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            
            if (response.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }
            
            const data = await response.json();
            if (!response.ok) { throw new Error(data.hata); }

            alert(`${data.mesaj}\nFatura ID: ${data.faturaId}\nYeni Durum: ${data.faturaDurumu}`);
            handleRowClick(siparisId); // Detayları yenile

        } catch (error) {
            console.error("Paraşüt Faturası güncellenirken hata:", error);
            alert(`Hata: ${error.message}`);
        }
    };

    const handleDownloadInvoicePdf = async (faturaId) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                return;
            }

            // PDF indirme isteği
            const response = await fetch(`/api/faturalar/${faturaId}/download`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.hata || 'PDF indirilemedi');
            }

            // PDF blob'unu oluştur
            const blob = await response.blob();
            
            // PDF'i indir
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `fatura_${faturaId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("PDF indirirken hata:", error);
            alert(`PDF indirilemedi: ${error.message}`);
        }
    };

    // Fatura durum etiketi (Faturalama başlığında yalnızca "Paraşüt'te İptal Edildi" için kullanılıyor): true -> yeşil "Resmileşti", false -> kırmızı "Gönderildi, Resmileşmedi", null -> kontrol ediliyor
    const renderFaturaDurumEtiketi = (resmilesti, iptalEdildi = false) => {
        if (iptalEdildi) resmilesti = 'iptal';
        const renk = resmilesti === null ? { yazi: '#666', zemin: '#f2f2f2', kenar: '#ddd' }
            : resmilesti === 'iptal' ? { yazi: '#842029', zemin: '#f8d7da', kenar: '#842029' }
            : resmilesti ? { yazi: '#28a745', zemin: '#eaf7ed', kenar: '#28a745' }
            : { yazi: '#dc3545', zemin: '#fdecee', kenar: '#dc3545' };
        return (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '2px 10px', borderRadius: '12px', textTransform: 'none', whiteSpace: 'nowrap', border: `1px solid ${renk.kenar}`, background: renk.zemin, color: renk.yazi, fontSize: '12px', fontWeight: '600', fontFamily: 'Poppins, sans-serif' }}>
                <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: renk.yazi }} />
                {resmilesti === null ? 'Durum kontrol ediliyor...' : resmilesti === 'iptal' ? "Paraşüt'te İptal Edildi" : resmilesti ? 'Resmileşti' : 'Gönderildi, Resmileşmedi'}
            </div>
        );
    };

    // Toplu Paraşüt işlemlerinde (Gönder, Resmileştir) istek sınırına takılmamak için her 8 siparişten sonra 10 sn beklenir
    const PARASUT_GRUP_BOYUTU = 8;
    const PARASUT_GRUP_BEKLEMESI_MS = 10000;
    const parasutGrupBeklemesi = async (islenen, toplam, setIlerleme) => {
        if (islenen % PARASUT_GRUP_BOYUTU !== 0 || islenen >= toplam) return;
        for (let kalan = PARASUT_GRUP_BEKLEMESI_MS / 1000; kalan > 0; kalan--) {
            setIlerleme(`${islenen}/${toplam} · ${kalan} sn`);
            await new Promise(r => setTimeout(r, 1000));
        }
    };

    const handleResmilestir = async (faturaId) => {
        if (isButtonDisabled() || resmilestirLoading[faturaId]) return;
        // Ek sipariş faturaları da ana siparişin ödemesine bağlıdır (ödeme sipariş bazında tutulur)
        if (detayData && odemeYapilmadi(detayData)) {
            alert(`⚠️ Ödeme yapılmadı!\n\n#${detayData.siparis_no} siparişi Ödeme Takibi'nde "Ödenmedi" görünüyor. Ödeme alınmadan fatura resmileştirilemez.`);
            return;
        }
        if (!window.confirm('Fatura resmileştirilecek ve alıcıya e-fatura / e-arşiv olarak düzenlenecek.\n\nBu işlem GERİ ALINAMAZ. Fatura bilgileri ve kalemleri doğru mu?')) return;

        setResmilestirLoading(prev => ({ ...prev, [faturaId]: true }));
        try {
            const sonuc = await parasutResmilestir(faturaId);
            alert(sonuc.devamEdiyor
                ? `${sonuc.belge_turu} işlemi Paraşüt'te devam ediyor. Birkaç dakika sonra sayfayı yenileyip kontrol edin.`
                : `✅ Fatura ${sonuc.belge_turu} olarak resmileştirildi.`);
            // Fatura no ve sabitlenen fatura bilgileri durum sorgusuyla güncellenir
            await checkFaturaStatusOtomatik(faturaId);
        } catch (error) {
            console.error("Resmileştirme hatası:", error);
            alert(`Resmileştirme hatası: ${error.message}`);
        } finally {
            setResmilestirLoading(prev => ({ ...prev, [faturaId]: false }));
        }
    };

    const handleCheckInvoiceStatus = async (faturaId, siparisId) => {
        // Loading state'i başlat
        setResmilestirLoading(prev => ({ ...prev, [faturaId]: true }));

        try {
            const response = await fetch(`api/faturalar/${faturaId}/durum`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            const data = await response.json();
            if (!response.ok) { throw new Error(data.hata); }

            if (data.is_finalized) {
                // Resmileşmiş fatura bilgilerini göster
                const faturaBilgi = data.fatura_bilgileri;
                let mesaj = "✅ FATURA RESMİLEŞTİRİLMİŞ!\n\n";
                mesaj += `Fatura No: ${faturaBilgi.fatura_no}\n`;
                mesaj += `Durum: ${faturaBilgi.durum}\n`;
                mesaj += `Tutar: ${faturaBilgi.tutar} ${faturaBilgi.para_birimi}\n`;
                if (faturaBilgi.duzenlenme_tarihi) {
                    mesaj += `Düzenlenme Tarihi: ${faturaBilgi.duzenlenme_tarihi}\n`;
                }
                
                alert(mesaj);
                
                // Veritabanındaki durumu da güncelle
                const ilgili_siparis = siparisler.find(s => s.id === siparisId);
                if (ilgili_siparis && ilgili_siparis.parasut_fatura_durumu !== 'issued') {
                    handleRowClick(siparisId); // Detayları yenile
                }
            } else {
                // Henüz resmileşmemiş
                alert(`❌ ${data.mesaj}\n\nParaşüt panelinden manuel resmileştirme yapılması gerekiyor.`);
            }

        } catch (error) {
            console.error("Fatura durumu kontrol edilirken hata:", error);
            alert(`Hata: ${error.message}`);
        } finally {
            // Loading state'i bitir
            setResmilestirLoading(prev => ({ ...prev, [faturaId]: false }));
        }
    };
    
    // Tarih filtresini temizler
    const handleFiltreyiTemizle = () => {
        setSeciliTarih('');
    };
    
    const handleSiparisDuzenle = (siparisId) => {
        if (isButtonDisabled()) return;
        // navigate(`/siparis/duzenle/${siparisId}`); // ESKİ HALİ
        handleModalOpen(siparisId); // YENİ HALİ
    };

    // --- EK SİPARİŞ FONKSİYONLARI ---
    const handleEkSiparisAc = (siparis) => {
        if (isButtonDisabled()) return;
        setEkSiparisAnaSiparisId(siparis.id);
        setEkSiparisEditId(null);
        setEkSiparisInitialData({
            musteri: siparis.musteri,
            siparis_kaynagi: siparis.siparis_kaynagi,
            odeme_yontemi: siparis.odeme_yontemi,
        });
        setEkSiparisModalAcik(true);
    };

    const handleEkSiparisModalKapat = (refresh) => {
        setEkSiparisModalAcik(false);
        setEkSiparisAnaSiparisId(null);
        setEkSiparisInitialData(null);
        setEkSiparisEditId(null);
        if (refresh && acikSiparisId) {
            fetch(`/api/siparisler/${acikSiparisId}`, { cache: 'no-cache' })
                .then(res => res.json())
                .then(data => {
                    setDetayData(data);
                    // Yeni eklenen ek siparişe geç
                    const ekSayisi = data.ek_siparisler ? data.ek_siparisler.length : 0;
                    if (ekSayisi > 0) setActiveProformaIndex(ekSayisi);
                })
                .catch(err => console.error('Detay yenileme hatası:', err));
        }
    };

    const handleEkSiparisDuzenleAc = (siparis, ekSiparisId) => {
        if (isButtonDisabled()) return;
        const ek = siparis.ek_siparisler.find(e => e.id === ekSiparisId);
        if (!ek) return;
        setEkSiparisAnaSiparisId(siparis.id);
        setEkSiparisEditId(ekSiparisId);
        setEkSiparisInitialData({
            musteri: siparis.musteri,
            siparis_kaynagi: ek.siparis_kaynagi,
            odeme_yontemi: ek.odeme_yontemi,
            sepet: ek.sepet,
        });
        setEkSiparisModalAcik(true);
    };

    const handleEkSiparisModalKapatEdit = (refresh) => {
        const prevAnaSiparisId = ekSiparisAnaSiparisId;
        setEkSiparisModalAcik(false);
        setEkSiparisAnaSiparisId(null);
        setEkSiparisInitialData(null);
        setEkSiparisEditId(null);
        if (refresh && acikSiparisId) {
            fetch(`/api/siparisler/${acikSiparisId}`, { cache: 'no-cache' })
                .then(res => res.json())
                .then(data => setDetayData(data))
                .catch(err => console.error('Detay yenileme hatası:', err));
        }
    };

    // --- TEKRAR GÖNDERİM FONKSİYONLARI ---
    const handleTekrarGonderAc = (siparis) => {
        if (isButtonDisabled()) return;
        setTekrarModalSiparisId(siparis.id);
    };

    const tekrarDetayYenile = (sonTekrariSec) => {
        if (!acikSiparisId) return;
        fetch(`/api/siparisler/${acikSiparisId}`, { cache: 'no-cache' })
            .then(res => res.json())
            .then(data => {
                setDetayData(data);
                const tekrarlar = data.tekrar_gonderimler || [];
                if (sonTekrariSec && tekrarlar.length > 0) {
                    const son = tekrarlar[tekrarlar.length - 1];
                    setActiveProformaIndex(0);
                    setActiveTekrarIndex(tekrarlar.length - 1);
                    if (son.kargo_takip_no) setAktifBarkod(son.kargo_takip_no);
                } else {
                    setActiveTekrarIndex(null);
                    setAktifBarkod(data.kargo_takip_no || '');
                }
            })
            .catch(err => console.error('Detay yenileme hatası:', err));
    };

    const handleTekrarModalKapat = (refresh) => {
        setTekrarModalSiparisId(null);
        if (refresh) tekrarDetayYenile(true);
    };

    const handleTekrarGonderimSil = async (anaSiparisId, tekrar) => {
        if (!window.confirm(`Tekrar-${tekrar.sira} kaydı silinecek; bu gönderimde stoktan düşülen (yeni eklenen) ürünler iade edilecek. PTT'deki barkod iptal edilmez. Emin misiniz?`)) return;
        try {
            const response = await fetch(`/api/siparisler/${anaSiparisId}/tekrar-gonderim/${tekrar.id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            alert(data.mesaj);
            tekrarDetayYenile(false);
        } catch (err) {
            alert(`Hata: ${err.message}`);
        }
    };

    const handleEkFaturaOlustur = async (anaSiparisId, ekId, kisiAdi) => {
        const isConfirmed = window.confirm('Bu ek sipariş için Paraşüt\'te fatura taslağı oluşturulacaktır. Emin misiniz?');
        if (!isConfirmed) return;
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/siparisler/${anaSiparisId}/ek-siparis/${ekId}/fatura-olustur`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ faturaKisiAdi: kisiAdi || null })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            alert(`${data.mesaj}\nFatura ID: ${data.faturaId}`);
            handleRowClick(acikSiparisId);
        } catch (err) {
            alert(`Hata: ${err.message}`);
        }
    };

    const handleEkSiparisSil = async (anaSiparisId, ekId, ekSira) => {
        const isConfirmed = window.confirm(`EK-${ekSira} siparişi ve ürünleri silinecek. Stoklar iade edilecek. Emin misiniz?`);
        if (!isConfirmed) return;
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/siparisler/${anaSiparisId}/ek-siparis/${ekId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            alert(data.mesaj);
            setActiveProformaIndex(0);
            handleRowClick(acikSiparisId);
        } catch (err) {
            alert(`Hata: ${err.message}`);
        }
    };

    const handleDownloadEkJpg = async (ekData, anaMusteri, etiket = `Ek-${ekData.sira}`) => {
        // Ek sipariş proformasını indirmek için geçici bir render kullanıyoruz
        const geciciId = `ek-proforma-download-${ekData.id}`;
        const geciciNode = document.getElementById(geciciId);
        if (!geciciNode) {
            alert('Ek sipariş önizlemesi bulunamadı.');
            return;
        }
        const originalHeight = geciciNode.style.height;
        const tableContainer = geciciNode.querySelector(`[id^="proforma-table-container-"]`);
        const originalOverflow = tableContainer ? tableContainer.style.overflowY : '';
        try {
            geciciNode.style.height = 'auto';
            if (tableContainer) tableContainer.style.overflowY = 'visible';
            const dataUrl = await htmlToImage.toJpeg(geciciNode, { quality: 1, backgroundColor: '#ffffff', pixelRatio: 3 });
            const link = document.createElement('a');
            link.download = `(${etiket}) - ${(anaMusteri?.telefon_numarasi || '0000').slice(-4)} - ${(anaMusteri?.ad_soyad || 'Isimsiz').replace(/ /g, '_')}.jpg`;
            link.href = dataUrl;
            link.click();
        } catch (err) {
            console.error('Ek proforma indirme hatası:', err);
            alert('Ek proforma indirilemedi.');
        } finally {
            geciciNode.style.height = originalHeight;
            if (tableContainer) tableContainer.style.overflowY = originalOverflow;
        }
    };

    const handleSendEkWhatsapp = async (ekData, anaMusteri, telefon) => {
        const geciciId = `ek-proforma-download-${ekData.id}`;
        const geciciNode = document.getElementById(geciciId);
        const phoneNumber = (telefon || anaMusteri?.telefon_numarasi || '').replace(/[^0-9]/g, '');
        if (!geciciNode) { alert('Ek sipariş önizlemesi bulunamadı.'); return; }
        if (!phoneNumber) { alert('Gönderilecek telefon numarası boş.'); return; }
        const originalHeight = geciciNode.style.height;
        const tableContainer = geciciNode.querySelector(`[id^="proforma-table-container-"]`);
        const originalOverflow = tableContainer ? tableContainer.style.overflowY : '';
        try {
            geciciNode.style.height = 'auto';
            if (tableContainer) tableContainer.style.overflowY = 'visible';
            const blob = await htmlToImage.toBlob(geciciNode, { pixelRatio: 3, backgroundColor: '#ffffff', cacheBust: true });
            if (!blob) throw new Error('Görsel oluşturulamadı.');
            await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
            window.location.href = `whatsapp://send?phone=90${phoneNumber}`;
        } catch (err) {
            console.error('Ek proforma whatsapp hatası:', err);
            alert('Ek proforma gönderilemedi.');
        } finally {
            geciciNode.style.height = originalHeight;
            if (tableContainer) tableContainer.style.overflowY = originalOverflow;
        }
    };

    // onayAlindi: alıcı ödemelide parola modalı onay yerine geçer, ayrıca sorulmaz
    const handleCreatePttShipment = async (siparisId, odeme_sart = 'G', onayAlindi = false) => {
        if (isButtonDisabled()) return;

        const odemeTipi = odeme_sart === 'A' ? 'Alıcı Ödemeli' : 'Gönderici Ödemeli';
        if (!onayAlindi && !window.confirm(`Bu sipariş için ${odemeTipi} PTT Kargo kaydı oluşturulacaktır. Emin misiniz?`)) {
            return;
        }

        try {
            const response = await fetch(`api/siparisler/${siparisId}/kargo-olustur`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ odeme_sart })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası oluştu.');
            }

            alert(`${data.mesaj}\nTakip No: ${data.kargoTakipNo}`);
            
            // Alıcı ödemeli olarak oluşturulmuşsa bu bilgiyi sakla
            if (odeme_sart === 'A') {
                localStorage.setItem(`kargo_alici_odemeli_${siparisId}`, 'true');
            }
            
            // Başarılı olduktan sonra, yeni takip numarasını görmek için detay verisini yenileyelim
            handleRowClick(siparisId);

        } catch (error) {
            console.error("PTT Kargo oluşturulurken hata:", error);
            alert(`Hata: ${error.message}`);
        }
    };

    const handleDownloadJpg = async (siparisDetay) => { // Fonksiyonu async olarak işaretle
        const proformaNodeId = `proforma-${siparisDetay.id}`;
        const tableContainerNodeId = `proforma-table-container-${siparisDetay.id}`;

        const proformaNode = document.getElementById(proformaNodeId);
        const tableContainerNode = document.getElementById(tableContainerNodeId);

        if (!proformaNode || !tableContainerNode) {
            console.error("İndirilecek elementler bulunamadı.");
            alert("Önizleme alanı bulunamadı, indirme işlemi yapılamıyor.");
            return;
        }

        // 1. Orijinal stilleri sakla
        const originalProformaHeight = proformaNode.style.height;
        const originalTableContainerOverflow = tableContainerNode.style.overflowY;

        // 2. Fotoğraf çekimi için stilleri geçici olarak değiştir
        proformaNode.style.height = 'auto'; // Ana container'ın yüksekliğini otomatik yap
        tableContainerNode.style.overflowY = 'visible'; // Kaydırma çubuğunu kaldır

        try {
            // 3. Görüntüyü oluşturmayı bekle
            const dataUrl = await htmlToImage.toJpeg(proformaNode, {
                quality: 1,
                backgroundColor: '#ffffff',
                pixelRatio: 3
            });

            // 4. İndirme linkini oluştur ve tıkla
            const link = document.createElement('a');
            link.download = createFileName('Proforma', siparisDetay);
            link.href = dataUrl;
            link.click();

        } catch (error) {
            console.error('Görüntü oluşturulurken hata oluştu!', error);
            alert("Önizleme indirilirken bir hata oluştu.");
        } finally {
            // 5. NE OLURSA OLSUN stilleri orijinal haline geri getir
            proformaNode.style.height = originalProformaHeight;
            tableContainerNode.style.overflowY = originalTableContainerOverflow;
        }
    };

    const handleSendWhatsapp = async () => {
        // İki hedef elementin de ID'lerini alıyoruz
        const proformaNodeId = `proforma-${detayData.id}`;
        const tableContainerNodeId = `proforma-table-container-${detayData.id}`;

        const proformaNode = document.getElementById(proformaNodeId);
        const tableContainerNode = document.getElementById(tableContainerNodeId);
        const phoneNumber = ((alternatifTel && alternatifTel.trim()) ? alternatifTel : proformaTel).replace(/[^0-9]/g, '');

        // Elementlerin varlığını kontrol et
        if (!proformaNode || !tableContainerNode) {
            alert("Önizleme alanı veya içeriği bulunamadı.");
            return;
        }
        if (!phoneNumber) {
            alert("Gönderilecek telefon numarası boş.");
            return;
        }

        // 1. Orijinal stilleri daha sonra geri yüklemek için sakla
        const originalProformaHeight = proformaNode.style.height;
        const originalTableContainerOverflow = tableContainerNode.style.overflowY;

        try {
            // 2. Fotoğraf çekimi için stilleri geçici olarak değiştir
            proformaNode.style.height = 'auto';
            tableContainerNode.style.overflowY = 'visible';

            // 3. Resmi PNG formatında bir Blob olarak oluştur
            const blob = await htmlToImage.toBlob(proformaNode, {
                pixelRatio: 3,
                backgroundColor: '#ffffff',
                cacheBust: true
            });

            if (!blob) {
                throw new Error("Görsel (blob) oluşturulamadı.");
            }

            // 4. Müşteri bilgilendirme mesajı
            const bilgilendirmeMetni = `*Sipariş Bilgi Formunuz Gönderilmiştir.*

Lütfen aşağıdaki bilgileri kontrol ediniz;

📞 Telefon
👤 İsim
📍 Adres
📦 Ürün Detayları
🏷️ Toplam Tutar
💳 Ödeme Yöntemi

✅ Kontrol sonrası siparişe onay veriniz.
⚠️ Onaydan itibaren siparişe ek yapılamamaktadır.

🔎 Sipariş durumunu syposr.com.tr/takip sayfasından takip edebilirsiniz.

Anlayışınız için teşekkür ederiz.`;
            
            // 5. Sadece görseli panoya kopyala
            await navigator.clipboard.write([
                new ClipboardItem({
                    'image/png': blob
                })
            ]);
            
            // 6. WhatsApp'ı aç (metin URL parametresinde)
            const encodedText = encodeURIComponent(bilgilendirmeMetni);
            window.location.href = `whatsapp://send?phone=90${phoneNumber}&text=${encodedText}`;

        } catch (error) {
            console.error("Gönderme işlemi sırasında detaylı hata:", error);
            alert("Görsel oluşturulurken veya paylaşılırken bir hata oluştu. Detaylar için konsolu kontrol edin.");
        } finally {
            // 7. NE OLURSA OLSUN stilleri orijinal haline geri getir
            proformaNode.style.height = originalProformaHeight;
            tableContainerNode.style.overflowY = originalTableContainerOverflow;
        }
    };

    const handleSendKargoWhatsapp = async () => {
        // Müşteri telefon numarasını al
        const phoneNumber = detayData.musteri?.telefon_numarasi?.replace(/[^0-9]/g, '');
        
        if (!phoneNumber) {
            alert("Müşteri telefon numarası bulunamadı.");
            return;
        }

        if (!aktifBarkod) {
            alert("Takip numarası bulunamadı.");
            return;
        }

        try {
            let messageText = '';
            
            // Sorgulama yapılmışsa (kargoHareketleri doluysa)
            if (kargoHareketleri.length > 0) {
                messageText = `🚚 Kargo Takip Bilgileri\n\nTakip No: ${aktifBarkod}\n\n`;
                messageText += '📦 Son Hareketler:\n\n';
                
                // Son 3 hareketi ekle
                kargoHareketleri.slice(0, 3).forEach((hareket, index) => {
                    messageText += `${index + 1}. ${hareket.durum}\n`;
                    messageText += `   ${hareket.yer} - ${hareket.tarih} ${hareket.saat}\n\n`;
                });
            } else {
                // Sorgulama yapılmamışsa sadece barkod numarasını gönder
                messageText = `🚚 Kargo Takip Numaranız\n\nTakip No: ${aktifBarkod}\n\nBu numara ile kargonuzu takip edebilirsiniz.`;
            }

            // Metni panoya kopyala
            await navigator.clipboard.writeText(messageText);
            
            // WhatsApp sohbet linkini aç
            window.location.href = `whatsapp://send?phone=90${phoneNumber}`;
            
        } catch (error) {
            console.error("WhatsApp gönderme hatası:", error);
            alert("Mesaj gönderilirken bir hata oluştu.");
        }
    };

     const handleTopluBarkodAl = async () => {
        if (!seciliTarih) {
            alert("Lütfen geçerli bir tarih seçin.");
            return;
        }
        
        // Seçili sipariş kontrolü
        if (seciliSiparisler.length === 0) {
            alert("Lütfen en az bir sipariş seçin.");
            return;
        }

        const isConfirmed = window.confirm(`Seçili ${seciliSiparisler.length} sipariş için PTT'den takip numarası alınacaktır. Bu işlem biraz zaman alabilir. Emin misiniz?`);
        if (!isConfirmed) return;

        alert("İşlem başlatıldı, lütfen bekleyin...");

        try {
            const response = await fetch('/api/siparisler/toplu-barkod-olustur', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    siparisIds: seciliSiparisler 
                })
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası.');
            }

            // Sonuç özetini kullanıcıya göster
            let sonucMesaji = data.mesaj;
            if (data.hatalar && data.hatalar.length > 0) {
                sonucMesaji += "\n\nHatalar:\n" + data.hatalar.join("\n");
            }
            alert(sonucMesaji);

            // İşlem bittikten sonra listeyi yenile
            fetchSiparisler();

        } catch (error) {
            alert(`Bir hata oluştu: ${error.message}`);
        }
    };

    // Parola modalı onay yerine geçer; parola doğru girilince çağrılır
    const handleTopluBarkodIptal = async () => {
        if (seciliSiparisler.length === 0) {
            alert("Lütfen en az bir sipariş seçin.");
            return;
        }

        alert("İşlem başlatıldı, lütfen bekleyin...");

        try {
            const response = await fetch('/api/siparisler/toplu-barkod-iptal', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    siparisIds: seciliSiparisler 
                })
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası.');
            }

            let sonucMesaji = data.mesaj;
            if (data.hatalar && data.hatalar.length > 0) {
                sonucMesaji += "\n\nHatalar:\n" + data.hatalar.join("\n");
            }
            alert(sonucMesaji);

            fetchSiparisler();

        } catch (error) {
            alert(`Bir hata oluştu: ${error.message}`);
        }
    };

    // Seçili siparişlerin resmileşmemiş faturalarını sırayla resmileştirir.
    // Her fatura ayrı istekle işlenir (canlıda gunicorn 30 sn timeout'u var).
    const handleTopluResmilestir = async () => {
        if (isButtonDisabled() || topluResmilestirIlerleme || seciliSiparisler.length === 0) return;
        const token = localStorage.getItem('token');

        // Liste uç noktası parasut_fatura_id döndürmediği için fatura bilgisi sipariş detayından okunur
        setTopluResmilestirIlerleme('hazırlanıyor');
        const hedefler = [];
        const odemesizler = []; // Ödeme Takibi'nde "Ödenmedi": seçili olsa da resmileştirilmez
        let faturasizSayisi = 0, resmiSayisi = 0;
        const okumaHatalari = [];
        for (const id of seciliSiparisler) {
            try {
                const res = await fetch(`/api/siparisler/${id}`, { headers: { 'Authorization': `Bearer ${token}` }, cache: 'no-cache' });
                if (!res.ok) throw new Error(`Status ${res.status}`);
                const d = await res.json();
                if (!d.parasut_fatura_id) faturasizSayisi++;
                else if (d.fatura_bilgileri?.sabit || faturaStatuslari[d.parasut_fatura_id]?.is_finalized) resmiSayisi++;
                else if (odemeYapilmadi(d)) odemesizler.push(`#${d.siparis_no} - ${d.musteri?.ad_soyad || ''}`);
                else hedefler.push({ siparis_no: d.siparis_no, parasut_fatura_id: d.parasut_fatura_id });
            } catch (error) {
                const s = siparisler.find(x => x.id === id);
                okumaHatalari.push(`#${s ? s.siparis_no : id}: sipariş bilgisi okunamadı (${error.message})`);
            }
        }
        setTopluResmilestirIlerleme(null);

        const odemeUyarisi = odemesizler.length
            ? `\n\n⚠️ ÖDEME YAPILMADI - resmileştirilmeyecek (${odemesizler.length}):\n- ${odemesizler.join('\n- ')}`
            : '';
        if (hedefler.length === 0) {
            alert("Seçili siparişler arasında resmileştirilecek sipariş yok." + odemeUyarisi +
                (okumaHatalari.length ? `\n\n${okumaHatalari.join('\n')}` : ''));
            return;
        }
        const atlananlar = [
            faturasizSayisi ? `${faturasizSayisi} siparişin faturası kesilmemiş` : '',
            resmiSayisi ? `${resmiSayisi} sipariş zaten resmileşmiş` : '',
            okumaHatalari.length ? `${okumaHatalari.length} sipariş okunamadı` : ''
        ].filter(Boolean);
        if (!window.confirm(
            `${hedefler.length} fatura resmileştirilecek (e-fatura / e-arşiv).` +
            (atlananlar.length ? `\n(Atlanacak: ${atlananlar.join(', ')}.)` : '') +
            odemeUyarisi +
            `\n\nBu işlem GERİ ALINAMAZ. Fatura bilgileri ve kalemleri doğru mu?`
        )) return;

        const basarili = [], devamEden = [], hatalar = [...okumaHatalari];
        for (let i = 0; i < hedefler.length; i++) {
            const s = hedefler[i];
            setTopluResmilestirIlerleme(`${i + 1}/${hedefler.length}`);
            try {
                const sonuc = await parasutResmilestir(s.parasut_fatura_id);
                (sonuc.devamEdiyor ? devamEden : basarili).push(`#${s.siparis_no} (${sonuc.belge_turu})`);
                await checkFaturaStatusOtomatik(s.parasut_fatura_id);
            } catch (error) {
                hatalar.push(`#${s.siparis_no}: ${error.message}`);
                if (error.message === 'Oturum süresi doldu.') break;
            }
            await parasutGrupBeklemesi(i + 1, hedefler.length, setTopluResmilestirIlerleme);
        }
        setTopluResmilestirIlerleme(null);

        let mesaj = `Toplu resmileştirme tamamlandı.\n\nBaşarılı: ${basarili.length}`;
        if (basarili.length) mesaj += `\n- ${basarili.join('\n- ')}`;
        if (devamEden.length) mesaj += `\n\nParaşüt'te devam ediyor (${devamEden.length}):\n- ${devamEden.join('\n- ')}`;
        if (hatalar.length) mesaj += `\n\nHatalar (${hatalar.length}):\n- ${hatalar.join('\n- ')}`;
        mesaj += odemeUyarisi;
        alert(mesaj);
    };

    const handleTopluFaturaGonder = async () => {
        if (!seciliTarih) {
            alert("Lütfen geçerli bir tarih seçin.");
            return;
        }
        
        // Seçili sipariş kontrolü
        if (seciliSiparisler.length === 0) {
            alert("Lütfen en az bir sipariş seçin.");
            return;
        }

        if (topluFaturaIlerleme) return;
        const isConfirmed = window.confirm(`Seçili ${seciliSiparisler.length} sipariş için Paraşüt'te fatura oluşturulacaktır. Bu işlem biraz zaman alabilir; bitene kadar sayfayı kapatmayın. Emin misiniz?`);
        if (!isConfirmed) return;

        // Siparişler tek tek gönderilir: hepsi tek istekte işlenince canlıdaki 30 sn gunicorn
        // timeout'unda istek kesiliyor ve kalan siparişlerin faturası oluşmuyordu
        const siparisIdleri = [...seciliSiparisler];
        const basarili = [], hatalar = [], tahsilatUyarilari = [];
        let atlanan = 0;
        for (let i = 0; i < siparisIdleri.length; i++) {
            const id = siparisIdleri[i];
            const etiket = `#${siparisler.find(s => s.id === id)?.siparis_no || id}`;
            setTopluFaturaIlerleme(`${i + 1}/${siparisIdleri.length}`);
            try {
                const response = await fetch('/api/siparisler/toplu-fatura-olustur', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify({ siparisIds: [id] })
                });

                if (response.status === 401) {
                    setTopluFaturaIlerleme(null);
                    alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                    localStorage.removeItem('token');
                    window.location.href = '/login';
                    return;
                }

                const data = await response.json().catch(() => ({}));
                if (!response.ok) throw new Error(data.hata || `Sunucu hatası (Status ${response.status})`);

                if (data.tahsilat_uyarilari?.length) tahsilatUyarilari.push(...data.tahsilat_uyarilari);
                if (data.basarili_siparisler?.length) {
                    data.basarili_siparisler.forEach(s => basarili.push(`Sipariş #${s.siparis_no}: Fatura ID ${s.fatura_id}`));
                } else if (data.hatalar?.length) {
                    hatalar.push(...data.hatalar);
                } else {
                    atlanan++; // faturası zaten var veya ücretsiz gönderi (B)
                }
            } catch (error) {
                hatalar.push(`Sipariş ${etiket}: ${error.message}`);
            }
            await parasutGrupBeklemesi(i + 1, siparisIdleri.length, setTopluFaturaIlerleme);
        }
        setTopluFaturaIlerleme(null);

        let sonucMesaji = `Toplu fatura tamamlandı.\n\nBaşarılı: ${basarili.length}`;
        if (basarili.length) sonucMesaji += `\n- ${basarili.join('\n- ')}`;
        if (atlanan) sonucMesaji += `\n\nAtlanan (faturası zaten var veya ücretsiz gönderi): ${atlanan}`;
        if (hatalar.length) sonucMesaji += `\n\nHatalar (${hatalar.length}):\n- ${hatalar.join('\n- ')}`;
        if (tahsilatUyarilari.length) sonucMesaji += `\n\nTahsil edildi olarak işlenemeyenler (${tahsilatUyarilari.length}):\n- ${tahsilatUyarilari.join('\n- ')}`;
        alert(sonucMesaji);

        // İşlem bittikten sonra listeyi yenile
        fetchSiparisler();
    };

    const handleTopluSil = async () => {
        if (seciliSiparisler.length === 0) {
            alert("Lütfen en az bir sipariş seçin.");
            return;
        }

        const isConfirmed = window.confirm(`Seçili ${seciliSiparisler.length} sipariş çöp kutusuna taşınacaktır. 30 gün içinde Silinenler sayfasından geri alabilirsiniz. Devam etmek istiyor musunuz?`);
        if (!isConfirmed) return;

        try {
            const response = await fetch('/api/siparisler/toplu-sil', {
                method: 'DELETE',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ 
                    siparisIds: seciliSiparisler 
                })
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası.');
            }

            alert(data.mesaj || `${seciliSiparisler.length} sipariş çöp kutusuna taşındı.`);
            
            // Seçili siparişleri temizle ve listeyi yenile
            setSeciliSiparisler([]);
            fetchSiparisler();

        } catch (error) {
            alert(`Bir hata oluştu: ${error.message}`);
        }
    };

    const handleTopluTarihDegistir = () => {
        if (seciliSiparisler.length === 0) {
            alert("Lütfen en az bir sipariş seçin.");
            return;
        }
        
        // Modalı aç
        setTopluSecilenTarih(new Date().toISOString().split('T')[0]);
        setTopluTarihModalAcik(true);
    };
    
    const handleTopluTarihOnayla = async () => {
        const isConfirmed = window.confirm(
            `Seçili ${seciliSiparisler.length} siparişin tarihi ${topluSecilenTarih} olarak değiştirilecektir.\n\nEmin misiniz?`
        );
        
        if (!isConfirmed) return;

        try {
            const response = await fetch('/api/siparisler/toplu-tarih-guncelle', {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ 
                    siparisIds: seciliSiparisler,
                    yeniTarih: topluSecilenTarih
                })
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası.');
            }

            alert(data.mesaj || `${seciliSiparisler.length} siparişin tarihi başarıyla güncellendi.`);
            
            // Modalı kapat, seçili siparişleri temizle ve listeyi yenile
            setTopluTarihModalAcik(false);
            setSeciliSiparisler([]);
            fetchSiparisler();

        } catch (error) {
            alert(`Bir hata oluştu: ${error.message}`);
            setTopluTarihModalAcik(false);
        }
    };

    // handleA5Print fonksiyonu kaldırıldı (artık kullanılmıyor)

    const getDurumRengi = (durum) => {
        switch (durum) {
            case 'Tamamı Ödendi': return '#28a745'; // Yeşil
            case 'Kısmen Ödendi': return '#fd7e14'; // Turuncu
            case 'Ödenmedi': return '#dc3545'; // Kırmızı
            default: return 'black';
        }
    };
    
    // Sipariş notunu kaydeder; boş metin notu siler (N butonu pasifleşir)
    const handleSaveNote = async (yeniNot) => {
        if (!detayData) {
            alert("Sipariş bilgisi bulunamadı.");
            return false;
        }

        try {
            const response = await fetch(`/api/siparisler/${detayData.id}/not`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ notlar: yeniNot })
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Not kaydedilirken bir hata oluştu.');
            }
            setDetayData(prev => ({ ...prev, siparis_notu: yeniNot }));
            fetchSiparisler();
            return true;
        } catch (error) {
            console.error("Not kaydedilirken hata:", error);
            alert(`Hata: ${error.message}`);
            return false;
        }
    };

    const handleNotModalKaydet = async () => {
        const yeniNot = musteriNotu.trim();
        const mevcutNot = (detayData?.siparis_notu || '').trim();
        if (!yeniNot && !mevcutNot) { setNotModalAcik(false); return; }
        const soru = !yeniNot
            ? 'Sipariş notu silinecek. Emin misiniz?'
            : (mevcutNot ? 'Sipariş notu güncellenecek. Emin misiniz?' : 'Siparişe not eklenecek. Emin misiniz?');
        if (!window.confirm(soru)) return;
        if (await handleSaveNote(yeniNot)) setNotModalAcik(false);
    };

    const handleNotSil = async () => {
        if (!window.confirm('Sipariş notu silinecek. Emin misiniz?')) return;
        handleSaveNote('');
    };

    // Beklemeden çıkarma yalnızca yöneticilere açık
    const handleBeklemedenCikar = async (siparisId) => {
        if (userRole !== 'admin') {
            alert('Siparişi beklemeden yalnızca yöneticiler çıkarabilir.');
            return;
        }
        if (!window.confirm('Sipariş beklemeden çıkarılacak ve normal gönderime alınacak. Emin misiniz?')) return;
        try {
            const response = await fetch(`/api/siparisler/${siparisId}/durum-guncelle`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ kargo_durumu: 'Normal' })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            alert(data.mesaj);
            fetchSiparisler();
            setDetayData(prev => ({ ...prev, kargo_durumu: 'Normal' }));
        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };

    const handleTakipDegistir = async (siparisId, takipEt) => {
        const soru = takipEt
            ? 'Bu sipariş "Takip Edilenler" listesine eklenecek. Emin misiniz?'
            : 'Bu sipariş "Takip Edilenler" listesinden çıkarılacak. Emin misiniz?';
        if (!window.confirm(soru)) return;
        try {
            const response = await fetch(`/api/siparisler/${siparisId}/durum-guncelle`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ is_tracked: takipEt })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata || 'İşlem başarısız oldu.');
            alert(takipEt ? 'Sipariş başarıyla takibe alındı.' : 'Sipariş takipten çıkarıldı.');
            fetchSiparisler();
            setDetayData(prev => ({ ...prev, is_tracked: takipEt }));
        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };

    // Proforma üstündeki renkli harf butonları: işlevi açıksa %100, değilse %30 görünür
    const renderHarfButonu = ({ harf, renk, aktif, aciklama, onClick, disabled }) => (
        <button
            type="button"
            title={aciklama}
            disabled={disabled}
            onClick={(e) => { e.stopPropagation(); onClick(); }}
            style={{
                width: '26px', height: '26px', padding: 0, flexShrink: 0,
                background: renk, color: 'white', border: 'none', borderRadius: '4px',
                fontFamily: 'Poppins, sans-serif', fontWeight: '700', fontSize: '17px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                opacity: aktif ? 1 : 0.3,
                cursor: disabled ? 'not-allowed' : 'pointer'
            }}
        >
            {harf}
        </button>
    );

    const handleSiparisSil = (siparisId) => {
        const isConfirmed = window.confirm(`#${siparisId} numaralı sipariş çöp kutusuna taşınacaktır. 30 gün içinde Silinenler sayfasından geri alabilirsiniz. Devam etmek istiyor musunuz?`);
        if (isConfirmed) {
            fetch(`/api/siparisler/${siparisId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Sunucu hatası oluştu.');
                }
                return response.json();
            })
            .then(data => {
                alert(data.mesaj);
                fetchSiparisler();
            })
            .catch(error => {
                console.error('Sipariş silinirken hata:', error);
                alert(`Sipariş silinirken bir hata oluştu: ${error.message}`);
            });
        }
    };
    
    // Tarih değiştirme modalı için fonksiyonlar
    const handleTarihDegistir = (siparisId) => {
        setTarihDegistirilecekSiparisId(siparisId);
        setSecilenTarih(new Date().toISOString().split('T')[0]);
        setTarihModalAcik(true);
    };
    
    const handleTarihOnayla = async () => {
        if (!tarihDegistirilecekSiparisId) return;
        
        const isConfirmed = window.confirm(
            `Sipariş tarihi ${secilenTarih} olarak değiştirilecektir.\n\nEmin misiniz?`
        );
        if (!isConfirmed) return;
        
        try {
            const response = await fetch(`/api/siparisler/${tarihDegistirilecekSiparisId}/tarih-guncelle`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ siparis_tarihi: secilenTarih })
            });
            
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.hata || 'Tarih güncellenemedi');
            }
            
            const data = await response.json();
            alert(`✅ ${data.mesaj}`);
            
            // Listeyi yenile
            fetchSiparisler();
            
            // Modal'ı kapat
            setTarihModalAcik(false);
            setTarihDegistirilecekSiparisId(null);
            
        } catch (error) {
            console.error('Tarih güncelleme hatası:', error);
            alert(`❌ Hata: ${error.message}`);
        }
    };

    // --- Teslimat talepleri ---
    // İade tek başına seçilir; diğerleri birlikte seçilip tek mailde gönderilir
    const TALEP_TURLERI = [
        { tur: 'isim_adres', ad: 'İsim Adres Değişikliği', aciklama: 'İsim / telefon / adres güncellensin' },
        { tur: 'odeme', ad: 'Ödeme Değişikliği', aciklama: 'Kapıda ödeme ekle / kaldır / değiştir' },
        { tur: 'iade', ad: 'İade Talebi', aciklama: 'Sevk durdurulup iade edilsin (tek başına)' },
        { tur: 'tekrar_dagitim', ad: 'Tekrar Dağıtım', aciklama: 'Yeniden dağıtıma çıkarılsın' }
    ];
    const TALEP_DURUM_RENKLERI = {
        'Gönderilemedi': '#dc3545', 'Hatırlatılmalı': '#fd7e14', 'Gönderildi': '#1565C0',
        'İşleme Alındı': '#6f42c1', 'Tamamlandı': '#28a745', 'İptal': '#6c757d'
    };
    const talepGorunenDurum = (t) => (t.hatirlatilmali ? 'Hatırlatılmalı' : t.durum);
    const talepAcikMi = (t) => ['Gönderilemedi', 'Gönderildi', 'İşleme Alındı'].includes(t.durum);

    const talepIstek = async (url, method = 'POST', body) => {
        const res = await fetch(url, {
            method,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
            body: body ? JSON.stringify(body) : undefined
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok && !data.talep) throw new Error(data.hata || 'Sunucu hatası.');
        return data;
    };

    // Değişen talebi açık detayda yerine koyar, liste renklerini tazeler
    const talepGuncellendi = (talep) => {
        if (!talep) return;
        setDetayData(prev => {
            if (!prev || prev.id !== talep.siparis_id) return prev;
            const liste = prev.teslimat_talepleri || [];
            const varMi = liste.some(t => t.id === talep.id);
            return { ...prev, teslimat_talepleri: varMi ? liste.map(t => (t.id === talep.id ? talep : t)) : [talep, ...liste] };
        });
        fetchSiparisler();
    };

    // İade seçilirse diğerleri kalkar; diğerlerinden biri seçilirse iade kalkar
    const talepTuruSec = (tur) => setTalepForm(f => {
        if (f.turler.includes(tur)) return { ...f, turler: f.turler.filter(t => t !== tur) };
        return { ...f, turler: tur === 'iade' ? ['iade'] : [...f.turler.filter(t => t !== 'iade'), tur] };
    });

    const talepFormuAc = () => {
        if (!detayData) return;
        const m = detayData.musteri || {};
        setTalepForm({
            turler: [],
            barkod: detayData.eski_etiket || aktifBarkod || detayData.kargo_takip_no || '',
            detay: {
                yeni_adres: [m.adres, [m.ilce, m.il].filter(Boolean).join(' / ')].filter(Boolean).join('\n'),
                yeni_ad_soyad: m.ad_soyad || '',
                yeni_telefon: m.telefon_numarasi || '',
                islem: detayData.odeme_yontemi === 'K' ? 'kaldir' : 'ekle',
                tutar: '',
                ptt_notu: ''
            },
            kaynak: 'musteri',
            notlar: ''
        });
    };

    // İsim Adres Değişikliği: sadece mevcut bilgiden farklı olan alanlar maile yazılır
    const isimAdresDegisenleri = (detay) => {
        const m = detayData?.musteri || {};
        const mevcutAdres = [m.adres, [m.ilce, m.il].filter(Boolean).join(' / ')].filter(Boolean).join('\n');
        const farkli = (yeni, eski) => ((yeni || '').trim() !== (eski || '').trim() ? (yeni || '').trim() : '');
        return {
            yeni_ad_soyad: farkli(detay.yeni_ad_soyad, m.ad_soyad),
            yeni_telefon: farkli(detay.yeni_telefon, m.telefon_numarasi),
            yeni_adres: farkli(detay.yeni_adres, mevcutAdres)
        };
    };

    const handleTalepKaydet = async () => {
        if (!talepForm || !detayData || talepKaydediliyor) return;
        const { turler, detay } = talepForm;
        // Sadece seçilen türlere ait, değişen alanlar gönderilir
        const gonderilecekDetay = { ptt_notu: detay.ptt_notu, ...(turler.includes('isim_adres') ? isimAdresDegisenleri(detay) : {}) };
        if (turler.includes('odeme')) Object.assign(gonderilecekDetay, { islem: detay.islem, tutar: detay.tutar });
        setTalepKaydediliyor(true);
        try {
            const data = await talepIstek(`/api/siparisler/${detayData.id}/teslimat-talepleri`, 'POST', {
                turler, barkod: talepForm.barkod, detay: gonderilecekDetay, kaynak: talepForm.kaynak, notlar: talepForm.notlar
            });
            talepGuncellendi(data.talep);
            setTalepForm(null);
            if (data.talep?.durum === 'Gönderilemedi') {
                alert(`Talep kaydedildi ancak mail gönderilemedi:\n${data.talep.mail_hata || ''}\n\nTalep kartından tekrar gönderebilir veya mail programında açabilirsiniz.`);
            }
        } catch (err) {
            alert(`Talep oluşturulamadı: ${err.message}`);
        } finally {
            setTalepKaydediliyor(false);
        }
    };

    // Talep kartındaki işlemler: gonder (tekrar gönder / hatırlat), kontrol, elle gönderildi, kapat
    const handleTalepIslem = async (talep, islem, ek) => {
        if (talepIslemde) return;
        if (islem === 'durum' && !window.confirm(`Talep "${ek}" olarak kapatılacak. Emin misiniz?`)) return;
        if (islem === 'gonder' && talep.durum !== 'Gönderilemedi' && !window.confirm("PTT'ye hatırlatma maili gönderilecek. Emin misiniz?")) return;
        setTalepIslemde(talep.id);
        try {
            const yollar = {
                gonder: [`/api/teslimat-talepleri/${talep.id}/gonder`, 'POST'],
                kontrol: [`/api/teslimat-talepleri/${talep.id}/kontrol`, 'POST'],
                elle: [`/api/teslimat-talepleri/${talep.id}/gonderildi-isaretle`, 'POST'],
                durum: [`/api/teslimat-talepleri/${talep.id}/durum`, 'PUT', { durum: ek }]
            };
            const [url, method, body] = yollar[islem];
            const data = await talepIstek(url, method, body);
            talepGuncellendi(data.talep);
            if (data.hata) alert(`Mail gönderilemedi: ${data.hata}`);
            else if (islem === 'kontrol' && data.talep?.durum === talep.durum) alert(`Durum değişmedi: ${data.talep.durum}${data.talep.son_hareket ? `\nSon hareket: ${data.talep.son_hareket}` : ''}`);
        } catch (err) {
            alert(`İşlem başarısız: ${err.message}`);
        } finally {
            setTalepIslemde(null);
        }
    };

    // --- İşyerinden elden teslim ---
    // Barkod alınmış siparişte PTT kabul (ilk hareket) girişi varsa elden teslim yapılamaz, talep açılabilir
    const kargoHareketiVar = kargoHareketleri.some(h => h.tarih || h.yer);

    const eldenTeslimFormuAc = () => {
        if (!detayData || isButtonDisabled()) return;
        const bugun = new Date();
        const yerelTarih = new Date(bugun.getTime() - bugun.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
        setEldenTeslimForm({ tarih: yerelTarih, teslim_alan: detayData.musteri?.ad_soyad || '' });
    };

    const eldenTeslimKaydet = async (kayit) => {
        if (!detayData || eldenTeslimKaydediliyor) return;
        setEldenTeslimKaydediliyor(true);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`/api/siparisler/${detayData.id}/durum-guncelle`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ elden_teslim: kayit })
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.hata || 'Sunucu hatası.');
            setDetayData(prev => (prev && prev.id === detayData.id ? { ...prev, elden_teslim: kayit } : prev));
            setEldenTeslimForm(null);
            fetchSiparisler();
        } catch (err) {
            alert(`Elden teslim kaydedilemedi: ${err.message}`);
        } finally {
            setEldenTeslimKaydediliyor(false);
        }
    };

    const handleEldenTeslimKaydet = () => {
        if (!eldenTeslimForm) return;
        const tarih = eldenTeslimForm.tarih;
        const teslim_alan = eldenTeslimForm.teslim_alan.trim();
        if (!tarih || !teslim_alan) return;
        eldenTeslimKaydet({ tarih, teslim_alan, kayit_tarihi: new Date().toISOString() });
    };

    const handleEldenTeslimKaldir = () => {
        if (!window.confirm('Elden teslim kaydı kaldırılacak ve sipariş kargo işlemlerine geri dönecek. Emin misiniz?')) return;
        eldenTeslimKaydet(null);
    };

    // --- Eski etiket (sadece admin seçer/kaldırır; aktifken herkes yeşil butonu görür) ---
    const eskiEtiketKaydet = async (barkod) => {
        if (!detayData || eskiEtiketKaydediliyor) return;
        setEskiEtiketKaydediliyor(true);
        try {
            const res = await fetch(`/api/siparisler/${detayData.id}/eski-etiket`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                body: JSON.stringify({ barkod })
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.hata || 'Sunucu hatası.');
            setDetayData(prev => (prev && prev.id === detayData.id ? { ...prev, eski_etiket: data.eski_etiket, eski_barkodlar: data.eski_barkodlar } : prev));
            setEskiEtiketForm(null);
        } catch (err) {
            alert(`Eski etiket kaydedilemedi: ${err.message}`);
        } finally {
            setEskiEtiketKaydediliyor(false);
        }
    };

    const renderEskiEtiketButonu = () => {
        const aktif = !!detayData.eski_etiket;
        const admin = userRole === 'admin';
        if (!admin && !aktif) return null;
        return (
            <button
                type="button"
                onClick={(e) => { e.stopPropagation(); if (admin) setEskiEtiketForm({ secili: detayData.eski_etiket || '', elle: '' }); }}
                disabled={!admin}
                title={aktif ? `Hareketler eski etiketten gösteriliyor: ${detayData.eski_etiket}` : 'Önceki etiketlerden birinin hareketlerini göster'}
                style={{
                    fontSize: '11px', padding: '2px 10px', borderRadius: '4px', fontFamily: 'Poppins, sans-serif',
                    cursor: admin ? 'pointer' : 'default',
                    border: `1px solid ${aktif ? '#28a745' : '#ccc'}`,
                    background: aktif ? '#d4edda' : '#f8f8f8',
                    color: aktif ? '#155724' : '#333',
                    fontWeight: aktif ? '600' : '400'
                }}
            >
                {aktif ? `Eski Etiket: ${detayData.eski_etiket}` : 'Eski Etiket'}
            </button>
        );
    };

    // Takip numarası oluştur butonunun / barkod satırının altındaki teslimat butonları
    const renderTeslimatButonlari = () => {
        const barkodVar = !!(aktifBarkod || detayData.kargo_takip_no);
        const talepAktif = barkodVar && kargoHareketiVar;
        const eldenTeslimAktif = !kargoHareketiVar && !kargoSorguLoading && !isButtonDisabled();
        const stil = (aktif) => ({
            flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '10px',
            cursor: aktif ? 'pointer' : 'not-allowed', fontFamily: "'Poppins', sans-serif", fontSize: '13px',
            background: '#f8f8f8', border: '1px solid #ccc', borderRadius: '4px', opacity: aktif ? 1 : 0.5
        });
        return (
            <div style={{ display: 'flex', gap: '8px', width: '100%' }} onClick={(e) => e.stopPropagation()}>
                <button type="button" style={stil(talepAktif)} disabled={!talepAktif} onClick={talepFormuAc}
                    title={talepAktif ? "PTT'ye adres, ödeme, iade vb. talep gönder" : 'Talep için gönderinin PTT tarafından kabul edilmiş olması gerekir'}>
                    <img src={PTTLogo} alt="" style={{ height: '14px' }} /><span>Talimat Oluştur</span>
                </button>
                <button type="button" style={stil(eldenTeslimAktif)} disabled={!eldenTeslimAktif} onClick={eldenTeslimFormuAc}
                    title={kargoHareketiVar ? 'Gönderi PTT tarafından kabul edildi, elden teslim yapılamaz' : 'Sipariş kargo ile gönderilmeden müşteriye elden teslim edildi'}>
                    <img src={EldenTeslimIcon} alt="" style={{ height: '18px' }} /><span>İşyerinden Teslim</span>
                </button>
            </div>
        );
    };

    // Elden teslim edilmiş siparişte etiket/gönderi işlemleri yerine gösterilen teslimat bilgisi
    const renderEldenTeslimBilgisi = () => {
        const et = detayData.elden_teslim;
        return (
            <div style={{ border: '1px solid #b7e1c1', borderRadius: '6px', overflow: 'hidden', fontSize: '13px' }} onClick={(e) => e.stopPropagation()}>
                <div style={{ background: '#e6f4ea', padding: '8px 12px', borderBottom: '1px solid #b7e1c1', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <strong style={{ color: '#1e7e34', fontSize: '12px' }}>İşyerinden Elden Teslim Edildi</strong>
                    {!isButtonDisabled() && (
                        <button type="button" onClick={handleEldenTeslimKaldir} disabled={eldenTeslimKaydediliyor}
                            style={talepButonStili('#6c757d', eldenTeslimKaydediliyor)}>Kaydı Kaldır</button>
                    )}
                </div>
                <div style={{ padding: '10px 12px', background: 'white', display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '6px 12px' }}>
                    <span style={{ color: '#666' }}>Teslim Tarihi:</span>
                    <strong>{et.tarih ? new Date(`${et.tarih}T00:00:00`).toLocaleDateString('tr-TR') : '-'}</strong>
                    <span style={{ color: '#666' }}>Teslim Alan:</span>
                    <strong>{et.teslim_alan || '-'}</strong>
                    {detayData.kargo_takip_no && (<>
                        <span style={{ color: '#666' }}>Kullanılmayan Barkod:</span>
                        <span>{detayData.kargo_takip_no}</span>
                    </>)}
                </div>
            </div>
        );
    };

    const talepMailtoLinki = (t) =>
        `mailto:${t.alici}?subject=${encodeURIComponent(t.konu || '')}&body=${encodeURIComponent(t.govde || '')}`;

    const tarihSaatYaz = (iso) => (iso ? new Date(iso).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');

    const talepDetayOzeti = (t) => {
        const d = t.detay || {};
        const turler = t.turler || [t.tur];
        const satirlar = [];
        if (turler.some(x => ['isim_adres', 'alici'].includes(x))) satirlar.push([d.yeni_ad_soyad, d.yeni_telefon].filter(Boolean).join(' · '));
        if (turler.some(x => ['isim_adres', 'adres'].includes(x))) satirlar.push(d.yeni_adres);
        if (turler.includes('odeme')) satirlar.push(d.islem === 'kaldir' ? 'Ödeme şartı kaldırılacak' : `${d.islem === 'degistir' ? 'Yeni tutar' : 'Eklenecek tutar'}: ${d.tutar} TL`);
        return satirlar.filter(Boolean).join('\n') || null;
    };

    const renderTalepDurumu = (durum) => (
        <span style={{ display: 'inline-block', padding: '1px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600', whiteSpace: 'nowrap', color: TALEP_DURUM_RENKLERI[durum] || '#555', border: `1px solid ${TALEP_DURUM_RENKLERI[durum] || '#ccc'}`, background: '#fff' }}>
            {durum}
        </span>
    );

    const talepButonStili = (renk = '#333', pasif = false) => ({
        fontSize: '11px', padding: '3px 8px', border: `1px solid ${renk === '#333' ? '#ccc' : renk}`, borderRadius: '4px',
        background: '#f8f8f8', color: renk, cursor: pasif ? 'not-allowed' : 'pointer', opacity: pasif ? 0.5 : 1,
        fontFamily: 'Poppins, sans-serif', textDecoration: 'none', display: 'inline-flex', alignItems: 'center'
    });

    const renderTalepKarti = (t) => {
        const durum = talepGorunenDurum(t);
        const renk = TALEP_DURUM_RENKLERI[durum] || '#999';
        const islemde = talepIslemde === t.id;
        const acik = talepAcikMi(t);
        const ozet = talepDetayOzeti(t);
        return (
            <div key={t.id} style={{ border: '1px solid #e3e3e3', borderLeft: `4px solid ${renk}`, borderRadius: '6px', padding: '8px 10px', marginBottom: '10px', fontSize: '12px', background: acik ? '#fff' : '#fafafa' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                    <strong style={{ fontSize: '12px' }}>{t.tur_adi}</strong>
                    {renderTalepDurumu(durum)}
                </div>
                <div style={{ color: '#777', fontSize: '11px', marginBottom: '4px' }}>
                    {tarihSaatYaz(t.olusturma_tarihi)}{t.olusturan ? ` · ${t.olusturan}` : ''} · {t.barkod}
                    {t.gonderim_sayisi > 1 ? ` · ${t.gonderim_sayisi} mail` : ''}
                </div>
                {ozet && <div style={{ whiteSpace: 'pre-wrap', marginBottom: '4px' }}>{ozet}</div>}
                {t.notlar && <div style={{ color: '#555', fontStyle: 'italic', marginBottom: '4px' }}>Özel Not: {t.notlar}</div>}
                {t.son_hareket && <div style={{ color: '#444', background: '#f4f4f4', borderRadius: '3px', padding: '3px 6px', marginBottom: '4px' }}>Son hareket: {t.son_hareket}</div>}
                {t.uyari && <div style={{ color: '#842029', background: '#f8d7da', borderRadius: '3px', padding: '3px 6px', marginBottom: '4px' }}>⚠ {t.uyari}</div>}
                {t.durum === 'Gönderilemedi' && t.mail_hata && <div style={{ color: '#842029', marginBottom: '4px' }}>Mail hatası: {t.mail_hata}</div>}
                {durum === 'Hatırlatılmalı' && <div style={{ color: '#b35900', marginBottom: '4px' }}>2 iş günüdür hareketlerde talimat görülmedi.</div>}

                <details style={{ marginBottom: acik ? '6px' : 0 }}>
                    <summary style={{ cursor: 'pointer', color: '#1a6cb0', fontSize: '11px' }}>Mail metni ve geçmiş</summary>
                    <div style={{ fontSize: '11px', color: '#555', margin: '6px 0 2px' }}><strong>Konu:</strong> {t.konu}</div>
                    <pre style={{ margin: 0, fontSize: '11px', color: '#444', background: '#f8f8f8', border: '1px solid #e8e8e8', borderRadius: '3px', padding: '6px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'Poppins, sans-serif' }}>{t.govde}</pre>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                        <button type="button" style={talepButonStili('#1a6cb0')}
                            onClick={() => navigator.clipboard.writeText(t.govde).then(() => alert('Metin kopyalandı.')).catch(() => alert('Kopyalama başarısız.'))}>
                            Kopyala
                        </button>
                    </div>
                    <div style={{ marginTop: '6px' }}>
                        {(t.gecmis || []).map((g, i) => (
                            <div key={i} style={{ fontSize: '11px', color: '#666', borderTop: i ? '1px dashed #eee' : 'none', padding: '2px 0' }}>
                                {tarihSaatYaz(g.tarih)} · {g.olay}{g.kisi ? ` (${g.kisi})` : ''}
                            </div>
                        ))}
                    </div>
                </details>

                {acik && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                        {t.durum === 'Gönderilemedi' ? (
                            <>
                                <button type="button" disabled={islemde} style={talepButonStili('#1565C0', islemde)} onClick={() => handleTalepIslem(t, 'gonder')}>Tekrar Gönder</button>
                                <a href={talepMailtoLinki(t)} style={talepButonStili()}>Mail Programında Aç</a>
                                <button type="button" disabled={islemde} style={talepButonStili('#333', islemde)} onClick={() => handleTalepIslem(t, 'elle')}>Gönderdim</button>
                            </>
                        ) : (
                            <>
                                <button type="button" disabled={islemde} style={talepButonStili('#333', islemde)} onClick={() => handleTalepIslem(t, 'kontrol')}>Kontrol Et</button>
                                {t.durum === 'Gönderildi' && (
                                    <button type="button" disabled={islemde} style={talepButonStili(durum === 'Hatırlatılmalı' ? '#fd7e14' : '#333', islemde)} onClick={() => handleTalepIslem(t, 'gonder')}>Hatırlat</button>
                                )}
                                <button type="button" disabled={islemde} style={talepButonStili('#28a745', islemde)} onClick={() => handleTalepIslem(t, 'durum', 'Tamamlandı')}>Tamamlandı</button>
                            </>
                        )}
                        <button type="button" disabled={islemde} style={talepButonStili('#6c757d', islemde)} onClick={() => handleTalepIslem(t, 'durum', 'İptal')}>İptal</button>
                        {islemde && <span style={{ fontSize: '11px', color: '#888', alignSelf: 'center' }}>İşleniyor...</span>}
                    </div>
                )}
            </div>
        );
    };

    // Renk kodları ve stiller
    const kaynakRenkleri = { W: '#25d366', S: '#3783c2', R: '#f4bf4a' };
    const odemeRenkleri = { K: '#17bebb', E: '#6761a8', O: '#2c6184', D: '#bb999c', B: '#a32e68' };
    const statusIconStyle = {
        width: '20px', height: '20px', borderRadius: '50%', color: 'white', display: 'inline-flex', 
        alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold',
    };

    // Detay bandı için ortak stiller
    const detailStyles = {
        column: {
            flex: 1,
            padding: '15px',
            border: '1px solid #E0E0E0',
            borderRadius: '8px',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'Poppins, sans-serif',
            gap: '20px',
        },
        title: {
            fontWeight: '600',
            fontSize: '13px',
            color: '#555',
            textTransform: 'uppercase',
            borderBottom: '1px solid #eee',
            paddingBottom: '8px',
            margin: 0, // sütun başlıkları aynı hizada başlasın
            minHeight: '24px', // durum etiketi olan/olmayan başlıklar aynı yükseklikte
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center', // başlıklar kendi sütunlarında ortalı
            fontFamily: 'poppins'
        },

        button: {
            padding: '8px 16px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            background: '#f7f7f7',
            cursor: 'pointer',
            textAlign: 'center',
            fontSize: '13px',
            fontFamily: 'Poppins, sans-serif'
        },

        primaryButton: {
            padding: '10px 16px',
            border: 'none',
            borderRadius: '4px',
            background: '#28a745', // Yeşil renk
            color: 'white',
            cursor: 'pointer',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 'bold',
            fontfamily: 'poppins'
        },
        input: {
            width: '100%',
            padding: '8px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxSizing: 'border-box',
            fontfamily: 'poppins'
        },
        noteArea: {
            width: '100%',
            minHeight: '80px',
            padding: '8px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxSizing: 'border-box',
            fontFamily: 'poppins',
            fontSize: '13px',
        },
        actionGroup: {
            display: 'flex',
            alignItems: 'center',
            fontfamily: 'poppins',
            gap: '10px'
        }
    };

     const handleConfirmUpload = async () => {
        if (!selectedFile) return;

        setIsCsvModalOpen(false);
        setUploadStatus('Yükleniyor, lütfen bekleyin...');
        
        console.log('📤 CSV upload başlatılıyor...');
        console.log('📄 Seçili dosya:', selectedFile);
        
        const formData = new FormData();
        formData.append('file', selectedFile);

        try {
            console.log('🌐 Backend istek gonderiliyor...');
            const response = await fetch('/api/upload-csv', {
                method: 'POST',
                body: formData,
            });
            
            console.log('📡 Response status:', response.status);
            console.log('📡 Response ok:', response.ok);
            
            const result = await response.json();
            console.log('📊 Response data:', result);
            
            setUploadStatus(response.ok ? result.message : `Hata: ${result.message}`);
            if (response.ok) {
                if (vergiNoUyarilari.length > 0) {
                    // Vergi No uyarısı varsa önce uyarıyı göster, kapatınca yenile
                    setTimeout(() => setIsVergiUyariModalOpen(true), 500);
                } else {
                    setTimeout(() => window.location.reload(), 2000);
                }
            }
        } catch (error) {
            console.error('❌ CSV upload hatası:', error);
            setUploadStatus(`Yükleme sırasında bir ağ hatası oluştu: ${error.message}`);
        } finally {
            if(fileInputRef.current) fileInputRef.current.value = "";
            setSelectedFile(null);
        }
    };
    
    // --- Onay Ekranındaki "İptal" Butonunun Fonksiyonu ---
    const handleCancelUpload = () => {
        setIsCsvModalOpen(false);
        setSelectedFile(null);
        if(fileInputRef.current) fileInputRef.current.value = "";
    };
    return (
        <div style={{ background: '#F8F8F8', padding: '20px', borderRadius: '8px', height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>
            
            {/* --- İSTEDİĞİNİZ ŞEKİLDE GÜNCELLENMİŞ ÜST BAR --- */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexShrink: 0 }}>
                <style>{`
                .siparis-satiri {
                    transition: all 0.2s ease-in-out;
                }
                .ust-menu-secenek:not(:disabled):hover {
                    background: #f0f0f0 !important;
                }
                .siparis-satiri:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                    z-index: 10;
                    position: relative;
                }
                `}</style>
                
                {/* Sol Taraf: Tarih Filtresi ve Butonlar */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <label style={{ fontWeight: '500', fontFamily: 'poppins' }}>Tarih Seçiniz:</label>
                        <input
                            type="date"
                            value={seciliTarih}
                            onChange={(e) => setSeciliTarih(e.target.value)}
                            style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins', boxSizing: 'border-box' }}
                        />
                    </div>
                    
                    {/* Özdeş Butonlar */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {/* Yeni Sipariş Butonu */}
                        <button 
                            onClick={() => !isButtonDisabled() && handleModalOpen()} 
                            disabled={isButtonDisabled()}
                            style={{ 
                                padding: '5px 15px', 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '8px', 
                                cursor: isButtonDisabled() ? 'not-allowed' : 'pointer', 
                                border: '1px solid #ccc', 
                                borderRadius: '4px', 
                                fontFamily: 'poppins',
                                background: '#f8f8f8',
                                fontSize: '13px',
                                opacity: isButtonDisabled() ? '0.5' : '1'
                            }}>
                            <img src={PlusIcon} alt="Yeni" style={{ height: '14px' }} />
                            <span>Yeni Sipariş</span>
                        </button>
                        
                        {/* CSV Yükleme Butonu */}
                        <input 
                            type="file" 
                            accept=".csv" 
                            onChange={handleFileChange} 
                            ref={fileInputRef} 
                            style={{ display: 'none' }} 
                        />
                        <button 
                            onClick={handleBrowseClick}
                            disabled={isButtonDisabled()}
                            style={{
                                padding: '5px 15px', 
                                background: '#f8f8f8', 
                                fontFamily: 'poppins', 
                                alignItems: 'center', 
                                display: 'flex', 
                                border: '1px solid #ccc', 
                                borderRadius: '4px', 
                                gap: '8px',
                                cursor: isButtonDisabled() ? 'not-allowed' : 'pointer',
                                fontSize: '13px',
                                opacity: isButtonDisabled() ? '0.5' : '1'
                            }}
                        >
                            <img src={PlusIcon} alt="Yükle" style={{ height: '14px' }} />
                            <span>Toplu Yükle</span>
                        </button>
                    </div>
                    {uploadStatus && (
                        <div style={{
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            marginTop: '5px',
                            padding: '5px 10px',
                            background: '#f0f0f0',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontStyle: 'italic',
                            color: '#666',
                            zIndex: 10
                        }}>
                            {uploadStatus}
                        </div>
                    )}

                {/* --- Vergi No Uyarı Modalı --- */}
                {isVergiUyariModalOpen && (
                    <div style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100}}>
                        <div style={{backgroundColor: 'white', padding: '24px', borderRadius: '8px', fontFamily: 'poppins', minWidth: '380px', maxWidth: '520px', boxShadow: '0 4px 20px rgba(0,0,0,0.2)'}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px'}}>
                                <span style={{fontSize: '20px'}}>⚠️</span>
                                <strong style={{fontSize: '14px', color: '#856404'}}>Vergi Numarası Tespit Edildi</strong>
                            </div>
                            <p style={{fontSize: '13px', color: '#555', marginBottom: '14px'}}>Aşağıdaki siparişlerde T.C. Kimlik / Vergi No bilgisi bulunmaktadır. Lütfen kontrol ediniz:</p>
                            <ul style={{listStyle: 'none', padding: 0, margin: '0 0 20px 0', maxHeight: '220px', overflowY: 'auto'}}>
                                {vergiNoUyarilari.map((item, idx) => (
                                    <li key={idx} style={{fontSize: '13px', padding: '6px 10px', borderRadius: '4px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', marginBottom: '6px', color: '#333'}}>
                                        <strong>{item.ad_soyad || item.siparis_no}</strong> siparişinde Vergi numarası tespit edildi ve Fatura Bilgileri'ne aktarıldı
                                    </li>
                                ))}
                            </ul>
                            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                <button
                                    onClick={() => { setIsVergiUyariModalOpen(false); window.location.reload(); }}
                                    style={{padding: '6px 20px', background: '#856404', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontFamily: 'poppins', fontSize: '13px'}}
                                >
                                    Tamam
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* --- CSV Upload Onay Ekranı (Modal) --- */}
                {isCsvModalOpen && (
                    <div className="modal-overlay" style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000}}>
                        <div className="modal-content" style={{backgroundColor: 'white', padding: '20px', borderRadius: '5px', textAlign: 'center', fontFamily: 'poppins'}}>
                            <p style={{marginBottom: '15px', fontSize: '14px'}}>Seçilen CSV dosyasında <strong>{orderCount}</strong> adet benzersiz sipariş bulundu.</p>
                            <p style={{marginBottom: '20px', fontSize: '14px'}}>Siparişler panele yüklensin mi?</p>
                            <div style={{display: 'flex', justifyContent: 'center', gap: '10px'}}>
                                <button 
                                    onClick={handleConfirmUpload} 
                                    style={{
                                        padding: '5px 15px', 
                                        background: '#f8f8f8', 
                                        fontFamily: 'poppins', 
                                        alignItems: 'center', 
                                        display: 'flex', 
                                        border: '1px solid #28a745', 
                                        borderRadius: '4px', 
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        color: '#28a745'
                                    }}
                                >
                                    <span>Onayla ve Yükle</span>
                                </button>
                                <button 
                                    onClick={handleCancelUpload} 
                                    style={{
                                        padding: '5px 15px', 
                                        background: '#f8f8f8', 
                                        fontFamily: 'poppins', 
                                        alignItems: 'center', 
                                        display: 'flex', 
                                        border: '1px solid #6c757d', 
                                        borderRadius: '4px', 
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        color: '#6c757d'
                                    }}
                                >
                                    <span>İptal</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                    <input 
                        type="text"
                        placeholder="Müşteri veya Tel No Ara..."
                        value={aramaTerimi}
                        onChange={(e) => setAramaTerimi(e.target.value)}
                        style={{ 
                            padding: '5px', 
                            border: '1px solid #ccc', 
                            borderRadius: '4px',
                            width: '300px',
                            fontFamily: 'poppins',
                            fontSize: '13px'
                        }}
                    />
                </div>

                {/* Sağ Taraf: Toplu işlemler açılır menülerde toplanır */}
                <div ref={menuAlaniRef} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {renderUstMenu('ptt', PTTLogo, {}, 'PTT Kargo', null, [
                        { etiket: 'Toplu Etiket', onClick: handleTopluBarkodAl, disabled: isButtonDisabled() },
                        {
                            etiket: 'Etiket İptal',
                            onClick: () => setEtiketIptalParola(''),
                            disabled: seciliSiparisler.length === 0 || isButtonDisabled(),
                            title: 'Seçili siparişlerin barkodunu sistemden sil ve siparişi yeniden barkodsuz hale getir',
                            gizli: userRole !== 'admin'
                        }
                    ])}
                    {renderUstMenu('parasut', ParasutLogo, {}, 'Paraşüt',
                        topluFaturaIlerleme ? `Gönderiliyor ${topluFaturaIlerleme}`
                            : topluResmilestirIlerleme === 'hazırlanıyor' ? 'Hazırlanıyor...'
                            : topluResmilestirIlerleme ? `Resmileştiriliyor ${topluResmilestirIlerleme}` : null, [
                        {
                            etiket: 'Gönder',
                            onClick: () => handleTopluFaturaGonder(),
                            disabled: !seciliTarih || isButtonDisabled() || !!topluFaturaIlerleme,
                            title: !seciliTarih ? 'Lütfen tarih seçin' : 'Seçili siparişler için Paraşüt\'te fatura oluştur'
                        },
                        {
                            etiket: 'Kontrol',
                            onClick: handleFaturaKontrol,
                            disabled: isButtonDisabled() || faturaKontrol?.durum === 'yukleniyor',
                            title: seciliSiparisler.length > 0
                                ? 'Seçili siparişlerin proforma toplamını Paraşüt faturalarıyla karşılaştır'
                                : 'Listedeki siparişlerin proforma toplamını Paraşüt faturalarıyla karşılaştır'
                        },
                        {
                            etiket: 'Resmileştir',
                            onClick: () => handleTopluResmilestir(),
                            disabled: seciliSiparisler.length === 0 || isButtonDisabled() || !!topluResmilestirIlerleme,
                            title: 'Seçili siparişlerin kesilmiş faturalarını resmileştir (e-fatura / e-arşiv)'
                        }
                    ])}
                    {renderUstMenu('islemler', IslemlerIcon, { filter: 'invert(56%) sepia(69%) saturate(1877%) hue-rotate(356deg) brightness(98%) contrast(99%)' }, 'İşlemler',
                        yazdirIlerleme === 'hazırlanıyor' ? 'Hazırlanıyor...' : yazdirIlerleme ? `Hazırlanıyor ${yazdirIlerleme}` : null, [
                        {
                            etiket: 'Yazdır',
                            onClick: handleTopluYazdir,
                            disabled: seciliSiparisler.length === 0 || isButtonDisabled() || !!yazdirIlerleme,
                            title: 'Seçili siparişlerin etiket (ön yüz) ve e-faturasını (arka yüz) A5 çift taraflı yazdır'
                        },
                        { etiket: 'Tarih Değiştir', onClick: handleTopluTarihDegistir, disabled: seciliSiparisler.length === 0 || isButtonDisabled() },
                        { etiket: 'Çöpe At', onClick: handleTopluSil, disabled: seciliSiparisler.length === 0 || isButtonDisabled() },
                        { etiket: 'Teslim Evrakı', onClick: handleTeslimEvrakiAc, title: 'Seçili tarihin barkod teslim evrakını PDF olarak oluştur' }
                    ])}
                    {renderUstMenu('indirmeler', DownloadIcon, {}, 'İndirmeler',
                        efaturaIndirIlerleme === 'hazırlanıyor' ? 'Hazırlanıyor...' : efaturaIndirIlerleme ? `İndiriliyor ${efaturaIndirIlerleme}` : null, [
                        { etiket: 'Proformalar', onClick: () => handleTopluIndir('Proforma'), disabled: seciliSiparisler.length === 0 || isButtonDisabled() },
                        { etiket: 'Etiketler', onClick: () => handleTopluIndir('Etiket'), disabled: seciliSiparisler.length === 0 || isButtonDisabled() },
                        {
                            etiket: 'E-Faturalar',
                            onClick: handleTopluEFaturaIndir,
                            disabled: seciliSiparisler.length === 0 || isButtonDisabled() || !!efaturaIndirIlerleme,
                            title: 'Seçili siparişlerin resmileşmiş e-fatura / e-arşiv PDF\'lerini toplu indir'
                        }
                    ])}
                </div>
            </div>

            {/* Seçili Sipariş Sayısı - Fixed Popup */}
            {seciliSiparisler.length > 0 && (
                <div style={{ 
                    position: 'fixed',
                    bottom: '30px', // Alt köşe
                    right: '30px',
                    zIndex: 1000,
                    backgroundColor: '#ffffff',
                    border: '1px solid #000000', // İnce siyah çerçeve
                    borderRadius: '6px', // Biraz küçültüldü
                    padding: '8px 12px', // Padding küçültüldü
                    fontSize: '14px',
                    color: '#000000', // Siyah font
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '500',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    minWidth: '180px', // Biraz küçültüldü
                    textAlign: 'center',
                    animation: 'slideInFromRight 0.3s ease-out'
                }}>
                    {seciliSiparisler.length} Adet Sipariş Seçildi
                </div>
            )}

            {/* CSS Animation (inline style tag) */}
            <style>{`
                @keyframes slideInFromRight {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
            `}</style>

            {/* Sipariş Tablosu */}
            <div ref={listeKutusuRef} style={{ flex: 1, overflowY: 'auto', overflowX: 'auto', border: '1px solid #eee', borderRadius: '4px' }}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '13px' }}>
                <thead>
                    <tr style={{ background: '#E5E5E5', height: '35px' }}>
                        <th style={{ padding: '11px', width: '30px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>
                            <input 
                                type="checkbox"
                                onChange={handleTumunuSec}
                                checked={filtrelenmisSiparisler.length > 0 && seciliSiparisler.length === filtrelenmisSiparisler.length}
                            />
                        </th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '600', width: '20px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Sıra</th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '600', width: '90px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Telefon</th>
                        <th style={{ width: '180px', padding: '11px', textAlign: 'left', fontWeight: '600', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Ad Soyad</th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '600', width: '700px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Adres</th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '600', width: '120px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İl</th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '600', width: '120px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İlçe</th>
                        <th style={{ padding: '11px', textAlign: 'center', fontWeight: '600', width: '120px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Tutar</th>
                        <th style={{ padding: '11px', textAlign: 'center', fontWeight: '600', width: '100px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Durum</th>
                        <th style={{ padding: '11px', textAlign: 'center', fontWeight: '600', width: '40px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                        {filtrelenmisSiparisler.length > 0 ? (
                            filtrelenmisSiparisler.map((siparis, index) => (
                                <React.Fragment key={siparis.id}>
                                    
                                    {/* Tüm özellikler tek ve doğru <tr> etiketinin içinde */}
                                    <tr 
                                        className="siparis-satiri" 
                                        style={{ 
                                            backgroundColor: 
                                                siparis.kargo_durumu === 'Beklemede' ? '#fff4ccff' : 
                                                siparis.kargo_durumu === 'Acil' ? '#ffeeee' :
                                                (siparis.acik_talep_durumu || siparis.dt_kayit) ? 'rgba(173, 216, 230, 0.35)' :
                                                '#ffffff',
                                            borderBottom: '1px solid #eee',
                                            cursor: 'pointer',
                                            userSelect: 'none', // metin seçilmesin: uzun basıp sürüklerken seçime takılmasın
                                            WebkitUserSelect: 'none',
                                            borderLeft:
                                                siparis.kargo_durumu === 'Beklemede' ? '4px solid #ffc107' :
                                                siparis.kargo_durumu === 'Acil' ? '4px solid #dc3545' :
                                                siparis.acik_talep_durumu ? `4px solid ${TALEP_DURUM_RENKLERI[siparis.acik_talep_durumu] || '#4a90d9'}` :
                                                siparis.dt_kayit ? '4px solid #4a90d9' :
                                                'none',
                                            ...(suruklenenId === siparis.id ? {
                                                backgroundColor: '#eef4ff',
                                                boxShadow: '0 4px 14px rgba(0, 0, 0, 0.18)',
                                                position: 'relative',
                                                zIndex: 15,
                                                cursor: 'grabbing'
                                            } : {})
                                        }}
                                        data-siparis-id={siparis.id}
                                        onPointerDown={(e) => handleSatirPointerDown(e, siparis.id)}
                                        onPointerMove={handleSatirPointerMove}
                                        onPointerUp={uzunBasmaIptal}
                                        onPointerLeave={uzunBasmaIptal}
                                        onDragStart={(e) => e.preventDefault()} // ikonların tarayıcı sürüklemesi uzun basmayı bozmasın
                                        onClick={() => { if (!tiklamaEngelleRef.current) handleRowClick(siparis.id); }}
                                    >
                                        {/* Seçim Kutusu: kutunun kendisi seçer, hücrenin boşluğu detayı açar */}
                                        <td style={{ padding: '12px', textAlign: 'center', width: '30px' }}>
                                            <input
                                                type="checkbox"
                                                checked={seciliSiparisler.includes(siparis.id)}
                                                onChange={() => handleSecim(siparis.id)}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                        </td>
                                    <td style={{ padding: '11px', textAlign: 'center', fontWeight: '500', fontSize: '12px', width: '20px' }}>{index + 1}</td>
                                    <td style={{ padding: '11px', width: '90px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <span>{siparis.telefon_numarasi}</span>
                                            {siparis.alternatif_telefon && (
                                                <img src={TransferIcon} title={`Diğer numara: ${siparis.alternatif_telefon}`} alt="Alternatif numara" style={{ height: '13px', width: '13px', flexShrink: 0 }} />
                                            )}
                                        </div>
                                    </td>
                                    <td style={{ padding: '11px' }}>{siparis.ad_soyad}</td>
                                    <td style={{ padding: '11px', width: '500px' }}>{siparis.adres}</td>
                                    <td style={{ padding: '11px', width: '120px' }}>{siparis.il}</td>
                                    <td style={{ padding: '11px', width: '120px' }}>{siparis.ilce}</td>
                                    <td style={{ padding: '11px', textAlign: 'center', fontWeight: '400', width: '100px' }}>{(siparis.toplam_bedel || 0).toFixed(2)} ₺</td>
                                    <td style={{ padding: '11px', textAlign: 'center', width: '100px' }}>
                                        <div style={{ display: 'flex', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
                                            <span style={{ ...statusIconStyle, background: kaynakRenkleri[siparis.siparis_kaynagi] }}>{siparis.siparis_kaynagi}</span>
                                            <span style={{ ...statusIconStyle, background: odemeRenkleri[siparis.odeme_yontemi] }}>{siparis.odeme_yontemi}</span>
                                            <span title="Makine Baskısı" style={{ ...statusIconStyle, background: siparis.has_makine_baskisi ? '#93D82F' : '#F4885A' }}><img src={siparis.has_makine_baskisi ? TickIcon : CrossIcon} alt="Durum" style={{ height: '12px', width: '12px' }} /></span>
                                            <span title="Özel Baskı" style={{ ...statusIconStyle, background: siparis.has_ozel_baskisi ? '#93D82F' : '#F4885A' }}><img src={siparis.has_ozel_baskisi ? TickIcon : CrossIcon} alt="Durum" style={{ height: '12px', width: '12px' }} /></span>
                                            {/* Fatura Durumu İndikatörü */}
                                            {siparis.parasut_fatura_id && (
                                                <span 
                                                    title={faturaStatuslari[siparis.parasut_fatura_id]?.is_finalized ? 'Fatura Resmileşti' : 'Fatura Oluşturuldu'}
                                                    style={{ 
                                                        ...statusIconStyle, 
                                                        background: faturaStatuslari[siparis.parasut_fatura_id]?.is_finalized ? '#28a745' : '#ffc107',
                                                        color: 'white',
                                                        fontWeight: 'bold', 
                                                        fontSize: '11px', 
                                                        width: '20px', 
                                                        height: '20px', 
                                                        borderRadius: '50%', 
                                                        display: 'inline-flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center' 
                                                    }}
                                                >
                                                    {faturaStatuslari[siparis.parasut_fatura_id]?.is_finalized ? '✓' : 'F'}
                                                </span>
                                            )}
                                            {siparis.kargo_durumu === 'Beklemede' && (
                                                <span style={{ ...statusIconStyle, background: '#ffc107', color: 'black', 
                                                    fontWeight: 'bold', fontSize: '13px', width: '20px', height: '20px', borderRadius: '50%', display: 'inline-flex', 
                                                    alignItems: 'center', justifyContent: 'center', }}>B</span>
                                            )}
                                            {siparis.kargo_durumu === 'Acil' && (
                                                <span style={{ ...statusIconStyle, background: '#dc3545', color: 'white', 
                                                    fontWeight: 'bold', fontSize: '13px', width: '20px', height: '20px', borderRadius: '50%', display: 'inline-flex', 
                                                    alignItems: 'center', justifyContent: 'center', }}>A</span>
                                            )}
                                        </div>
                                    </td>
                                    {/* İşlemler: bu hücre detayı açmaz ve sürüklemeyi başlatmaz */}
                                    <td data-surukleme-yok style={{ padding: '12px', textAlign: 'center', width: '40px', cursor: 'default' }} onClick={(e) => e.stopPropagation()}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                            {userRole !== 'depo_operatoru' && (
                                                <button 
                                                    onClick={(e) => handleDefterdGosterToggle(siparis.id, e)}
                                                    title={siparis.defterde_goster ? "Defterde Gösteriliyor" : "Defterde Gizli"}
                                                    style={{ 
                                                        background: 'none', 
                                                        border: 'none', 
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '4px'
                                                    }}
                                                >
                                                    <img 
                                                        src={siparis.defterde_goster ? EyeIcon : EyeOffIcon} 
                                                        alt={siparis.defterde_goster ? "Göster" : "Gizle"} 
                                                        style={{ width: '16px', height: '16px' }} 
                                                    />
                                                </button>
                                            )}
                                            {/* Tarihe Gönder butonu - her zaman göster */}
                                            <button 
                                                onClick={(e) => { 
                                                    e.stopPropagation(); 
                                                    handleTarihDegistir(siparis.id);
                                                }}
                                                title="Tarihe Gönder"
                                                style={{ 
                                                    background: 'none', 
                                                    border: 'none', 
                                                    cursor: isButtonDisabled() ? 'not-allowed' : 'pointer',
                                                    opacity: isButtonDisabled() ? '0.5' : '1',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '4px'
                                                }}
                                                disabled={isButtonDisabled()}
                                            >
                                                <img 
                                                    src={CalendarIcon} 
                                                    alt="Tarihe Gönder" 
                                                    style={{ 
                                                        width: '16px', 
                                                        height: '16px',
                                                        filter: 'invert(59%) sepia(89%) saturate(2476%) hue-rotate(360deg) brightness(101%) contrast(102%)'
                                                    }} 
                                                />
                                            </button>
                                            <button 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    // Aktif proformaya göre düzenleme yap
                                                    if (acikSiparisId === siparis.id && activeProformaIndex > 0 && detayData?.ek_siparisler?.length >= activeProformaIndex) {
                                                        const ek = detayData.ek_siparisler[activeProformaIndex - 1];
                                                        handleEkSiparisDuzenleAc(detayData, ek.id);
                                                    } else {
                                                        handleSiparisDuzenle(siparis.id);
                                                    }
                                                }} 
                                                title={acikSiparisId === siparis.id && activeProformaIndex > 0 ? `EK-${activeProformaIndex} Düzenle` : 'Düzenle'}
                                                style={{ 
                                                    background: 'none', 
                                                    border: 'none', 
                                                    cursor: isButtonDisabled() ? 'not-allowed' : 'pointer',
                                                    opacity: isButtonDisabled() ? '0.5' : '1',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '4px'
                                                }}
                                                disabled={isButtonDisabled()}
                                            >
                                                <img src={EditIcon} alt="Düzenle" style={{ width: '15px', height: '15px' }} />
                                            </button>
                                            <button 
                                                onClick={(e) => { e.stopPropagation(); handleSiparisSil(siparis.id); }}
                                                title="Sil"
                                                style={{ 
                                                    background: 'none', 
                                                    border: 'none', 
                                                    cursor: isButtonDisabled() ? 'not-allowed' : 'pointer',
                                                    opacity: isButtonDisabled() ? '0.5' : '1',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '4px'
                                                }}
                                                disabled={isButtonDisabled()}
                                            >
                                                <img src={RecycleBinIcon} alt="Sil" style={{ width: '15px', height: '15px', filter: 'invert(19%) sepia(97%) saturate(4632%) hue-rotate(350deg) brightness(93%) contrast(92%)' }} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                
                                {/* YENİ TASARIM: 2. Açılır Detay Bandı Satırı (Koşullu) */}
                                {acikSiparisId === siparis.id && (
                                    <tr className="detay-bandi">
                                        <td colSpan="10" style={{ padding: '10px', background: '#f2f4f7' }}>
                                            {!detayData ? (
                                                <p>Sipariş detayları yükleniyor...</p>
                                            ) : (
                                                <div style={{ display: 'flex', gap: '20px', fontFamily: 'Poppins' }}>
                                                    
                                                    {/* SÜTUN 1: Sipariş Formu (Proforma) - proforma genişliğinde, üstteki satırlar ona hizalı */}
                                                    <div style={{ ...detailStyles.column, flex: '0 0 auto', gap: '14px' }}>
                                                        <h3 style={detailStyles.title}>SİPARİŞ FORMU</h3>

                                                        {/* Gönderim Numarası: kutucuk işaretlenince numara değiştirilebilir */}
                                                        {userRole !== 'depo_operatoru' && (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={numaraCheckbox}
                                                                    onChange={(e) => {
                                                                        setNumaraCheckbox(e.target.checked);
                                                                        if (!e.target.checked) setAlternatifTel('');
                                                                    }}
                                                                    title="Numarayı değiştir"
                                                                    style={{ cursor: 'pointer', margin: 0, flexShrink: 0 }}
                                                                />
                                                                <label style={{ margin: 0, fontSize: '12px', fontWeight: '500' }}>Gönderim Numarası:</label>
                                                                <input
                                                                    type="text"
                                                                    style={{ ...detailStyles.input, flex: 1, minWidth: '80px', height: '27px', padding: '0 6px', fontSize: '12px' }}
                                                                    value={numaraCheckbox ? alternatifTel : (detayData?.musteri?.telefon_numarasi || '')}
                                                                    onChange={(e) => setAlternatifTel(e.target.value)}
                                                                    disabled={!numaraCheckbox}
                                                                />
                                                                <button
                                                                    style={{
                                                                        height: '27px', padding: '0 10px', background: '#F8F8F8', color: 'black',
                                                                        borderRadius: '8px', cursor: 'pointer', fontSize: '13px', display: 'flex',
                                                                        alignItems: 'center', justifyContent: 'center', fontWeight: '500',
                                                                        border: '1px solid #ccc', flexShrink: 0, fontFamily: 'Poppins, sans-serif'
                                                                    }}
                                                                    onClick={() => handleSaveGonderimNumarasi()}
                                                                    disabled={!detayData || !numaraCheckbox}
                                                                >
                                                                    Kaydet
                                                                </button>
                                                            </div>
                                                        )}

                                                        {/* Gönder / İndir + E B T G N işlem butonları */}
                                                        {(() => {
                                                            const ekler = detayData.ek_siparisler || [];
                                                            const tekrarlar = detayData.tekrar_gonderimler || [];
                                                            const telefon = (numaraCheckbox && alternatifTel) ? alternatifTel : detayData.musteri?.telefon_numarasi;

                                                            // Aktif sekmeye (ana / ek / tekrar) göre indirme ve gönderme
                                                            let indir = null;
                                                            let gonder = null;
                                                            let kisitli = false;
                                                            if (activeTekrarIndex !== null) {
                                                                const tekrar = tekrarlar[activeTekrarIndex];
                                                                if (tekrar) {
                                                                    // Proforma sarmalayıcısı "ek-proforma-download-tekrar-{id}" olduğu için id'yi buna göre veriyoruz
                                                                    const indirmeData = { ...tekrar, id: `tekrar-${tekrar.id}` };
                                                                    const tekrarTel = (numaraCheckbox && alternatifTel) ? alternatifTel : tekrar.musteri?.telefon_numarasi;
                                                                    indir = () => handleDownloadEkJpg(indirmeData, tekrar.musteri, `Tekrar-${tekrar.sira}`);
                                                                    gonder = () => handleSendEkWhatsapp(indirmeData, tekrar.musteri, tekrarTel);
                                                                }
                                                            } else if (activeProformaIndex === 0) {
                                                                indir = () => handleDownloadJpg(detayData);
                                                                gonder = handleSendWhatsapp;
                                                                kisitli = isButtonDisabled();
                                                            } else {
                                                                const ekSiparis = ekler[activeProformaIndex - 1];
                                                                if (ekSiparis) {
                                                                    indir = () => handleDownloadEkJpg(ekSiparis, detayData.musteri);
                                                                    gonder = () => handleSendEkWhatsapp(ekSiparis, detayData.musteri, telefon);
                                                                }
                                                            }
                                                            const butonStili = {
                                                                width: '90px', height: '27px', background: '#F8F8F8', borderRadius: '8px',
                                                                border: '1px solid #ccc', cursor: kisitli ? 'not-allowed' : 'pointer',
                                                                padding: '0 12px', fontWeight: '500', display: 'flex', alignItems: 'center',
                                                                justifyContent: 'center', gap: '5px', opacity: kisitli ? '0.5' : '1', flexShrink: 0,
                                                                fontFamily: 'Poppins, sans-serif'
                                                            };

                                                            const ekSayisi = ekler.length;
                                                            const beklemede = detayData.kargo_durumu === 'Beklemede';
                                                            const tekrarGonderilemez = isButtonDisabled() || !detayData.kargo_takip_no;
                                                            const notVar = !!(detayData.siparis_notu || '').trim();

                                                            return (
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}>
                                                                    {gonder && (
                                                                        <button type="button" onClick={gonder} disabled={kisitli} style={butonStili}>
                                                                            <img src={WhatsappIcon} alt="Gönder" style={{ height: '16px' }} />
                                                                            <span>Gönder</span>
                                                                        </button>
                                                                    )}
                                                                    {indir && (
                                                                        <button type="button" onClick={indir} disabled={kisitli} style={butonStili}>
                                                                            <img src={DownloadIcon} alt="İndir" style={{ height: '16px' }} />
                                                                            <span>İndir</span>
                                                                        </button>
                                                                    )}
                                                                    <div style={{ display: 'flex', gap: '6px', marginLeft: 'auto' }}>
                                                                        {renderHarfButonu({
                                                                            harf: 'E', renk: '#1565C0', aktif: ekSayisi > 0,
                                                                            aciklama: ekSayisi >= 3 ? 'Ek Sipariş (en fazla 3 ek eklenebilir)' : `Ek Sipariş Oluştur${ekSayisi > 0 ? ` (${ekSayisi}/3)` : ''}`,
                                                                            disabled: isButtonDisabled() || ekSayisi >= 3,
                                                                            onClick: () => handleEkSiparisAc(detayData)
                                                                        })}
                                                                        {renderHarfButonu({
                                                                            harf: 'B', renk: '#ffc107', aktif: beklemede,
                                                                            aciklama: beklemede ? 'Beklemede (beklemeden çıkarmak için tıklayın - yalnızca yönetici)' : 'Siparişi Beklet',
                                                                            onClick: () => beklemede ? handleBeklemedenCikar(detayData.id) : handleBeklemeyeAl(detayData.id)
                                                                        })}
                                                                        {renderHarfButonu({
                                                                            harf: 'T', renk: '#6f42c1', aktif: !!detayData.is_tracked,
                                                                            aciklama: detayData.is_tracked ? 'Takip Ediliyor (takipten çıkarmak için tıklayın)' : 'Takibe Al',
                                                                            onClick: () => handleTakipDegistir(detayData.id, !detayData.is_tracked)
                                                                        })}
                                                                        {renderHarfButonu({
                                                                            harf: 'G', renk: '#fd7e14', aktif: tekrarlar.length > 0,
                                                                            aciklama: detayData.kargo_takip_no ? 'Tekrar Gönder (siparişi son haliyle yeni barkodla tekrar gönder)' : 'Tekrar Gönder (önce gönderi barkodu oluşturulmalı)',
                                                                            disabled: tekrarGonderilemez,
                                                                            onClick: () => handleTekrarGonderAc(detayData)
                                                                        })}
                                                                        {renderHarfButonu({
                                                                            harf: 'N', renk: '#28a745', aktif: notVar,
                                                                            aciklama: notVar ? 'Notu Düzenle' : 'Not Ekle',
                                                                            onClick: () => { setMusteriNotu(detayData.siparis_notu || ''); setNotModalAcik(true); }
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })()}

                                                        {/* Proforma Navigasyon Sekmeleri (Ana / Ek / Tekrar) */}
                                                        {(() => {
                                                            const ekler = detayData.ek_siparisler || [];
                                                            const tekrarlar = detayData.tekrar_gonderimler || [];
                                                            if (ekler.length === 0 && tekrarlar.length === 0) return null;
                                                            const aktifEk = activeTekrarIndex === null && activeProformaIndex > 0 ? ekler[activeProformaIndex - 1] : null;
                                                            const aktifTekrar = activeTekrarIndex !== null ? tekrarlar[activeTekrarIndex] : null;
                                                            return (
                                                                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
                                                                    <button
                                                                        onClick={() => { setActiveProformaIndex(0); setActiveTekrarIndex(null); }}
                                                                        style={{
                                                                            padding: '4px 12px', borderRadius: '4px', border: '1px solid #ccc',
                                                                            background: activeProformaIndex === 0 && activeTekrarIndex === null ? '#1565C0' : '#f8f8f8',
                                                                            color: activeProformaIndex === 0 && activeTekrarIndex === null ? 'white' : '#333',
                                                                            cursor: 'pointer', fontSize: '12px', fontFamily: 'Poppins', fontWeight: '500'
                                                                        }}
                                                                    >Ana Sipariş</button>
                                                                    {ekler.map((ek, i) => (
                                                                        <button key={ek.id}
                                                                            onClick={() => { setActiveProformaIndex(i + 1); setActiveTekrarIndex(null); }}
                                                                            style={{
                                                                                padding: '4px 12px', borderRadius: '4px', border: '1px solid #ccc',
                                                                                background: activeTekrarIndex === null && activeProformaIndex === i + 1 ? '#1565C0' : '#f8f8f8',
                                                                                color: activeTekrarIndex === null && activeProformaIndex === i + 1 ? 'white' : '#1565C0',
                                                                                cursor: 'pointer', fontSize: '12px', fontFamily: 'Poppins', fontWeight: '500'
                                                                            }}
                                                                        >Ek-{ek.sira}</button>
                                                                    ))}
                                                                    {tekrarlar.map((t, i) => (
                                                                        <button key={`tekrar-${t.id}`}
                                                                            onClick={() => {
                                                                                setActiveProformaIndex(0);
                                                                                setActiveTekrarIndex(i);
                                                                                if (t.kargo_takip_no) setAktifBarkod(t.kargo_takip_no);
                                                                            }}
                                                                            style={{
                                                                                padding: '4px 12px', borderRadius: '4px', border: '1px solid #fd7e14',
                                                                                background: activeTekrarIndex === i ? '#fd7e14' : '#fff3e0',
                                                                                color: activeTekrarIndex === i ? 'white' : '#e8590c',
                                                                                cursor: 'pointer', fontSize: '12px', fontFamily: 'Poppins', fontWeight: '500'
                                                                            }}
                                                                        >Tekrar-{t.sira}</button>
                                                                    ))}
                                                                    {/* Tekrar gönderim seçiliyken sil butonu */}
                                                                    {aktifTekrar && (
                                                                        <button onClick={() => handleTekrarGonderimSil(detayData.id, aktifTekrar)}
                                                                            disabled={isButtonDisabled()}
                                                                            style={{ marginLeft: 'auto', padding: '3px 8px', background: '#fff0f0', borderRadius: '4px', border: '1px solid #dc3545', cursor: isButtonDisabled() ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '4px', opacity: isButtonDisabled() ? 0.5 : 1, fontSize: '11px', fontFamily: 'Poppins' }}
                                                                            title={`Tekrar-${aktifTekrar.sira} kaydını sil`}>
                                                                            <img src={DeleteIcon} alt="Sil" style={{ height: '12px' }} />
                                                                        </button>
                                                                    )}
                                                                    {/* Ek sipariş seçiliyken sil butonu */}
                                                                    {aktifEk && (
                                                                        <button onClick={() => handleEkSiparisSil(detayData.id, aktifEk.id, aktifEk.sira)}
                                                                            disabled={isButtonDisabled()}
                                                                            style={{ marginLeft: 'auto', padding: '3px 8px', background: '#fff0f0', borderRadius: '4px', border: '1px solid #dc3545', cursor: isButtonDisabled() ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '4px', opacity: isButtonDisabled() ? 0.5 : 1, fontSize: '11px', fontFamily: 'Poppins' }}
                                                                            title={`Ek-${aktifEk.sira} siparişini sil`}>
                                                                            <img src={DeleteIcon} alt="Sil" style={{ height: '12px' }} />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}

                                                        {/* Sipariş notu (N butonuyla eklenir/düzenlenir) */}
                                                        {(detayData.siparis_notu || '').trim() && (
                                                            <div style={{ width: '417px', boxSizing: 'border-box', display: 'flex', alignItems: 'flex-start', gap: '6px', background: '#eaf6ec', borderLeft: '3px solid #28a745', borderRadius: '4px', padding: '5px 8px', fontSize: '12px' }}>
                                                                <span
                                                                    onClick={() => { setMusteriNotu(detayData.siparis_notu || ''); setNotModalAcik(true); }}
                                                                    title="Notu düzenle"
                                                                    style={{ flex: 1, whiteSpace: 'pre-wrap', wordBreak: 'break-word', cursor: 'pointer' }}
                                                                >
                                                                    <strong style={{ color: '#28a745' }}>Not:</strong> {detayData.siparis_notu}
                                                                </span>
                                                                <button onClick={handleNotSil} title="Notu sil"
                                                                    style={{ padding: '2px 4px', background: 'transparent', border: 'none', cursor: 'pointer', flexShrink: 0, display: 'flex' }}>
                                                                    <img src={DeleteIcon} alt="Sil" style={{ height: '12px' }} />
                                                                </button>
                                                            </div>
                                                        )}

                                                        {/* Ödeme Durumu (EFT / Havale siparişlerinde) */}
                                                        {detayData.odeme_yontemi === 'E' && activeProformaIndex === 0 && activeTekrarIndex === null && (
                                                            <div style={{ width: '417px', boxSizing: 'border-box', display: 'flex', justifyContent: 'space-between', gap: '8px', whiteSpace: 'nowrap', background: '#f0f0f0', borderLeft: `4px solid ${getDurumRengi(detayData.odeme_durumu)}`, borderRadius: '4px', padding: '5px 8px', fontSize: '11px' }}>
                                                                <strong style={{ color: getDurumRengi(detayData.odeme_durumu) }}>{detayData.odeme_durumu || 'Yükleniyor...'}</strong>
                                                                <span style={{ color: '#555' }}>Toplam: {(detayData.toplam_bedel || 0).toFixed(2)} ₺</span>
                                                                <span style={{ color: '#555' }}>Ödenen: {(detayData.odenen_bedel || 0).toFixed(2)} ₺</span>
                                                                <strong>Kalan: {((detayData.toplam_bedel || 0) - (detayData.odenen_bedel || 0)).toFixed(2)} ₺</strong>
                                                            </div>
                                                        )}

                                                        {/* Proforma Önizlemesi - Ana, Ek veya Tekrar (tam boyut) */}
                                                        <div>
                                                            <div>
                                                            {activeTekrarIndex !== null ? (
                                                                (() => {
                                                                    const tekrar = (detayData.tekrar_gonderimler || [])[activeTekrarIndex];
                                                                    if (!tekrar) return null;
                                                                    const tekrarData = { ...tekrar, id: `tekrar-${tekrar.id}`, siparis_tarihi: tekrar.olusturma_tarihi || detayData.siparis_tarihi };
                                                                    return (
                                                                        <div id={`ek-proforma-download-tekrar-${tekrar.id}`}>
                                                                            <ProformaPreview detayData={tekrarData} ekLabel={`Tekrar-${tekrar.sira}`} />
                                                                        </div>
                                                                    );
                                                                })()
                                                            ) : activeProformaIndex === 0 ? (
                                                                <ProformaPreview detayData={detayData} />
                                                            ) : (
                                                                (() => {
                                                                    const ekSiparis = (detayData.ek_siparisler || [])[activeProformaIndex - 1];
                                                                    if (!ekSiparis) return null;
                                                                    const ekData = { ...ekSiparis, id: `ek-${ekSiparis.id}`, musteri: detayData.musteri, siparis_tarihi: ekSiparis.olusturma_tarihi || detayData.siparis_tarihi };
                                                                    return (
                                                                        <div id={`ek-proforma-download-${ekSiparis.id}`}>
                                                                            <ProformaPreview detayData={ekData} ekLabel={`Ek-${ekSiparis.sira}`} />
                                                                        </div>
                                                                    );
                                                                })()
                                                            )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* SÜTUN 2: Faturalama (ortada, en az üçte bir genişlik; kalan boşluğu da alır) */}
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', flex: '1 0 calc((100% - 40px) / 3)', minWidth: 0 }}>
                                                    <div style={detailStyles.column}>
                                                        <h3 style={{ ...detailStyles.title, gap: '8px' }}>
                                                            <span>FATURALAMA İŞLEMLERİ</span>
                                                            {(() => {
                                                                // Aktif sekmedeki (ana / ek) fatura Paraşüt'te iptal edildiyse başlığın yanında gösterilir
                                                                const ek = activeProformaIndex > 0 ? (detayData.ek_siparisler || [])[activeProformaIndex - 1] : null;
                                                                const kayit = activeProformaIndex === 0 ? detayData : ek;
                                                                if (!kayit || !kayit.parasut_fatura_id) return null;
                                                                const st = faturaStatuslari[kayit.parasut_fatura_id];
                                                                return st?.iptal_edildi ? renderFaturaDurumEtiketi(null, true) : null;
                                                            })()}
                                                        </h3>

                                                        {/* Faturalama sekme navigasyonu (ek sipariş varsa) */}
                                                        {(detayData.ek_siparisler || []).length > 0 && (
                                                            <div style={{ display: 'flex', gap: '6px', marginBottom: '12px', flexWrap: 'wrap' }}>
                                                                <button onClick={() => setActiveProformaIndex(0)}
                                                                    style={{ padding: '3px 10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', fontFamily: 'Poppins', fontWeight: '500', cursor: 'pointer', background: activeProformaIndex === 0 ? '#1565C0' : '#f8f8f8', color: activeProformaIndex === 0 ? 'white' : '#333' }}>
                                                                    Ana Sipariş
                                                                </button>
                                                                {(detayData.ek_siparisler || []).map((ek, i) => (
                                                                    <button key={ek.id} onClick={() => setActiveProformaIndex(i + 1)}
                                                                        style={{ padding: '3px 10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', fontFamily: 'Poppins', fontWeight: '500', cursor: 'pointer', background: activeProformaIndex === i + 1 ? '#1565C0' : '#f8f8f8', color: activeProformaIndex === i + 1 ? 'white' : '#1565C0' }}>
                                                                        Ek-{ek.sira}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {activeProformaIndex === 0 ? (
                                                            /* ANA SİPARİŞ FATURA */
                                                            <>
                                                        {/* Henüz fatura oluşturulmamışsa "Oluştur" butonunu göster */}
                                                        {!detayData.parasut_fatura_id ? (
                                                            <div>
                                                                {/* E-Fatura Oluştur | E-Fatura Bağla (isim/adres/telefon/vergi no backend'de kayıtlı fatura bilgilerinden alınır) */}
                                                                {renderFaturaOlusturBagla('ana', () => handleCreateParasutInvoice(detayData.id))}

                                                                {/* Fatura bilgileri (Düzenle ikonuyla değiştirilir, E-Fatura bu bilgilerle oluşturulur) */}
                                                                {renderFaturaBilgileri('ana', detayData.fatura_bilgileri, true)}
                                                            </div>
                                                        ) : (
                                                            /* Fatura oluşturulmuş */
                                                            <div>
                                                                {faturaStatuslari[detayData.parasut_fatura_id]?.is_finalized ? (
                                                                    /* Resmileşmiş: fatura bilgileri yerine e-fatura önizlemesi */
                                                                    <FaturaOnizleme
                                                                        faturaId={detayData.parasut_fatura_id}
                                                                        onIndir={() => handleDownloadInvoicePdf(detayData.parasut_fatura_id)}
                                                                        telefon={(alternatifTel && alternatifTel.trim()) ? alternatifTel : proformaTel}
                                                                        onIptal={isButtonDisabled() ? null : () => handleFaturaIptal(detayData.parasut_fatura_id, true)}
                                                                        iptalEdiliyor={!!faturaIptalEdiliyor[detayData.parasut_fatura_id]}
                                                                        iptalEdildi={!!faturaStatuslari[detayData.parasut_fatura_id]?.iptal_edildi}
                                                                    />
                                                                ) : (
                                                                (() => {
                                                                    // Resmileşene kadar taslak kontrol edilebilir ve fatura bilgileri düzenlenebilir
                                                                    const resmilesti = detayData.fatura_bilgileri?.sabit;
                                                                    return (
                                                                        <>
                                                                            {!resmilesti && renderTaslakIslemleri('ana', detayData.parasut_fatura_id)}
                                                                            <div style={{ marginTop: '15px' }}>
                                                                                {renderFaturaBilgileri('ana', detayData.fatura_bilgileri, !resmilesti, true)}
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })()
                                                                )}
                                                            </div>
                                                        )}
                                                        {renderIptalGecmisi(detayData.iptal_faturalar)}
                                                            </>
                                                        ) : (
                                                            /* EK SİPARİŞ FATURA */
                                                            (() => {
                                                                const ekSiparis = (detayData.ek_siparisler || [])[activeProformaIndex - 1];
                                                                if (!ekSiparis) return null;
                                                                return (
                                                                    <div>
                                                                        {!ekSiparis.parasut_fatura_id ? (
                                                                            <div>
                                                                                {/* Bilgiler backend'de ek siparişin kayıtlı fatura bilgilerinden alınır */}
                                                                                {renderFaturaOlusturBagla(ekSiparis.id, () => handleEkFaturaOlustur(detayData.id, ekSiparis.id, null), ` (Ek-${ekSiparis.sira})`)}
                                                                                {renderFaturaBilgileri(ekSiparis.id, ekSiparis.fatura_bilgileri, true)}
                                                                            </div>
                                                                        ) : (
                                                                            <div>
                                                                                {(() => {
                                                                                    const ekResmilesti = ekSiparis.fatura_bilgileri?.sabit || faturaStatuslari[ekSiparis.parasut_fatura_id]?.is_finalized;
                                                                                    return (
                                                                                        <>
                                                                                            {ekResmilesti ? (
                                                                                                <FaturaOnizleme
                                                                                                    faturaId={ekSiparis.parasut_fatura_id}
                                                                                                    onIndir={() => handleDownloadInvoicePdf(ekSiparis.parasut_fatura_id)}
                                                                                                    telefon={(numaraCheckbox && alternatifTel) ? alternatifTel : detayData.musteri?.telefon_numarasi}
                                                                                                    onIptal={isButtonDisabled() ? null : () => handleFaturaIptal(ekSiparis.parasut_fatura_id, true)}
                                                                                                    iptalEdiliyor={!!faturaIptalEdiliyor[ekSiparis.parasut_fatura_id]}
                                                                                                    iptalEdildi={!!faturaStatuslari[ekSiparis.parasut_fatura_id]?.iptal_edildi}
                                                                                                />
                                                                                            ) : (
                                                                                            <>
                                                                                            {renderTaslakIslemleri(ekSiparis.id, ekSiparis.parasut_fatura_id)}
                                                                                            <div style={{ marginTop: '15px' }}>
                                                                                                {renderFaturaBilgileri(ekSiparis.id, ekSiparis.fatura_bilgileri, true, true)}
                                                                                            </div>
                                                                                            </>
                                                                                            )}
                                                                                        </>
                                                                                    );
                                                                                })()}
                                                                            </div>
                                                                        )}
                                                                        {renderIptalGecmisi(ekSiparis.iptal_faturalar)}
                                                                    </div>
                                                                );
                                                            })()
                                                        )}
                                                    </div>
                                                    </div>

                                                    {/* SÜTUN 3: Gönderi Takip (teslimat işlemleri dahil, etiket genişliğinde) */}
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', flex: '0 0 auto', width: 'calc(12cm + 32px)' }}>
                                                        {/* Sütun 3: Gönderi Takip İşlemleri (kargo etiketi genişliğinde: 12cm) */}
                                                        <div style={{ ...detailStyles.column, width: '12cm' }}>
                                                            <h3 style={{...detailStyles.title, display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap'}}>
                                                                GÖNDERİ TAKİP İŞLEMLERİ
                                                                {(detayData.tekrar_gonderimler || []).length > 0 && (
                                                                    <span style={{
                                                                        background: '#f8d7da',
                                                                        border: '1px solid #dc3545',
                                                                        color: '#842029',
                                                                        borderRadius: '4px',
                                                                        padding: '2px 8px',
                                                                        fontSize: '12px',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        Yeniden Gönderildi{detayData.tekrar_gonderimler.length > 1 ? ` (${detayData.tekrar_gonderimler.length})` : ''}
                                                                    </span>
                                                                )}
                                                            </h3>
                                                            
                                                            {detayData.elden_teslim ? renderEldenTeslimBilgisi() : !detayData.kargo_takip_no ? (
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }} onClick={(e) => e.stopPropagation()}>
                                                                    {/* Gönderi tipi: Standart (varsayılan) | Alıcı Ödemeli (parola ister) */}
                                                                    <div style={{ display: 'flex', gap: '20px', fontFamily: 'poppins', fontSize: '13px' }}>
                                                                        {[['G', 'Standart Gönderi'], ['A', 'Alıcı Ödemeli']].map(([tip, etiket]) => (
                                                                            <label key={tip} style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                                                                                <input type="radio" name={`gonderi-tipi-${detayData.id}`} checked={gonderiTipi === tip}
                                                                                    onChange={() => setGonderiTipi(tip)} disabled={isButtonDisabled()} />
                                                                                {etiket}
                                                                            </label>
                                                                        ))}
                                                                    </div>
                                                                    <button
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            gap: '8px',
                                                                            width: '100%',
                                                                            padding: '10px',
                                                                            cursor: isButtonDisabled() ? 'not-allowed' : 'pointer',
                                                                            fontFamily: "'Poppins', sans-serif",
                                                                            fontSize: '13px',
                                                                            fontWeight: '400',
                                                                            background: '#f8f8f8',
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '4px',
                                                                            opacity: isButtonDisabled() ? '0.5' : '1'
                                                                        }}
                                                                        onClick={() => {
                                                                            if (isButtonDisabled()) return;
                                                                            if (gonderiTipi === 'A') setAliciOdemeliParola('');
                                                                            else handleCreatePttShipment(detayData.id, 'G');
                                                                        }}
                                                                        disabled={isButtonDisabled()}
                                                                    >
                                                                        <img src={PTTLogo} alt="Takip Numarası Oluştur" style={{ height: '14px' }} /><span>Takip Numarası Oluştur</span>
                                                                    </button>
                                                                    {renderTeslimatButonlari()}
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    {/* Takip Numarası ve Butonlar */}
                                                                    <div>
                                                                        <div style={{display: 'flex', gap: '8px', alignItems: 'center'}} onClick={(e) => e.stopPropagation()}>
                                                                            {/* Açılır Liste - Ana ve Ek Barkodlar */}
                                                                            <select
                                                                                title="PTT Kargo Takip Numarası"
                                                                                style={{...detailStyles.input, flex: 1, minWidth: 0, background: '#e9ecef', fontWeight: 'bold', fontFamily: 'Poppins', fontSize: '11px', cursor: 'pointer', height: '27px', lineHeight: '27px', paddingTop: '0', paddingBottom: '0', paddingLeft: '6px', paddingRight: '2px'}}
                                                                                value={aktifBarkod}
                                                                                onChange={(e) => setAktifBarkod(e.target.value)}
                                                                            >
                                                                                {/* Ana Barkod */}
                                                                                <option value={detayData.kargo_takip_no || ''}>
                                                                                    {detayData.kargo_takip_no || 'Barkod Yok'}
                                                                                </option>
                                                                                {/* Ek Barkodlar */}
                                                                                {detayData.paketler && detayData.paketler.map((paket, index) => (
                                                                                    <option key={paket.id} value={paket.kargo_takip_no}>
                                                                                        {paket.kargo_takip_no} ({index + 2}){(() => {
                                                                                            const tekrar = (detayData.tekrar_gonderimler || []).find(t => t.kargo_takip_no === paket.kargo_takip_no);
                                                                                            return tekrar ? ` - Tekrar-${tekrar.sira}` : '';
                                                                                        })()}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                            <button
                                                                                type="button"
                                                                                style={islemButonStili(!aktifBarkod)}
                                                                                title="Barkod numarasını kopyala"
                                                                                onClick={(e) => {
                                                                                    if (!aktifBarkod) return;
                                                                                    const svg = e.currentTarget.querySelector('svg path');
                                                                                    navigator.clipboard.writeText(aktifBarkod).then(() => {
                                                                                        // Başarılı kopyalama geri bildirimi
                                                                                        if (svg) svg.style.fill = '#28a745';
                                                                                        setTimeout(() => {
                                                                                            if (svg) svg.style.fill = '#000000';
                                                                                        }, 500);
                                                                                    }).catch(err => {
                                                                                        console.error('Kopyalama hatası:', err);
                                                                                        alert('Kopyalama başarısız oldu');
                                                                                    });
                                                                                }}
                                                                                disabled={!aktifBarkod}
                                                                            >
                                                                                <svg width='16' height='16' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' style={{flexShrink: 0}}>
                                                                                    <g transform="matrix(1.43 0 0 1.43 12 12)">
                                                                                        <path style={{fill: '#000000', transition: 'fill 0.3s'}} transform="translate(-8, -7.5)" d="M 2.5 1 C 1.675781 1 1 1.675781 1 2.5 L 1 10.5 C 1 11.324219 1.675781 12 2.5 12 L 4 12 L 4 12.5 C 4 13.324219 4.675781 14 5.5 14 L 13.5 14 C 14.324219 14 15 13.324219 15 12.5 L 15 4.5 C 15 3.675781 14.324219 3 13.5 3 L 12 3 L 12 2.5 C 12 1.675781 11.324219 1 10.5 1 Z M 2.5 2 L 10.5 2 C 10.78125 2 11 2.21875 11 2.5 L 11 10.5 C 11 10.78125 10.78125 11 10.5 11 L 2.5 11 C 2.21875 11 2 10.78125 2 10.5 L 2 2.5 C 2 2.21875 2.21875 2 2.5 2 Z M 12 4 L 13.5 4 C 13.78125 4 14 4.21875 14 4.5 L 14 12.5 C 14 12.78125 13.78125 13 13.5 13 L 5.5 13 C 5.21875 13 5 12.78125 5 12.5 L 5 12 L 10.5 12 C 11.324219 12 12 11.324219 12 10.5 Z" strokeLinecap="round" />
                                                                                    </g>
                                                                                </svg>
                                                                                <span>Kopyala</span>
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                style={islemButonStili(isShipmentUpdateDisabled() || !aktifBarkod || aktifBarkod !== detayData.kargo_takip_no)}
                                                                                onClick={() => {
                                                                                    if (!isShipmentUpdateDisabled() && aktifBarkod === detayData.kargo_takip_no) {
                                                                                        handleUpdatePttShipment(detayData.id);
                                                                                    }
                                                                                }}
                                                                                disabled={isShipmentUpdateDisabled() || !aktifBarkod || aktifBarkod !== detayData.kargo_takip_no}
                                                                                title="Kargo Bilgilerini Güncelle ve Yeni Barkod Al (Sadece Ana Barkod)"
                                                                            >
                                                                                {islemIkonu(UndoIcon, '')}
                                                                                <span>Güncelle</span>
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                style={islemButonStili(isButtonDisabled())}
                                                                                title="Ek Barkod Oluştur (Kapıda Ödemesiz)"
                                                                                onClick={() => {
                                                                                    if (!isButtonDisabled()) {
                                                                                        handleEkBarkodOlustur();
                                                                                    }
                                                                                }}
                                                                                disabled={isButtonDisabled()}
                                                                            >
                                                                                {islemIkonu(EkEtiketIcon, '')}
                                                                                <span>Ek Etiket</span>
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    {/* Gönderi Hareketleri */}
                                                                    <div style={{marginTop: '15px'}}>
                                                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}}>
                                                                            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                                                                <h4 style={{...detailStyles.title, justifyContent: 'flex-start', border: 'none', padding: 0, margin: 0}}>Gönderi Hareketleri</h4>
                                                                                {renderEskiEtiketButonu()}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{fontSize: '12px', color: '#333', maxHeight: '150px', overflowY: 'auto'}}>
                                                                            {kargoHareketleri.length > 0 ? (
                                                                                kargoHareketleri.map((hareket, index) => (
                                                                                    <div key={index} style={{borderBottom: '1px solid #eee', padding: '8px 0'}}>
                                                                                        <p style={{margin: 0}}><strong>{hareket.durum}</strong></p>
                                                                                        <p style={{margin: '4px 0 0 0', color: '#666'}}>{hareket.yer} - {hareket.tarih} {hareket.saat}</p>
                                                                                    </div>
                                                                                ))
                                                                            ) : (
                                                                                <p style={{color: '#888'}}>{kargoSorguLoading ? 'Hareketler sorgulanıyor...' : 'Hareket bulunamadı.'}</p>
                                                                            )}
                                                                        </div>

                                                                    {/* Etiket Önizleme ve Butonlar */}
                                                                        <div style={{borderTop: '1px solid #eee', paddingTop: '10px', marginTop: '15px'}}>
                                                                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px'}}>
                                                                                <h4 style={{...detailStyles.title, justifyContent: 'flex-start', border: 'none', padding: 0, margin: 0}}>Etiket Önizleme</h4>
                                                                                <div style={{display: 'flex', gap: '8px'}} onClick={(e) => e.stopPropagation()}>
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={handleSendKargoWhatsapp}
                                                                                        disabled={isButtonDisabled() || !aktifBarkod}
                                                                                        style={islemButonStili(isButtonDisabled() || !aktifBarkod)}
                                                                                    >
                                                                                        {islemIkonu(WhatsappIcon, 'Gönder')}
                                                                                        <span>Gönder</span>
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        style={islemButonStili(isButtonDisabled() || !aktifBarkod)}
                                                                                        title="Etiketi PNG olarak indir"
                                                                                        onClick={() => {
                                                                                            if (!isButtonDisabled() && aktifBarkod) {
                                                                                                // Ek paket mi ana barkod mu kontrol et
                                                                                                const isEkPaket = detayData.paketler && detayData.paketler.some(p => p.kargo_takip_no === aktifBarkod);
                                                                                                handleDownloadLabel(detayData, aktifBarkod, isEkPaket);
                                                                                            }
                                                                                        }}
                                                                                        disabled={isButtonDisabled() || !aktifBarkod}
                                                                                    >
                                                                                        {islemIkonu(DownloadIcon, 'İndir')}
                                                                                        <span>İndir</span>
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        style={islemButonStili(!aktifBarkod || etiketYazdiriliyor, etiketYazdiriliyor)}
                                                                                        title="Etiketi A5 dikey, tek yönlü yazdır"
                                                                                        onClick={() => handleEtiketYazdir(detayData.id)}
                                                                                        disabled={!aktifBarkod || etiketYazdiriliyor}
                                                                                    >
                                                                                        {islemIkonu(PrintIcon, 'Yazdır')}
                                                                                        <span>{etiketYazdiriliyor ? 'Hazırlanıyor...' : 'Yazdır'}</span>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div id={`etiket-wrapper-${detayData.id}`} style={{ padding: '0', display: 'inline-block', backgroundColor: 'white', maxWidth: '100%', marginTop: '5px' }}>
                                                                        {(() => {
                                                                            // Tekrar gönderim barkodu seçiliyse etiket o gönderimin alıcı/ödeme/tutar bilgileriyle çizilir
                                                                            const tekrar = (detayData.tekrar_gonderimler || []).find(t => t.kargo_takip_no && t.kargo_takip_no === aktifBarkod);
                                                                            const etiketSiparis = tekrar
                                                                                ? { ...detayData, musteri: tekrar.musteri, odeme_yontemi: tekrar.odeme_yontemi, toplam_bedel: tekrar.toplam_bedel, sepet: tekrar.sepet }
                                                                                : detayData;
                                                                            return (
                                                                        <EtiketSablonu
                                                                            siparis={etiketSiparis}
                                                                            ozelBarkod={aktifBarkod}
                                                                            isEkPaket={!tekrar && detayData.paketler && detayData.paketler.some(p => p.kargo_takip_no === aktifBarkod)}
                                                                            paketSiraNo={(() => {
                                                                                const index = detayData.paketler?.findIndex(p => p.kargo_takip_no === aktifBarkod);
                                                                                return index >= 0 ? index + 2 : null;
                                                                            })()}
                                                                        />
                                                                            );
                                                                        })()}
                                                                    </div>
                                                                    {/* Barkod yenilendi, ana etiket henüz indirilmedi (wrapper dışında: indirilen görsele girmez) */}
                                                                    {(() => { try { return localStorage.getItem(`etiket_guncellendi_${detayData.id}`) === 'true'; } catch (e) { return false; } })() && (
                                                                        <div style={{
                                                                            marginTop: '8px',
                                                                            padding: '8px 10px',
                                                                            background: '#f8d7da',
                                                                            border: '1px solid #dc3545',
                                                                            borderRadius: '4px',
                                                                            color: '#842029',
                                                                            fontWeight: 'bold',
                                                                            fontFamily: 'Poppins',
                                                                            fontSize: '13px',
                                                                            textAlign: 'center'
                                                                        }}>
                                                                            Barkod Güncellendi, Çıktı Almayı Unutmayın !!
                                                                        </div>
                                                                    )}

                                                                    {/* Teslimat: Talimat Oluştur / İşyerinden Teslim (etiketin altında) */}
                                                                    <div style={{ marginTop: '12px', borderTop: '1px solid #eee', paddingTop: '12px' }}>{renderTeslimatButonlari()}</div>

                                                                    {/* Mevcut DT kaydı (eski talep kaydı) gösterimi */}
                                                                    {detayData.dt_kayit && (() => {
                                                                        const dt = detayData.dt_kayit;
                                                                        return (
                                                                            <div style={{marginTop: '10px', border: '1px solid #b3d4f5', borderRadius: '6px', overflow: 'hidden', fontSize: '13px', overflowWrap: 'anywhere'}} onClick={(e) => e.stopPropagation()}>
                                                                                <div style={{background: '#e3f0fd', padding: '8px 12px', borderBottom: '1px solid #b3d4f5', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                                                                    <strong style={{color: '#1a6cb0', fontSize: '12px'}}>
                                                                                        {dt.talep_turu === 'teslimat' ? 'Adres Değişiklik Talebi' : dt.talep_turu === 'iade' ? 'İade Talebi' : 'Ödeme Şartı Değişiklik Talebi'}
                                                                                    </strong>
                                                                                    <span style={{fontSize: '11px', color: '#666'}}>
                                                                                        {new Date(dt.tarih).toLocaleDateString('tr-TR')}
                                                                                    </span>
                                                                                </div>
                                                                                <div style={{padding: '10px 12px', background: 'white'}}>
                                                                                    {dt.govde && (
                                                                                        <pre style={{margin: 0, fontSize: '11px', color: '#444', background: '#f8f8f8', border: '1px solid #e8e8e8', borderRadius: '3px', padding: '7px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'poppins, sans-serif'}}>{dt.govde}</pre>
                                                                                    )}
                                                                                    <div style={{display: 'flex', justifyContent: 'flex-end', gap: '6px', marginTop: '6px'}}>
                                                                                        {dt.govde && (
                                                                                            <button
                                                                                                onClick={() => navigator.clipboard.writeText(dt.govde).then(() => alert('Metin kopyalandı.')).catch(() => alert('Kopyalama başarısız.'))}
                                                                                                style={{fontSize: '11px', padding: '2px 10px', border: '1px solid #b3d4f5', borderRadius: '3px', background: '#f0f7ff', cursor: 'pointer', color: '#1a6cb0', fontFamily: 'poppins'}}
                                                                                            >
                                                                                                Kopyala
                                                                                            </button>
                                                                                        )}
                                                                                        <button
                                                                                            onClick={async () => {
                                                                                                if (window.confirm('Bu gönderiye ait DT kaydı silinecek. Emin misiniz?')) {
                                                                                                    try {
                                                                                                        const token = localStorage.getItem('token');
                                                                                                        if (token) {
                                                                                                            const res = await fetch(`/api/siparisler/${detayData.id}/durum-guncelle`, {
                                                                                                                method: 'PUT',
                                                                                                                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                                                                                                                body: JSON.stringify({ dt_kayit: null })
                                                                                                            });
                                                                                                            if (res.ok) setDetayData(prev => prev ? { ...prev, dt_kayit: null } : prev);
                                                                                                        }
                                                                                                    } catch (err) { console.warn('DT kaydı silme hatası:', err); }
                                                                                                    fetchSiparisler();
                                                                                                }
                                                                                            }}
                                                                                            style={{fontSize: '11px', padding: '2px 10px', border: '1px solid #ccc', borderRadius: '3px', background: '#f8f8f8', cursor: 'pointer', color: '#555', fontFamily: 'poppins'}}
                                                                                        >
                                                                                            Eski Talep Kaydını Kaldır
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })()}

                                                                    {/* PTT'ye iletilen teslimat talepleri (en yeni üstte) */}
                                                                    {(detayData.teslimat_talepleri || []).length > 0 && (
                                                                        <div style={{ marginTop: '10px', overflowWrap: 'anywhere' }}>
                                                                            {detayData.teslimat_talepleri.map(renderTalepKarti)}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="10" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>Gösterilecek sipariş bulunamadı.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            </div>
            <Modal isOpen={isModalOpen} onClose={() => handleModalClose(false)}>
                <SiparisGirisFormu 
                    siparisId={editingSiparisId}
                    onClose={handleModalClose}
                />
            </Modal>

            {/* Ek Sipariş Modalı */}
            <Modal isOpen={ekSiparisModalAcik} onClose={() => (ekSiparisEditId ? handleEkSiparisModalKapatEdit(false) : handleEkSiparisModalKapat(false))}>
                <SiparisGirisFormu
                    ekSiparisMode={true}
                    siparisId={null}
                    anaSiparisId={ekSiparisAnaSiparisId}
                    ekSiparisEditId={ekSiparisEditId}
                    initialData={ekSiparisInitialData}
                    onClose={ekSiparisEditId ? handleEkSiparisModalKapatEdit : handleEkSiparisModalKapat}
                />
            </Modal>

            {/* Tekrar Gönderim Modalı */}
            <Modal isOpen={!!tekrarModalSiparisId} onClose={() => handleTekrarModalKapat(false)}>
                {tekrarModalSiparisId && (
                    <SiparisGirisFormu
                        tekrarGonderimMode={true}
                        siparisId={tekrarModalSiparisId}
                        onClose={handleTekrarModalKapat}
                    />
                )}
            </Modal>

            {/* Sipariş Notu Modalı (N butonu) */}
            {notModalAcik && detayData && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    zIndex: 1100
                }} onClick={() => setNotModalAcik(false)}>
                    <div style={{
                        backgroundColor: '#F8F8F8', borderRadius: '8px', padding: '25px',
                        maxWidth: '480px', width: '90%',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                        fontFamily: 'Poppins, sans-serif', border: '1px solid #E0E0E0'
                    }} onClick={(e) => e.stopPropagation()}>
                        <h2 style={{
                            margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600',
                            color: '#333', borderBottom: '2px solid #E0E0E0', paddingBottom: '12px'
                        }}>
                            {(detayData.siparis_notu || '').trim() ? 'Notu Düzenle' : 'Not Ekle'}
                        </h2>
                        <textarea
                            autoFocus
                            style={{ ...detailStyles.noteArea, minHeight: '110px', background: 'white' }}
                            placeholder="Bu siparişe özel notlar..."
                            value={musteriNotu}
                            onChange={(e) => setMusteriNotu(e.target.value)}
                        />
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                            <button
                                onClick={() => setNotModalAcik(false)}
                                style={{ padding: '6px 18px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#F7F7F7', cursor: 'pointer', fontFamily: 'Poppins, sans-serif' }}
                            >
                                İptal
                            </button>
                            <button
                                onClick={handleNotModalKaydet}
                                style={{ padding: '6px 18px', fontSize: '13px', border: 'none', borderRadius: '4px', backgroundColor: '#28a745', color: 'white', cursor: 'pointer', fontFamily: 'Poppins, sans-serif', fontWeight: '500' }}
                            >
                                Kaydet
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Yeni Teslimat Talebi Modalı */}
            {talepForm && detayData && (() => {
                const { turler, detay } = talepForm;
                const setDetay = (alan, deger) => setTalepForm(f => ({ ...f, detay: { ...f.detay, [alan]: deger } }));
                const eksik = turler.length === 0
                    || (turler.includes('isim_adres') && !Object.values(isimAdresDegisenleri(detay)).some(Boolean))
                    || (turler.includes('odeme') && detay.islem !== 'kaldir' && !detay.tutar);
                const girdiStili = { width: '100%', padding: '7px 8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif', fontSize: '13px' };
                const etiketStili = { display: 'block', fontSize: '12px', fontWeight: '500', margin: '10px 0 4px', color: '#444' };
                const butonStili = { padding: '6px 18px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#F7F7F7', cursor: 'pointer', fontFamily: 'Poppins, sans-serif' };
                const barkodlar = [...new Set([detayData.eski_etiket, detayData.kargo_takip_no, ...(detayData.paketler || []).map(p => p.kargo_takip_no)].filter(Boolean))];
                return (
                    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
                        <div style={{ backgroundColor: '#F8F8F8', borderRadius: '8px', padding: '22px 25px', width: '90%', maxWidth: '560px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 4px 20px rgba(0,0,0,0.2)', fontFamily: 'Poppins, sans-serif', border: '1px solid #E0E0E0', boxSizing: 'border-box' }}>
                            <h2 style={{ margin: '0 0 6px 0', fontSize: '16px', fontWeight: '600', color: '#333' }}>Yeni Talimat Talebi</h2>
                            <div style={{ fontSize: '12px', color: '#666', borderBottom: '2px solid #E0E0E0', paddingBottom: '10px', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                <span>Gönderi:</span>
                                {barkodlar.length > 1 ? (
                                    <select value={talepForm.barkod} onChange={(e) => setTalepForm(f => ({ ...f, barkod: e.target.value }))} style={{ fontFamily: 'Poppins, sans-serif', fontSize: '12px', padding: '2px 4px' }}>
                                        {barkodlar.map(b => <option key={b} value={b}>{b}</option>)}
                                    </select>
                                ) : <strong>{talepForm.barkod}</strong>}
                                <span>· Alıcı: ank-paket@ptt.gov.tr</span>
                            </div>

                            {/* Talep türleri: birden fazla seçilebilir, İade tek başına */}
                            <div style={{ fontSize: '11px', color: '#888', marginBottom: '6px' }}>Birden fazla seçebilirsiniz; İade Talebi tek başına seçilir.</div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px' }}>
                                {TALEP_TURLERI.map(s => {
                                    const secili = turler.includes(s.tur);
                                    return (
                                        <button key={s.tur} type="button" onClick={() => talepTuruSec(s.tur)}
                                            style={{ padding: '8px 10px', border: `1px solid ${secili ? '#1565C0' : '#ccc'}`, borderRadius: '6px', background: secili ? '#e8f0fe' : '#fff', cursor: 'pointer', textAlign: 'left', fontFamily: 'Poppins, sans-serif', display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                                            <input type="checkbox" readOnly checked={secili} style={{ marginTop: '3px', pointerEvents: 'none' }} />
                                            <span>
                                                <div style={{ fontSize: '13px', fontWeight: '600', color: secili ? '#1565C0' : '#333' }}>{s.ad}</div>
                                                <div style={{ fontSize: '11px', color: '#888' }}>{s.aciklama}</div>
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>

                            {/* Türe özel alanlar */}
                            {turler.includes('isim_adres') && (
                                <>
                                    <label style={etiketStili}>Alıcı Adı Soyadı</label>
                                    <input value={detay.yeni_ad_soyad} onChange={(e) => setDetay('yeni_ad_soyad', e.target.value)} style={girdiStili} />
                                    <label style={etiketStili}>Alıcı Telefonu</label>
                                    <input value={detay.yeni_telefon} onChange={(e) => setDetay('yeni_telefon', e.target.value)} style={girdiStili} />
                                    <label style={etiketStili}>Adres</label>
                                    <textarea rows={3} value={detay.yeni_adres} onChange={(e) => setDetay('yeni_adres', e.target.value)} style={{ ...girdiStili, resize: 'vertical' }} />
                                    <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>Mevcut bilgiler dolu gelir; sadece değiştirdiğiniz alanlar maile yazılır.</div>
                                </>
                            )}
                            {turler.includes('odeme') && (
                                <>
                                    <label style={etiketStili}>İşlem</label>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        {(detayData.odeme_yontemi === 'K' ? [['kaldir', 'Kaldır'], ['degistir', 'Tutarı Değiştir']] : [['ekle', 'Ödeme Şartı Ekle']]).map(([k, ad]) => (
                                            <button key={k} type="button" onClick={() => setDetay('islem', k)}
                                                style={{ ...butonStili, padding: '5px 12px', borderColor: detay.islem === k ? '#1565C0' : '#ccc', background: detay.islem === k ? '#e8f0fe' : '#fff', color: detay.islem === k ? '#1565C0' : '#333' }}>
                                                {ad}
                                            </button>
                                        ))}
                                    </div>
                                    {detay.islem !== 'kaldir' && (
                                        <>
                                            <label style={etiketStili}>{detay.islem === 'degistir' ? 'Yeni Tutar (TL)' : 'Eklenecek Tutar (TL)'}</label>
                                            <input type="number" min="0" value={detay.tutar} onChange={(e) => setDetay('tutar', e.target.value)} placeholder="0.00" style={girdiStili} />
                                        </>
                                    )}
                                </>
                            )}

                            {turler.length > 0 && (
                                <>
                                    <label style={etiketStili}>PTT Ek Açıklama</label>
                                    <input value={detay.ptt_notu} onChange={(e) => setDetay('ptt_notu', e.target.value)} placeholder="İsteğe bağlı, maile eklenir" style={girdiStili} />
                                    <label style={etiketStili}>Talep Nedeni</label>
                                    <div style={{ display: 'flex', gap: '14px', fontSize: '13px' }}>
                                        {[['musteri', 'Müşteri Talebi'], ['hata', 'Gönderim Hatası']].map(([k, ad]) => (
                                            <label key={k} style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
                                                <input type="radio" checked={talepForm.kaynak === k} onChange={() => setTalepForm(f => ({ ...f, kaynak: k }))} /> {ad}
                                            </label>
                                        ))}
                                    </div>
                                    <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>Talep nedeni maile eklenmez.</div>
                                    <label style={etiketStili}>Özel Not</label>
                                    <input value={talepForm.notlar} onChange={(e) => setTalepForm(f => ({ ...f, notlar: e.target.value }))} style={girdiStili} />
                                </>
                            )}

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '18px' }}>
                                <button type="button" onClick={() => setTalepForm(null)} disabled={talepKaydediliyor} style={butonStili}>İptal</button>
                                <button type="button" onClick={handleTalepKaydet} disabled={eksik || talepKaydediliyor}
                                    style={{ ...butonStili, border: 'none', backgroundColor: eksik ? '#ccc' : '#2962FF', color: 'white', fontWeight: '500', cursor: eksik || talepKaydediliyor ? 'not-allowed' : 'pointer' }}>
                                    {talepKaydediliyor ? 'Gönderiliyor...' : "Kaydet ve PTT'ye Gönder"}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Eski Etiket Seçim Modalı (admin) */}
            {eskiEtiketForm && detayData && (() => {
                const eskiler = [...(detayData.eski_barkodlar || [])].reverse(); // en yeni üstte
                const secim = eskiEtiketForm.elle.trim() || eskiEtiketForm.secili;
                const kaydedilemez = !secim || secim === detayData.eski_etiket || eskiEtiketKaydediliyor;
                const butonStili = { padding: '6px 18px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#F7F7F7', cursor: 'pointer', fontFamily: 'Poppins, sans-serif' };
                return (
                    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
                        <form onSubmit={(e) => { e.preventDefault(); if (!kaydedilemez) eskiEtiketKaydet(secim); }}
                            style={{ backgroundColor: '#F8F8F8', borderRadius: '8px', padding: '22px 25px', width: '90%', maxWidth: '440px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 4px 20px rgba(0,0,0,0.2)', fontFamily: 'Poppins, sans-serif', border: '1px solid #E0E0E0', boxSizing: 'border-box' }}>
                            <h2 style={{ margin: '0 0 6px 0', fontSize: '16px', fontWeight: '600', color: '#333' }}>Eski Etiket</h2>
                            <div style={{ fontSize: '12px', color: '#666', borderBottom: '2px solid #E0E0E0', paddingBottom: '10px', marginBottom: '12px' }}>
                                Sipariş #{detayData.siparis_no} için önceden alınmış etiketler. Seçilen etiketin hareketleri, kaldırılana kadar Gönderi Hareketleri'nde gösterilir.
                            </div>
                            {eskiler.length > 0 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    {eskiler.map(e => (
                                        <label key={e.barkod} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 10px', border: `1px solid ${e.barkod === detayData.eski_etiket ? '#28a745' : '#ddd'}`, borderRadius: '4px', background: e.barkod === detayData.eski_etiket ? '#d4edda' : 'white', cursor: 'pointer', fontSize: '13px' }}>
                                            <input type="radio" name="eski-etiket" checked={!eskiEtiketForm.elle.trim() && eskiEtiketForm.secili === e.barkod}
                                                onChange={() => setEskiEtiketForm({ secili: e.barkod, elle: '' })} />
                                            <strong>{e.barkod}</strong>
                                            <span style={{ marginLeft: 'auto', fontSize: '11px', color: '#666' }}>
                                                {e.barkod === detayData.eski_etiket ? 'Aktif' : (e.tarih ? `${new Date(e.tarih).toLocaleDateString('tr-TR')} tarihinde değişti` : '')}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ fontSize: '12px', color: '#888' }}>Bu sipariş için kayıtlı eski etiket yok.</div>
                            )}
                            <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', margin: '14px 0 4px', color: '#444' }}>Listede yoksa barkodu yazın</label>
                            <input value={eskiEtiketForm.elle} onChange={(e) => setEskiEtiketForm(f => ({ ...f, elle: e.target.value.replace(/\s/g, '') }))}
                                placeholder="Örn. KP01234567890" maxLength={50}
                                style={{ width: '100%', padding: '7px 8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif', fontSize: '13px' }} />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '18px' }}>
                                {detayData.eski_etiket && (
                                    <button type="button" onClick={() => eskiEtiketKaydet(null)} disabled={eskiEtiketKaydediliyor}
                                        style={{ ...butonStili, color: '#dc3545', borderColor: '#dc3545' }}>Eski Etiketi Kaldır</button>
                                )}
                                <span style={{ flex: 1 }} />
                                <button type="button" onClick={() => setEskiEtiketForm(null)} disabled={eskiEtiketKaydediliyor} style={butonStili}>İptal</button>
                                <button type="submit" disabled={kaydedilemez}
                                    style={{ ...butonStili, border: 'none', backgroundColor: kaydedilemez ? '#ccc' : '#2962FF', color: 'white', fontWeight: '500', cursor: kaydedilemez ? 'not-allowed' : 'pointer' }}>
                                    {eskiEtiketKaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
                                </button>
                            </div>
                        </form>
                    </div>
                );
            })()}

            {/* İşyerinden Elden Teslim Modalı */}
            {eldenTeslimForm && detayData && (() => {
                const eksik = !eldenTeslimForm.tarih || !eldenTeslimForm.teslim_alan.trim();
                const girdiStili = { width: '100%', padding: '7px 8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif', fontSize: '13px' };
                const etiketStili = { display: 'block', fontSize: '12px', fontWeight: '500', margin: '10px 0 4px', color: '#444' };
                const butonStili = { padding: '6px 18px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#F7F7F7', cursor: 'pointer', fontFamily: 'Poppins, sans-serif' };
                return (
                    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
                        <form onSubmit={(e) => { e.preventDefault(); if (!eksik) handleEldenTeslimKaydet(); }}
                            style={{ backgroundColor: '#F8F8F8', borderRadius: '8px', padding: '22px 25px', width: '90%', maxWidth: '420px', boxShadow: '0 4px 20px rgba(0,0,0,0.2)', fontFamily: 'Poppins, sans-serif', border: '1px solid #E0E0E0', boxSizing: 'border-box' }}>
                            <h2 style={{ margin: '0 0 6px 0', fontSize: '16px', fontWeight: '600', color: '#333' }}>İşyerinden Teslim</h2>
                            <div style={{ fontSize: '12px', color: '#666', borderBottom: '2px solid #E0E0E0', paddingBottom: '10px', marginBottom: '4px' }}>
                                Sipariş #{detayData.siparis_no} kargo ile gönderilmeyecek, müşteriye elden teslim edildi olarak kaydedilecek.
                                {detayData.kargo_takip_no && ' Etiket ve gönderi işlemleri artık gösterilmeyecek.'}
                            </div>
                            <label style={etiketStili}>Teslim Tarihi</label>
                            <input type="date" value={eldenTeslimForm.tarih} onChange={(e) => setEldenTeslimForm(f => ({ ...f, tarih: e.target.value }))} style={girdiStili} />
                            <label style={etiketStili}>Teslim Alan Kişi</label>
                            <input value={eldenTeslimForm.teslim_alan} onChange={(e) => setEldenTeslimForm(f => ({ ...f, teslim_alan: e.target.value }))} style={girdiStili} autoFocus />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '18px' }}>
                                <button type="button" onClick={() => setEldenTeslimForm(null)} disabled={eldenTeslimKaydediliyor} style={butonStili}>İptal</button>
                                <button type="submit" disabled={eksik || eldenTeslimKaydediliyor}
                                    style={{ ...butonStili, border: 'none', backgroundColor: eksik ? '#ccc' : '#2962FF', color: 'white', fontWeight: '500', cursor: eksik || eldenTeslimKaydediliyor ? 'not-allowed' : 'pointer' }}>
                                    {eldenTeslimKaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
                                </button>
                            </div>
                        </form>
                    </div>
                );
            })()}

            {/* Tarih Değiştirme Modal'ı */}
            {/* Alıcı ödemeli takip numarası için parola sorulur */}
            {aliciOdemeliParola !== null && detayData && (() => {
                const kapat = () => setAliciOdemeliParola(null);
                const onayla = (e) => {
                    e.preventDefault();
                    if (aliciOdemeliParola !== ALICI_ODEMELI_PAROLA) { alert('Parola hatalı.'); return; }
                    kapat();
                    handleCreatePttShipment(detayData.id, 'A', true);
                };
                const butonStili = { padding: '6px 18px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', background: '#f8f8f8', fontFamily: 'Poppins, sans-serif', cursor: 'pointer' };
                return (
                    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
                        onClick={kapat}>
                        <form onSubmit={onayla} onClick={(e) => e.stopPropagation()}
                            style={{ backgroundColor: '#F8F8F8', borderRadius: '8px', padding: '25px', minWidth: '320px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', fontFamily: 'Poppins, sans-serif', border: '1px solid #E0E0E0' }}>
                            <h2 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600', color: '#333', borderBottom: '2px solid #E0E0E0', paddingBottom: '12px' }}>
                                Alıcı Ödemeli Takip Numarası
                            </h2>
                            <label style={{ fontSize: '13px', display: 'block', marginBottom: '6px' }}>Parola</label>
                            <input type="password" autoFocus value={aliciOdemeliParola} onChange={(e) => setAliciOdemeliParola(e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Escape') kapat(); }}
                                style={{ width: '100%', padding: '6px 8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }} />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                                <button type="button" onClick={kapat} style={butonStili}>İptal</button>
                                <button type="submit" style={butonStili}>Oluştur</button>
                            </div>
                        </form>
                    </div>
                );
            })()}

            {/* Toplu etiket iptali için parola sorulur */}
            {etiketIptalParola !== null && (() => {
                const kapat = () => setEtiketIptalParola(null);
                const onayla = (e) => {
                    e.preventDefault();
                    if (etiketIptalParola !== ETIKET_IPTAL_PAROLA) { alert('Parola hatalı.'); return; }
                    kapat();
                    handleTopluBarkodIptal();
                };
                const butonStili = { padding: '6px 18px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px', background: '#f8f8f8', fontFamily: 'Poppins, sans-serif', cursor: 'pointer' };
                return (
                    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
                        onClick={kapat}>
                        <form onSubmit={onayla} onClick={(e) => e.stopPropagation()}
                            style={{ backgroundColor: '#F8F8F8', borderRadius: '8px', padding: '25px', minWidth: '320px', maxWidth: '380px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', fontFamily: 'Poppins, sans-serif', border: '1px solid #E0E0E0' }}>
                            <h2 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600', color: '#333', borderBottom: '2px solid #E0E0E0', paddingBottom: '12px' }}>
                                Etiket İptal
                            </h2>
                            <p style={{ fontSize: '12px', color: '#555', margin: '0 0 12px 0' }}>
                                Seçili {seciliSiparisler.length} siparişin etiketi sistemden silinip sipariş yeniden etiketsiz hale getirilecek. Eski etiket artık geçersiz olacak.
                            </p>
                            <label style={{ fontSize: '13px', display: 'block', marginBottom: '6px' }}>Parola</label>
                            <input type="password" autoFocus value={etiketIptalParola} onChange={(e) => setEtiketIptalParola(e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Escape') kapat(); }}
                                style={{ width: '100%', padding: '6px 8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }} />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                                <button type="button" onClick={kapat} style={butonStili}>Vazgeç</button>
                                <button type="submit" style={butonStili}>İptal Et</button>
                            </div>
                        </form>
                    </div>
                );
            })()}

            {tarihModalAcik && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#F8F8F8',
                        borderRadius: '8px',
                        padding: '25px',
                        minWidth: '400px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        fontFamily: 'Poppins, sans-serif',
                        border: '1px solid #E0E0E0'
                    }}>
                        <h2 style={{
                            margin: '0 0 20px 0',
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#333',
                            textAlign: 'left',
                            borderBottom: '2px solid #E0E0E0',
                            paddingBottom: '12px'
                        }}>
                            📅 Sipariş Tarihi Değiştir
                        </h2>
                        
                        <div style={{
                            marginBottom: '20px'
                        }}>
                            <input
                                type="date"
                                value={secilenTarih}
                                max={new Date().toISOString().split('T')[0]}
                                onChange={(e) => setSecilenTarih(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '6px 12px',
                                    fontSize: '14px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    fontFamily: 'Poppins, sans-serif',
                                    cursor: 'pointer',
                                    boxSizing: 'border-box',
                                    backgroundColor: 'white'
                                }}
                            />
                        </div>
                        
                        <div style={{
                            display: 'flex',
                            gap: '10px',
                            justifyContent: 'flex-end'
                        }}>
                            <button
                                onClick={() => setTarihModalAcik(false)}
                                style={{
                                    padding: '6px 16px',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#F7F7F7',
                                    color: '#666',
                                    cursor: 'pointer',
                                    fontFamily: 'Poppins, sans-serif'
                                }}
                            >
                                İptal
                            </button>
                            <button
                                onClick={handleTarihOnayla}
                                style={{
                                    padding: '6px 16px',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#F7F7F7',
                                    color: '#666',
                                    cursor: 'pointer',
                                    fontFamily: 'Poppins, sans-serif'
                                }}
                            >
                                Onayla
                            </button>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Toplu Tarih Değiştirme Modalı */}
            {topluTarihModalAcik && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#F8F8F8',
                        borderRadius: '8px',
                        padding: '25px',
                        minWidth: '400px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        fontFamily: 'Poppins, sans-serif',
                        border: '1px solid #E0E0E0'
                    }}>
                        <h2 style={{
                            margin: '0 0 20px 0',
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#333',
                            textAlign: 'left',
                            borderBottom: '2px solid #E0E0E0',
                            paddingBottom: '12px'
                        }}>
                            📅 Toplu Sipariş Tarihi Değiştir
                        </h2>
                        
                        <p style={{
                            fontSize: '13px',
                            color: '#666',
                            marginBottom: '15px',
                            fontFamily: 'Poppins, sans-serif'
                        }}>
                            {seciliSiparisler.length} sipariş için yeni tarih seçiniz:
                        </p>
                        
                        <div style={{
                            marginBottom: '20px'
                        }}>
                            <input
                                type="date"
                                value={topluSecilenTarih}
                                max={new Date().toISOString().split('T')[0]}
                                onChange={(e) => setTopluSecilenTarih(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '6px 12px',
                                    fontSize: '14px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    fontFamily: 'Poppins, sans-serif',
                                    cursor: 'pointer',
                                    boxSizing: 'border-box',
                                    backgroundColor: 'white'
                                }}
                            />
                        </div>
                        
                        <div style={{
                            display: 'flex',
                            gap: '10px',
                            justifyContent: 'flex-end'
                        }}>
                            <button
                                onClick={() => setTopluTarihModalAcik(false)}
                                style={{
                                    padding: '6px 16px',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#F7F7F7',
                                    color: '#666',
                                    cursor: 'pointer',
                                    fontFamily: 'Poppins, sans-serif'
                                }}
                            >
                                İptal
                            </button>
                            <button
                                onClick={handleTopluTarihOnayla}
                                style={{
                                    padding: '6px 16px',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#F7F7F7',
                                    color: '#666',
                                    cursor: 'pointer',
                                    fontFamily: 'Poppins, sans-serif'
                                }}
                            >
                                Onayla
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Teslim Evrakı Modalı */}
            {teslimEvrakiModalAcik && (() => {
                const modalButonStili = {
                    padding: '6px 16px',
                    fontSize: '13px',
                    fontWeight: '500',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    backgroundColor: '#F7F7F7',
                    color: '#666',
                    cursor: 'pointer',
                    fontFamily: 'Poppins, sans-serif'
                };
                const girdiStili = {
                    padding: '6px 10px',
                    fontSize: '13px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    fontFamily: 'Poppins, sans-serif',
                    backgroundColor: 'white',
                    boxSizing: 'border-box'
                };
                const eklenenIdler = teslimEdilmeyenler.map(item => String(item.siparisId));
                // Açılır listede telefonun son 4 hanesine göre (0-9) sırala
                const secilebilirSiparisler = teslimSiparisleri
                    .filter(s => !eklenenIdler.includes(String(s.id)))
                    .sort((a, b) => telefonSon4Al(a.telefon_numarasi).localeCompare(telefonSon4Al(b.telefon_numarasi)));
                const ekleDisabled = !teslimSecilenSiparisId;

                // PDF şablonu stilleri
                const pdfHucre = { border: '1px solid #000', padding: '4px 8px', fontSize: '18px' };
                const pdfEtiketHucre = { ...pdfHucre, fontWeight: 'bold', textAlign: 'left', width: '70%' };
                const pdfDegerHucre = { ...pdfHucre, textAlign: 'center' };

                return (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}>
                        <div style={{
                            backgroundColor: '#F8F8F8',
                            borderRadius: '8px',
                            padding: '25px',
                            width: '560px',
                            maxHeight: '85vh',
                            overflowY: 'auto',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                            fontFamily: 'Poppins, sans-serif',
                            border: '1px solid #E0E0E0'
                        }}>
                            <h2 style={{
                                margin: '0 0 15px 0',
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#333',
                                textAlign: 'left',
                                borderBottom: '2px solid #E0E0E0',
                                paddingBottom: '12px'
                            }}>
                                Teslim Evrakı - {teslimTarihMetni}
                            </h2>

                            <div style={{ display: 'flex', gap: '20px', fontSize: '13px', color: '#555', marginBottom: '15px' }}>
                                <span>Teslim Edilen: <b>{teslimEdilen}</b></span>
                                <span>Teslim Edilmeyen: <b>{teslimBekleyen}</b></span>
                                <span>Toplam Sipariş: <b>{teslimToplam}</b></span>
                            </div>

                            <p style={{ fontSize: '13px', color: '#666', margin: '0 0 8px 0' }}>
                                Teslim edilmeyen siparişi ve gerekçesini seçiniz:
                            </p>
                            <div style={{ display: 'flex', gap: '8px', marginBottom: teslimGerekce === 'Diğer' ? '8px' : '15px' }}>
                                <select
                                    value={teslimSecilenSiparisId}
                                    onChange={(e) => setTeslimSecilenSiparisId(e.target.value)}
                                    style={{ ...girdiStili, flex: 1, cursor: 'pointer' }}
                                >
                                    <option value="">Sipariş seçiniz...</option>
                                    {secilebilirSiparisler.map(s => (
                                        <option key={s.id} value={s.id}>
                                            {telefonSon4Al(s.telefon_numarasi)} - {s.ad_soyad}
                                        </option>
                                    ))}
                                </select>
                                <select
                                    value={teslimGerekce}
                                    onChange={(e) => setTeslimGerekce(e.target.value)}
                                    style={{ ...girdiStili, width: '150px', cursor: 'pointer' }}
                                >
                                    <option value="Beklemede">Beklemede</option>
                                    <option value="Önceden Teslim Edildi">Önceden Teslim Edildi</option>
                                    <option value="Diğer">Diğer</option>
                                </select>
                                <button
                                    onClick={handleTeslimEdilmeyenEkle}
                                    disabled={ekleDisabled}
                                    style={{
                                        ...modalButonStili,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        opacity: ekleDisabled ? 0.5 : 1,
                                        cursor: ekleDisabled ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    <img src={PlusIcon} alt="Ekle" style={{ height: '12px' }} />
                                    Ekle
                                </button>
                            </div>
                            {teslimGerekce === 'Diğer' && (
                                <input
                                    type="text"
                                    value={teslimDigerAciklama}
                                    onChange={(e) => setTeslimDigerAciklama(e.target.value)}
                                    placeholder="Açıklama (opsiyonel)"
                                    style={{ ...girdiStili, width: '100%', marginBottom: '15px' }}
                                />
                            )}

                            <div style={{
                                border: '1px solid #E0E0E0',
                                borderRadius: '4px',
                                backgroundColor: 'white',
                                marginBottom: '20px',
                                minHeight: '60px'
                            }}>
                                {teslimEdilmeyenler.length === 0 ? (
                                    <p style={{ fontSize: '13px', color: '#999', textAlign: 'center', margin: '20px 0' }}>
                                        Teslim edilmeyen sipariş eklenmedi.
                                    </p>
                                ) : teslimEdilmeyenler.map(item => (
                                    <div key={item.siparisId} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        padding: '6px 10px',
                                        borderBottom: '1px solid #f0f0f0',
                                        fontSize: '13px'
                                    }}>
                                        <b style={{ width: '45px' }}>{item.son4}</b>
                                        <span style={{ flex: 1, color: '#555' }}>{item.adSoyad}</span>
                                        <span style={{ color: '#333' }}>{item.gerekce}</span>
                                        <button
                                            onClick={() => handleTeslimEdilmeyenSil(item.siparisId)}
                                            title="Listeden sil"
                                            style={{
                                                ...modalButonStili,
                                                padding: '3px 10px',
                                                fontSize: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px'
                                            }}
                                        >
                                            <img src={DeleteIcon} alt="Sil" style={{ height: '12px' }} />
                                            Sil
                                        </button>
                                    </div>
                                ))}
                            </div>

                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <button onClick={() => setTeslimEvrakiModalAcik(false)} style={modalButonStili}>
                                    İptal
                                </button>
                                <button
                                    onClick={handleTeslimEvrakiOlustur}
                                    disabled={teslimPdfLoading}
                                    style={{ ...modalButonStili, opacity: teslimPdfLoading ? 0.5 : 1, cursor: teslimPdfLoading ? 'wait' : 'pointer' }}
                                >
                                    {teslimPdfLoading ? 'Oluşturuluyor...' : 'Tamam'}
                                </button>
                            </div>
                        </div>

                        {/* PDF'e dönüştürülecek şablon (ekran dışında) */}
                        <div style={{ position: 'fixed', left: '-10000px', top: 0 }}>
                            <div ref={teslimEvrakiRef} style={{
                                width: '794px',
                                padding: '20px',
                                backgroundColor: '#ffffff',
                                color: '#000',
                                fontFamily: 'Arial, Helvetica, sans-serif',
                                boxSizing: 'border-box'
                            }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <tbody>
                                        <tr>
                                            <td colSpan={2} style={{
                                                border: '1px solid #000',
                                                textAlign: 'center',
                                                fontSize: '110px',
                                                fontWeight: 'bold',
                                                lineHeight: 1.1,
                                                padding: '10px 0'
                                            }}>
                                                {teslimTarihMetni}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={pdfEtiketHucre}>TESLİM EDİLEN</td>
                                            <td style={pdfDegerHucre}>{teslimEdilen}</td>
                                        </tr>
                                        <tr>
                                            <td style={pdfEtiketHucre}>TESLİM EDİLMEYEN</td>
                                            <td style={pdfDegerHucre}>{teslimBekleyen}</td>
                                        </tr>
                                        <tr>
                                            <td style={pdfEtiketHucre}>TOPLAM SİPARİŞ</td>
                                            <td style={pdfDegerHucre}>{teslimToplam}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                {teslimEdilmeyenler.length > 0 && (
                                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '30px' }}>
                                        <tbody>
                                            <tr>
                                                <td colSpan={2} style={{ ...pdfHucre, textAlign: 'center', fontWeight: 'bold' }}>
                                                    TESLİM EDİLMEYEN LİSTESİ
                                                </td>
                                            </tr>
                                            {teslimEdilmeyenler.map(item => (
                                                <tr key={item.siparisId}>
                                                    <td style={{ ...pdfHucre, textAlign: 'center', width: '38%' }}>{item.son4}</td>
                                                    <td style={{ ...pdfHucre, textAlign: 'center' }}>
                                                        {item.gerekce.toLocaleUpperCase('tr-TR')}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Fatura Kontrolü Modalı (proforma - Paraşüt fatura denkliği) */}
            {faturaKontrolModalAcik && faturaKontrol && (() => {
                const modalButonStili = {
                    padding: '6px 16px',
                    fontSize: '13px',
                    fontWeight: '500',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    backgroundColor: '#F7F7F7',
                    color: '#666',
                    cursor: 'pointer',
                    fontFamily: 'Poppins, sans-serif'
                };
                const tl = (deger) => `${Number(deger || 0).toFixed(2)} ₺`;
                const th = { textAlign: 'left', padding: '6px 8px', fontSize: '12px', fontWeight: '600', color: '#555', borderBottom: '1px solid #E0E0E0', backgroundColor: '#FAFAFA' };
                const td = { padding: '6px 8px', fontSize: '12px', color: '#333', borderBottom: '1px solid #f0f0f0', verticalAlign: 'top' };
                const yukleniyor = faturaKontrol.durum === 'yukleniyor';

                return (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}>
                        <div style={{
                            backgroundColor: '#F8F8F8',
                            borderRadius: '8px',
                            padding: '25px',
                            width: '860px',
                            maxWidth: '95vw',
                            maxHeight: '85vh',
                            overflowY: 'auto',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                            fontFamily: 'Poppins, sans-serif',
                            border: '1px solid #E0E0E0'
                        }}>
                            <h2 style={{
                                margin: '0 0 15px 0',
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#333',
                                textAlign: 'left',
                                borderBottom: '2px solid #E0E0E0',
                                paddingBottom: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <img src={ParasutLogo} alt="" style={{ height: '18px' }} />
                                Fatura Kontrolü - {teslimTarihMetni}
                            </h2>

                            <div style={{ display: 'flex', gap: '20px', fontSize: '13px', color: '#555', marginBottom: '15px' }}>
                                {yukleniyor ? (
                                    <span>Kontrol ediliyor... <b>{faturaKontrol.islenen} / {faturaKontrol.toplam}</b></span>
                                ) : (
                                    <span>Kontrol Edilen: <b>{faturaKontrol.kontrolEdilen}</b></span>
                                )}
                                <span>Uyumsuz: <b style={{ color: faturaKontrol.uyumsuzlar.length ? '#d9534f' : '#333' }}>{faturaKontrol.uyumsuzlar.length}</b></span>
                                {faturaKontrol.hatalar.length > 0 && (
                                    <span>Kontrol Edilemeyen: <b style={{ color: '#e67e22' }}>{faturaKontrol.hatalar.length}</b></span>
                                )}
                            </div>

                            <div style={{
                                border: '1px solid #E0E0E0',
                                borderRadius: '4px',
                                backgroundColor: 'white',
                                marginBottom: '20px',
                                minHeight: '60px'
                            }}>
                                {faturaKontrol.uyumsuzlar.length === 0 ? (
                                    <p style={{ fontSize: '13px', color: '#999', textAlign: 'center', margin: '20px 0' }}>
                                        {yukleniyor ? 'Şu ana kadar uyumsuz fatura bulunmadı.' : 'Tüm proformalar Paraşüt faturalarıyla uyumlu.'}
                                    </p>
                                ) : (
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <th style={th}>Sipariş</th>
                                                <th style={{ ...th, textAlign: 'right' }}>Proforma</th>
                                                <th style={{ ...th, textAlign: 'right' }}>Fatura</th>
                                                <th style={{ ...th, textAlign: 'right' }}>Fark</th>
                                                <th style={th}>Faturalar / Not</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {faturaKontrol.uyumsuzlar.map(u => (
                                                <tr key={u.siparis_id}>
                                                    <td style={td}>
                                                        <span
                                                            onClick={() => handleFaturaKontrolSiparisAc(u.siparis_id)}
                                                            title="Sipariş detayını aç"
                                                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                        >
                                                            <b>{telefonSon4Al(u.telefon_numarasi)}</b> - {u.ad_soyad}
                                                        </span>
                                                        <div style={{ color: '#999', fontSize: '11px' }}>#{u.siparis_no}</div>
                                                    </td>
                                                    <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap' }}>{tl(u.proforma_toplam)}</td>
                                                    <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap' }}>{u.faturalar.length ? tl(u.fatura_toplam) : '—'}</td>
                                                    <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap', fontWeight: '600', color: '#d9534f' }}>
                                                        {u.faturalar.length ? `${u.fark > 0 ? '+' : ''}${tl(u.fark)}` : '—'}
                                                    </td>
                                                    <td style={td}>
                                                        {u.faturalar.map(f => (
                                                            <div key={f.fatura_id}>
                                                                <a
                                                                    href={`https://uygulama.parasut.com/365186/satislar/${f.fatura_id}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ color: '#1565C0' }}
                                                                >
                                                                    {f.etiket}
                                                                </a>
                                                                {`: ${tl(f.tutar)} `}
                                                                <span style={{ color: f.resmilesti ? '#28a745' : '#b8860b' }}>
                                                                    ({f.resmilesti ? 'Resmi' : 'Taslak'})
                                                                </span>
                                                            </div>
                                                        ))}
                                                        {u.notlar.map(n => (
                                                            <div key={n} style={{ color: '#d9534f', fontSize: '11px' }}>{n}</div>
                                                        ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {faturaKontrol.hatalar.length > 0 && (
                                <div style={{
                                    border: '1px solid #E0E0E0',
                                    borderRadius: '4px',
                                    backgroundColor: 'white',
                                    marginBottom: '20px',
                                    padding: '8px 10px',
                                    fontSize: '12px'
                                }}>
                                    <div style={{ fontWeight: '600', color: '#e67e22', marginBottom: '4px' }}>Kontrol edilemeyen siparişler</div>
                                    {faturaKontrol.hatalar.map(h => (
                                        <div key={h.siparis_id} style={{ color: '#555' }}>
                                            #{h.siparis_no} {h.ad_soyad}: <span style={{ color: '#999' }}>{h.hata}</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <button
                                    onClick={handleFaturaKontrol}
                                    disabled={yukleniyor}
                                    style={{ ...modalButonStili, opacity: yukleniyor ? 0.5 : 1, cursor: yukleniyor ? 'wait' : 'pointer' }}
                                >
                                    Yeniden Kontrol Et
                                </button>
                                <button
                                    onClick={handleFaturaKontrolPdfIndir}
                                    disabled={yukleniyor || faturaKontrolPdfLoading}
                                    title={yukleniyor ? 'Kontrol tamamlanınca indirilebilir' : 'Sonucu PDF olarak indir'}
                                    style={{
                                        ...modalButonStili,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        opacity: yukleniyor || faturaKontrolPdfLoading ? 0.5 : 1,
                                        cursor: yukleniyor ? 'not-allowed' : faturaKontrolPdfLoading ? 'wait' : 'pointer'
                                    }}
                                >
                                    <img src={DownloadIcon} alt="İndir" style={{ height: '13px' }} />
                                    {faturaKontrolPdfLoading ? 'Oluşturuluyor...' : 'İndir'}
                                </button>
                                <button onClick={() => setFaturaKontrolModalAcik(false)} style={modalButonStili}>
                                    Kapat
                                </button>
                            </div>
                        </div>

                        {/* PDF'e dönüştürülecek şablon (ekran dışında) */}
                        <div style={{ position: 'fixed', left: '-10000px', top: 0 }}>
                            <div ref={faturaKontrolRef} style={{
                                width: '1000px',
                                padding: '10px',
                                backgroundColor: '#ffffff',
                                color: '#000',
                                fontFamily: 'Arial, Helvetica, sans-serif',
                                boxSizing: 'border-box'
                            }}>
                                <div data-pdf-blok style={{ fontSize: '26px', fontWeight: 'bold', marginBottom: '6px' }}>
                                    Fatura Kontrolü - {teslimTarihMetni}
                                </div>
                                <div data-pdf-blok style={{ fontSize: '16px', marginBottom: '14px' }}>
                                    Kontrol Edilen: <b>{faturaKontrol.kontrolEdilen}</b>
                                    {'   '}·{'   '}Uyumsuz: <b>{faturaKontrol.uyumsuzlar.length}</b>
                                    {faturaKontrol.hatalar.length > 0 && <>{'   '}·{'   '}Kontrol Edilemeyen: <b>{faturaKontrol.hatalar.length}</b></>}
                                </div>
                                {faturaKontrol.uyumsuzlar.length === 0 ? (
                                    <div data-pdf-blok style={{ fontSize: '16px', border: '1px solid #000', padding: '10px', textAlign: 'center' }}>
                                        Tüm proformalar Paraşüt faturalarıyla uyumlu.
                                    </div>
                                ) : (
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '15px' }}>
                                        <thead>
                                            <tr>
                                                {['Sipariş', 'Proforma', 'Fatura', 'Fark', 'Faturalar / Not'].map((baslik, i) => (
                                                    <th key={baslik} style={{ border: '1px solid #000', padding: '6px 8px', backgroundColor: '#eee', textAlign: i > 0 && i < 4 ? 'right' : 'left' }}>
                                                        {baslik}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {faturaKontrol.uyumsuzlar.map(u => (
                                                <tr key={u.siparis_id}>
                                                    <td style={{ border: '1px solid #000', padding: '6px 8px', verticalAlign: 'top' }}>
                                                        <b>{telefonSon4Al(u.telefon_numarasi)}</b> - {u.ad_soyad}
                                                        <div style={{ fontSize: '12px', color: '#555' }}>#{u.siparis_no}</div>
                                                    </td>
                                                    <td style={{ border: '1px solid #000', padding: '6px 8px', textAlign: 'right', verticalAlign: 'top', whiteSpace: 'nowrap' }}>{tl(u.proforma_toplam)}</td>
                                                    <td style={{ border: '1px solid #000', padding: '6px 8px', textAlign: 'right', verticalAlign: 'top', whiteSpace: 'nowrap' }}>{u.faturalar.length ? tl(u.fatura_toplam) : '—'}</td>
                                                    <td style={{ border: '1px solid #000', padding: '6px 8px', textAlign: 'right', verticalAlign: 'top', whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                                                        {u.faturalar.length ? `${u.fark > 0 ? '+' : ''}${tl(u.fark)}` : '—'}
                                                    </td>
                                                    <td style={{ border: '1px solid #000', padding: '6px 8px', verticalAlign: 'top' }}>
                                                        {u.faturalar.map(f => (
                                                            <div key={f.fatura_id}>{f.etiket}: {tl(f.tutar)} ({f.resmilesti ? 'Resmi' : 'Taslak'})</div>
                                                        ))}
                                                        {u.notlar.map(n => (
                                                            <div key={n} style={{ fontSize: '13px' }}>{n}</div>
                                                        ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                                {faturaKontrol.hatalar.length > 0 && (
                                    <div style={{ marginTop: '16px', fontSize: '14px' }}>
                                        <div data-pdf-blok style={{ fontWeight: 'bold', marginBottom: '4px' }}>Kontrol edilemeyen siparişler</div>
                                        {faturaKontrol.hatalar.map(h => (
                                            <div data-pdf-blok key={h.siparis_id}>#{h.siparis_no} {h.ad_soyad}: {h.hata}</div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })()}
        </div>
    );
}

export default SiparisListesi;
